<template>
  <div id="box" class="secondhand-product-page">
    <div class="secondhand-list-head">
    <!-- 顶部起始位置 -->
    <div class="historyTag">
      <historyTag :historyArr="historyArr"></historyTag>
    </div>
    <div class="search-toolbar">
      <el-form
        :inline="true"
        size="small"
        class="search-form search-form--filters"
        @submit.native.prevent="searchFn"
      >
        <el-form-item label="商品编号">
          <el-input
            v-model="query.productNo"
            placeholder="商品编号"
            clearable
            class="search-form__input--sm"
            @keyup.enter.native="searchFn"
          />
        </el-form-item>

        <el-form-item v-if="isOfficialConsignList" label="寄售订单号">
          <el-input
            v-model="query.consignOrderNo"
            placeholder="order_id"
            clearable
            class="search-form__input--md"
            @keyup.enter.native="searchFn"
          />
        </el-form-item>

        <el-form-item v-if="isOfficialConsignList" label="鉴别号">
          <el-input
            v-model="query.inspectionSeq"
            placeholder="鉴别号"
            clearable
            class="search-form__input--md"
            @keyup.enter.native="searchFn"
          />
        </el-form-item>

        <el-form-item v-if="!isOfficialConsignList" label="标题">
          <el-input
            v-model="query.title"
            placeholder="标题关键字"
            clearable
            class="search-form__input--md"
            @keyup.enter.native="searchFn"
          />
        </el-form-item>

        <el-form-item :label="isOfficialConsignList ? '寄售用户' : '卖家'">
          <el-input
            v-model="query.sellerNickName"
            :placeholder="isOfficialConsignList ? '昵称/会员号/姓名' : '卖家昵称'"
            clearable
            class="search-form__input--md"
            @keyup.enter.native="searchFn"
          />
        </el-form-item>

        <el-form-item v-if="isOfficialConsignList" label="闲鱼id">
          <el-input
            v-model="query.xianyuItemId"
            placeholder="闲鱼商品id"
            clearable
            class="search-form__input--md"
            @keyup.enter.native="searchFn"
          />
        </el-form-item>

        <el-form-item v-if="!isOfficialConsignList && activeMainTab === 'all'" label="状态">
          <el-select v-model="query.status" placeholder="全部" clearable class="search-form__input--status" @change="searchFn">
            <el-option v-for="item in statusOptions" :key="String(item.value)" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>

        <template v-if="isOfficialConsignList && queryExpanded">
          <el-form-item label="标题">
            <el-input
              v-model="query.title"
              placeholder="标题关键字"
              clearable
              class="search-form__input--md"
              @keyup.enter.native="searchFn"
            />
          </el-form-item>

          <el-form-item v-if="activeMainTab === 'all'" label="状态">
            <el-select
              v-model="query.consignStage"
              placeholder="全部"
              clearable
              class="search-form__input--stage"
              @change="searchFn"
            >
              <el-option v-for="item in consignStageOptions" :key="String(item.value)" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>

          <el-form-item label="代号">
            <el-input
              v-model="query.importCode"
              placeholder="代号"
              clearable
              class="search-form__input--xs"
              @keyup.enter.native="searchFn"
            />
          </el-form-item>

          <el-form-item label="货架号">
            <el-input
              v-model="query.shelfNo"
              placeholder="货架号"
              clearable
              class="search-form__input--xs"
              @keyup.enter.native="searchFn"
            />
          </el-form-item>

          <el-form-item label="自动上架">
            <el-select
              v-model="query.autoList"
              placeholder="全部"
              clearable
              class="search-form__input--xs"
              @change="searchFn"
            >
              <el-option label="是" :value="1" />
              <el-option label="否" :value="0" />
            </el-select>
          </el-form-item>

          <el-form-item label="鉴别时间">
            <el-date-picker
              v-model="query.inspectionTimeRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              clearable
              class="search-form__input--range"
              @change="searchFn"
            />
          </el-form-item>

          <el-form-item label="关联">
            <el-select v-model="query.linkStatus" class="search-form__input--sm" @change="searchFn">
              <el-option label="全部" :value="0" />
              <el-option label="未关联" :value="1" />
              <el-option label="已关联" :value="2" />
            </el-select>
          </el-form-item>

          <el-form-item label="评级">
            <el-select v-model="query.gradeLevel" placeholder="全部" clearable class="search-form__input--grade" @change="searchFn">
              <el-option v-for="g in gradeLevelOptions" :key="g" :label="g + '级'" :value="g" />
            </el-select>
          </el-form-item>

          <el-form-item label="品牌">
            <el-input
              v-model="query.brandKeyword"
              placeholder="品牌名"
              clearable
              class="search-form__input--brand"
              @keyup.enter.native="searchFn"
            />
          </el-form-item>

          <el-form-item label="来源">
            <el-select v-model="query.xianyuOnly" class="search-form__input--source" @change="searchFn">
              <el-option label="全部" :value="0" />
              <el-option label="闲鱼导入" :value="1" />
            </el-select>
          </el-form-item>
        </template>
      </el-form>

      <div class="search-toolbar__footer">
        <div class="search-toolbar__footer-left">
          <el-button type="primary" size="small" @click="searchFn">搜索</el-button>
          <el-button size="small" @click="resetFn">重置</el-button>
          <el-button
            v-if="isOfficialConsignList"
            type="text"
            size="small"
            class="search-toolbar__expand-btn"
            @click="queryExpanded = !queryExpanded"
          >
            <i :class="queryExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
            {{ queryExpanded ? "收起筛选" : "更多筛选" }}
          </el-button>
        </div>

        <div class="search-toolbar__footer-right">
          <template v-if="isOfficialConsignList">
            <el-dropdown trigger="click" @command="handleToolbarImportCommand">
              <el-button size="small">
                导入/导出<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="consignLinkImport">Excel 关联寄售单</el-dropdown-item>
                <el-dropdown-item command="goofishAuctionImport">导入拍卖关联</el-dropdown-item>
                <el-dropdown-item command="downloadAuctionTemplate">下载拍卖模板</el-dropdown-item>
                <el-dropdown-item divided command="exportProduct">导出商品</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>

            <el-button
              v-if="!isAuctionTab"
              type="warning"
              size="small"
              :loading="batchPublishSubmitting"
              :disabled="!batchPublishSelectedCount"
              @click="openBatchPublishConfirm"
            >
              一键上架{{ batchPublishSelectedCount ? ` (${batchPublishSelectedCount})` : "" }}
            </el-button>

            <el-dropdown trigger="click" @command="handleToolbarBatchCommand">
              <el-button size="small" plain>
                更多<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <template v-if="!isAuctionTab">
                  <el-dropdown-item command="batchGoofishSync" :disabled="!batchGoofishSyncSelectedCount">
                    批量同步闲鱼{{ batchGoofishSyncSelectedCount ? ` (${batchGoofishSyncSelectedCount})` : "" }}
                  </el-dropdown-item>
                  <el-dropdown-item command="syncAllGoofish">全量同步闲鱼</el-dropdown-item>
                  <el-dropdown-item command="syncAllFreight">全量修复闲鱼运费</el-dropdown-item>
                  <el-dropdown-item command="cancelSchedule" :disabled="!cancelScheduleSelectedCount">
                    取消预约{{ cancelScheduleSelectedCount ? ` (${cancelScheduleSelectedCount})` : "" }}
                  </el-dropdown-item>
                  <el-dropdown-item divided command="syncEs" :disabled="!batchSyncEsSelectedCount">
                    同步 ES{{ batchSyncEsSelectedCount ? ` (${batchSyncEsSelectedCount})` : "" }}
                  </el-dropdown-item>
                </template>
                <el-dropdown-item v-else command="syncEs" :disabled="!batchSyncEsSelectedCount">
                  同步 ES{{ batchSyncEsSelectedCount ? ` (${batchSyncEsSelectedCount})` : "" }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>

          <el-dropdown v-else trigger="click" @command="handleToolbarBatchCommand">
            <el-button size="small" plain>
              更多<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="syncEs" :disabled="!batchSyncEsSelectedCount">
                同步 ES{{ batchSyncEsSelectedCount ? ` (${batchSyncEsSelectedCount})` : "" }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>

    <el-tabs
      v-if="showMainTabs"
      v-model="activeMainTab"
      type="card"
      class="secondhand-main-tabs"
      @tab-click="handleMainTabClick"
    >
      <template v-if="isOfficialConsignList">
        <el-tab-pane
          v-for="tab in officialConsignMainTabs"
          :key="tab.name"
          :label="tab.label"
          :name="tab.name"
        />
      </template>
      <template v-else>
        <el-tab-pane label="商品列表" name="all" />
        <el-tab-pane v-if="showManualAuditUi" label="人工审核" name="audit" />
      </template>
    </el-tabs>
    </div>

    <div class="secondhand-list-table-wrap" :class="{ 'secondhand-list-table-wrap--compact': isOfficialConsignList }">
    <el-table
      ref="productTable"
      :data="tableData"
      border
      style="width: 100%"
      v-loading="loading"
      :max-height="tableMaxHeight"
      :row-key="batchPublishRowKey"
      @selection-change="handleBatchPublishSelectionChange"
    >
      <el-table-column
        type="selection"
        width="48"
        align="center"
        reserve-selection
        :selectable="tableRowSelectable"
      />
      <el-table-column prop="productNo" label="商品编号" width="160" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.productNo || (isOfficialConsignOrderRow(scope.row) ? "-" : "") }}</span>
        </template>
      </el-table-column>
      <el-table-column label="图片" width="110" align="center">
        <template slot-scope="scope">
          <img
            v-if="listRowDisplayImage(scope.row)"
            :src="listRowDisplayImage(scope.row)"
            class="list-row-thumb"
            :class="{ 'list-row-thumb--compact': isOfficialConsignList }"
            @click="previewFn(listRowDisplayImage(scope.row))"
          />
          <span v-else>无</span>
        </template>
      </el-table-column>

      <el-table-column prop="title" label="标题" :min-width="isOfficialConsignList ? 160 : 220" class-name="cell-title-wrap">
        <template slot-scope="scope">
          <span>{{ listRowDisplayTitle(scope.row) }}</span>
        </template>
      </el-table-column>
      <el-table-column v-if="!isOfficialConsignList" label="商品描述" min-width="200">
        <template slot-scope="scope">
          <el-tooltip
            effect="dark"
            placement="top"
            :content="scope.row.description || '-'"
            popper-class="secondhand-desc-tooltip"
          >
            <div class="desc-cell-ellipsis">{{ scope.row.description || "-" }}</div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column v-if="activeMainTab !== 'audit'" prop="status" label="状态" width="130" align="center">
          <template slot-scope="scope">
          <span :style="{ color: isOfficialConsignList ? officialConsignStageColor(scope.row) : statusColor(scope.row.status) }">
            {{ isOfficialConsignList ? officialConsignStageLabel(scope.row) : statusLabel(scope.row.status) }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        v-if="isOfficialConsignList && (activeMainTab === 'RECALL' || activeMainTab === 'all')"
        label="召回单号"
        width="150"
        align="center"
      >
        <template slot-scope="scope">
          <span v-if="Number(scope.row.status) === 9 || scope.row.consignStage === 'RECALL'">
            {{ scope.row.recallExpressNo || "-" }}
          </span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="售价(元)" :width="isOfficialConsignList ? 150 : 110" align="center">
        <template slot-scope="scope">
          <template v-if="shouldShowListRowPrice(scope.row)">
            <template v-if="isOfficialConsignList">
              <span>{{ formatMoney(scope.row.price) }}</span>
              <span v-if="resolveListingStrikePrice(scope.row)" class="consign-listing-strike">
                {{ formatMoney(resolveListingStrikePrice(scope.row)) }}
              </span>
            </template>
            <span v-else>{{ scope.row.price }}</span>
          </template>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column v-if="isOfficialConsignList" label="自动上架" width="88" align="center">
        <template slot-scope="scope">
          <el-tag v-if="isAutoListRow(scope.row)" size="mini" type="warning">是</el-tag>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column v-if="isOfficialConsignList" label="自动上架价(元)" width="118" align="center">
        <template slot-scope="scope">
          <span>{{ formatAutoListPrice(scope.row) }}</span>
        </template>
      </el-table-column>
      <el-table-column v-if="isOfficialConsignList" label="预约上架时间" width="160" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.scheduledPublishAt ? formatTime(scope.row.scheduledPublishAt) : "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column v-if="isOfficialConsignList" label="寄售用户" min-width="170" align="center" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ formatConsignorDisplay(scope.row) }}</span>
        </template>
      </el-table-column>
      <el-table-column v-if="isOfficialConsignList" label="货架号" width="80" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.sourceConsignShelfNo || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column v-if="isOfficialConsignList" label="鉴别号" width="120" align="center" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ resolveInspectionSeq(scope.row) || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column v-if="isOfficialConsignList" prop="importCode" label="代号" width="90" align="center">
        <template slot-scope="scope">
          <span>{{ resolveImportCode(scope.row) || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column v-if="isOfficialConsignList" label="闲鱼id" min-width="168" align="left">
        <template slot-scope="scope">
          <div v-if="resolveXianyuItemEntries(scope.row).length" class="xianyu-id-cell">
            <div
              v-for="(e, idx) in resolveXianyuItemEntries(scope.row)"
              :key="idx"
              class="xianyu-id-row"
            >
              <el-tooltip v-if="e.shop" effect="dark" placement="top" :content="e.shop">
                <span class="xianyu-id-shop">{{ e.shopShort }}</span>
              </el-tooltip>
              <span class="xianyu-id-value">{{ e.itemId }}</span>
            </div>
          </div>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column v-if="isOfficialConsignList" label="寄售订单号" min-width="150" align="center" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.sourceConsignOrderNo" style="color: #67c23a">{{ scope.row.sourceConsignOrderNo }}</span>
          <span v-else style="color: #f56c6c">未关联</span>
        </template>
      </el-table-column>
      <el-table-column v-else prop="sellerNickName" label="卖家(昵称)" width="140" align="center" />
      <el-table-column v-if="showManualAuditUi" label="机审不通过次数" width="140" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.status === 4">{{
              scope.row.sellerViolationCount != null ? scope.row.sellerViolationCount : "-"
            }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column v-if="showManualAuditUi" label="违规原因" min-width="260">
        <template slot-scope="scope">
          <template v-if="scope.row.status === 4">
            <el-tooltip
              effect="dark"
              placement="top"
              :content="scope.row.violationReason || '-'"
              popper-class="secondhand-desc-tooltip"
            >
              <div class="desc-cell-ellipsis">{{ scope.row.violationReason || "-" }}</div>
            </el-tooltip>
          </template>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column v-if="isOfficialConsignList" label="开始鉴别时间" width="150" align="center">
        <template slot-scope="scope">
          <span>{{ formatTime(scope.row.inspectionStartTime) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" :width="isOfficialConsignList ? 150 : 170" align="center">
        <template slot-scope="scope">
          <span>{{ formatTime(scope.row.createTime) }}</span>
        </template>
      </el-table-column>

      <el-table-column
        label="操作"
        :width="isOfficialConsignList ? 260 : 220"
        align="center"
        fixed="right"
        class-name="table-action-col"
      >
        <template slot-scope="scope">
          <div class="table-action-wrap">
            <el-button size="mini" @click="detailFn(scope.row)">详情</el-button>
            <el-button
              v-if="canShowConsignGradeEntry(scope.row)"
              size="mini"
              type="primary"
              @click="goConsignGrade(scope.row)"
            >
              评级
            </el-button>
            <el-button
              v-if="canShowConsignPublishEntry(scope.row)"
              size="mini"
              type="warning"
              @click="openConsignPublishDialog(scope.row)"
            >
              定价上架
            </el-button>
            <el-button
              v-if="canEditAutoListPrice(scope.row)"
              size="mini"
              type="warning"
              plain
              @click="openAutoListPriceDialog(scope.row)"
            >
              改预设价
            </el-button>
            <el-button
              v-if="canShowConsignEditEntry(scope.row)"
              size="mini"
              type="primary"
              plain
              @click="editFn(scope.row)"
            >
              编辑
            </el-button>
            <el-button
              v-if="isOfficialConsignList && canConsignorChangePrice(scope.row)"
              size="mini"
              type="primary"
              @click="openConsignPriceDialog(scope.row)"
            >
              改价
            </el-button>
            <el-button
              v-if="canShowGoofishSyncEntry(scope.row)"
              size="mini"
              class="btn-goofish-plain"
              @click="openGoofishSyncDialog(scope.row)"
            >
              同步闲鱼
            </el-button>
            <el-button
              v-if="canShowOfflineEntry(scope.row)"
              size="mini"
              type="danger"
              plain
              :loading="shelfActionId === scope.row.id"
              @click="offlineProductFn(scope.row)"
            >
              下架
            </el-button>
            <el-button
              v-if="canShowStartAuctionEntry(scope.row)"
              size="mini"
              type="warning"
              plain
              :loading="shelfActionId === scope.row.id"
              @click="startAuctionFn(scope.row)"
            >
              拍卖
            </el-button>
            <el-button
              v-if="canShowEndAuctionEntry(scope.row)"
              size="mini"
              type="success"
              plain
              :loading="shelfActionId === scope.row.id"
              @click="endAuctionFn(scope.row)"
            >
              上架
            </el-button>
            <el-button
              v-if="canShowNativeGoofishLinkEntry(scope.row)"
              size="mini"
              class="btn-goofish-plain"
              @click="openNativeGoofishLinkDialog(scope.row)"
            >
              {{ nativeGoofishLinkEntryLabel(scope.row) }}
            </el-button>
            <el-button
              v-if="canShowGoofishSoldEntry(scope.row)"
              size="mini"
              class="btn-goofish-plain"
              :loading="shelfActionId === scope.row.id"
              @click="openGoofishSoldDialog(scope.row)"
            >
              {{ goofishSoldEntryLabel(scope.row) }}
            </el-button>
            <el-button
              v-if="canShowConsignRelistEntry(scope.row)"
              size="mini"
              type="success"
              plain
              :loading="shelfActionId === scope.row.id"
              @click="onlineProductFn(scope.row)"
            >
              上架
            </el-button>
            <el-button
              v-else-if="!isOfficialConsignList && scope.row.status === 0"
              size="mini"
              type="success"
              plain
              :loading="shelfActionId === scope.row.id"
              @click="onlineProductFn(scope.row)"
            >
              上架
            </el-button>
            <el-button
              v-if="isOfficialConsignList && !isOfficialConsignOrderRow(scope.row) && !scope.row.sourceConsignOrderNo"
              size="mini"
              type="warning"
              plain
              @click="openConsignLinkDialog(scope.row)"
            >
              关联寄售单
            </el-button>
            <el-button
              v-if="canShowConsignDeleteEntry(scope.row)"
              size="mini"
              type="danger"
              plain
              :loading="deleteActionId === scope.row.id"
              @click="deleteProductFn(scope.row)"
            >
              删除
            </el-button>
            <el-button
              v-if="showManualAuditUi && scope.row.status === 4"
              size="mini"
              type="warning"
              plain
              @click="openAuditDialog(scope.row)"
            >
              审核
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    </div>

    <div class="page_box">
      <list-pagination
        :sticky="false"
        :total="tableTotal"
        :current-page.sync="currentPage"
        :page-size.sync="pageSize"
        @page-change="changePage"
        @size-change="handlePageSizeChange"
      />
    </div>

    <el-dialog
      title="批量同步至闲鱼"
      :visible.sync="batchGoofishSyncVisible"
      width="500px"
      custom-class="goofish-sync-dialog"
      append-to-body
    >
      <div class="goofish-sync-dialog__body">
        <div class="goofish-sync-dialog__meta">
          已选 <strong>{{ batchGoofishSyncSelectedCount }}</strong> 个在售商品 · 各店独立 listing，互不覆盖
        </div>
        <el-form label-position="top" size="small" class="goofish-sync-dialog__form">
          <el-form-item label="目标店铺" required>
            <el-checkbox-group v-model="goofishSyncAccountIds" class="goofish-sync-dialog__shops">
              <el-checkbox
                v-for="a in goofishAccountOptions"
                :key="a.id"
                :label="a.id"
                class="goofish-sync-dialog__shop"
              >
                <span class="goofish-sync-dialog__shop-name">{{ a.name || "未命名店铺" }}</span>
                <span v-if="a.userName" class="goofish-sync-dialog__shop-user">{{ a.userName }}</span>
              </el-checkbox>
            </el-checkbox-group>
            <div v-if="!goofishAccountOptions.length" class="goofish-sync-dialog__empty">暂无启用中的闲鱼店铺</div>
          </el-form-item>
          <el-form-item label="同步方式">
            <el-radio-group v-model="goofishSyncMode" class="goofish-sync-dialog__modes">
              <el-radio label="schedule">延迟同步（约 30 分钟，推荐）</el-radio>
              <el-radio label="now">立即上架</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button @click="batchGoofishSyncVisible = false">取消</el-button>
        <el-button class="btn-goofish" :loading="batchGoofishSyncSubmitting" @click="submitBatchGoofishSync">确认</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="全量同步在售至闲鱼"
      :visible.sync="syncAllGoofishVisible"
      width="500px"
      custom-class="goofish-sync-dialog"
      append-to-body
    >
      <div class="goofish-sync-dialog__body">
        <div class="goofish-sync-dialog__meta">
          扫描在售官方寄售，后台异步同步 · 单次最多
          <strong>{{ syncAllGoofishLimit }}</strong> 条 · 进度见「闲鱼商品同步列表」
        </div>
        <el-form label-position="top" size="small" class="goofish-sync-dialog__form">
          <el-form-item label="目标店铺" required>
            <el-checkbox-group v-model="goofishSyncAccountIds" class="goofish-sync-dialog__shops">
              <el-checkbox
                v-for="a in goofishAccountOptions"
                :key="a.id"
                :label="a.id"
                class="goofish-sync-dialog__shop"
              >
                <span class="goofish-sync-dialog__shop-name">{{ a.name || "未命名店铺" }}</span>
                <span v-if="a.userName" class="goofish-sync-dialog__shop-user">{{ a.userName }}</span>
              </el-checkbox>
            </el-checkbox-group>
            <div v-if="!goofishAccountOptions.length" class="goofish-sync-dialog__empty">暂无启用中的闲鱼店铺</div>
          </el-form-item>
          <el-form-item label="同步方式">
            <el-radio-group v-model="goofishSyncMode" class="goofish-sync-dialog__modes">
              <el-radio label="schedule">延迟同步（约 30 分钟，推荐）</el-radio>
              <el-radio label="now">立即上架</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="扫描上限">
            <el-input-number v-model="syncAllGoofishLimit" :min="1" :max="5000" :step="100" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button @click="syncAllGoofishVisible = false">取消</el-button>
        <el-button class="btn-goofish" :loading="syncAllGoofishSubmitting" @click="submitSyncAllGoofish">确认全量同步</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="全量修复闲鱼运费"
      :visible.sync="syncAllFreightVisible"
      width="500px"
      custom-class="goofish-sync-dialog"
      append-to-body
    >
      <div class="goofish-sync-dialog__body">
        <div class="goofish-sync-dialog__meta">
          仅扫描已上架同步记录，通过 edit 传 express_way=3 + express_fee 修复运费（保留原 itemId）· 单次最多
          <strong>{{ syncAllFreightLimit }}</strong> 条 · 进度见「闲鱼商品同步列表」
        </div>
        <el-form label-position="top" size="small" class="goofish-sync-dialog__form">
          <el-form-item label="目标店铺" required>
            <el-checkbox-group v-model="goofishSyncAccountIds" class="goofish-sync-dialog__shops">
              <el-checkbox
                v-for="a in goofishAccountOptions"
                :key="a.id"
                :label="a.id"
                class="goofish-sync-dialog__shop"
              >
                <span class="goofish-sync-dialog__shop-name">{{ a.name || "未命名店铺" }}</span>
                <span v-if="a.userName" class="goofish-sync-dialog__shop-user">{{ a.userName }}</span>
              </el-checkbox>
            </el-checkbox-group>
            <div v-if="!goofishAccountOptions.length" class="goofish-sync-dialog__empty">暂无启用中的闲鱼店铺</div>
          </el-form-item>
          <el-form-item label="扫描上限">
            <el-input-number v-model="syncAllFreightLimit" :min="1" :max="5000" :step="100" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button @click="syncAllFreightVisible = false">取消</el-button>
        <el-button class="btn-goofish" :loading="syncAllFreightSubmitting" @click="submitSyncAllFreight">确认修复运费</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="同步至闲鱼"
      :visible.sync="goofishSyncVisible"
      width="500px"
      custom-class="goofish-sync-dialog"
      append-to-body
    >
      <div v-if="goofishSyncRow" class="goofish-sync-dialog__body">
        <div class="goofish-sync-dialog__meta">
          <div class="goofish-sync-dialog__meta-title">{{ goofishSyncRow.title || "—" }}</div>
          <div class="goofish-sync-dialog__meta-sub">商品 ID {{ goofishSyncRow.id }} · 各店独立 listing</div>
        </div>
        <el-form label-position="top" size="small" class="goofish-sync-dialog__form">
          <el-form-item label="目标店铺" required>
            <el-checkbox-group v-model="goofishSyncAccountIds" class="goofish-sync-dialog__shops">
              <el-checkbox
                v-for="a in goofishAccountOptions"
                :key="a.id"
                :label="a.id"
                class="goofish-sync-dialog__shop"
              >
                <span class="goofish-sync-dialog__shop-name">{{ a.name || "未命名店铺" }}</span>
                <span v-if="a.userName" class="goofish-sync-dialog__shop-user">{{ a.userName }}</span>
              </el-checkbox>
            </el-checkbox-group>
            <div v-if="!goofishAccountOptions.length" class="goofish-sync-dialog__empty">暂无启用中的闲鱼店铺</div>
          </el-form-item>
          <el-form-item label="同步方式">
            <el-radio-group v-model="goofishSyncMode" class="goofish-sync-dialog__modes">
              <el-radio label="schedule">延迟同步（约 30 分钟，推荐）</el-radio>
              <el-radio label="now">立即上架</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button @click="goofishSyncVisible = false">取消</el-button>
        <el-button class="btn-goofish" :loading="goofishSyncLoading" @click="submitGoofishSync">确认</el-button>
      </span>
    </el-dialog>

    <!-- 详情弹窗：分区标题 + 每区三列网格，主体可滚动 -->
    <el-dialog title="商品详情" :visible.sync="detailVisible" width="980px" custom-class="secondhand-detail-dialog">
      <div v-loading="detailLoading" v-if="detail" class="detail-dialog-body">
        <section class="detail-section">
          <h4 class="detail-section__title">基础信息</h4>
          <div class="detail-field-box">
            <div class="detail-field-cell">
              <div class="detail-field-label">商品编号</div>
              <div class="detail-field-value">{{ detail.productNo }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">标题</div>
              <div class="detail-field-value">{{ detail.title }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">分类</div>
              <div class="detail-field-value">{{ detail.categoryName || "-" }}</div>
            </div>
            <div class="detail-field-cell detail-field-cell--full">
              <div class="detail-field-label">描述</div>
              <div class="detail-field-value detail-field-value--multiline">{{ detail.description || "-" }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">品牌</div>
              <div class="detail-field-value">{{ detail.brandName || "-" }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">香型</div>
              <div class="detail-field-value">{{ detail.typeName || "-" }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">成色</div>
              <div class="detail-field-value">{{ conditionLabel(detail.conditionLevel) }}</div>
            </div>
          </div>
        </section>

        <section class="detail-section">
          <div class="detail-section__head">
            <h4 class="detail-section__title">商品图片</h4>
            <image-batch-download-btn
              :urls="productDetailDisplayImages"
              :name-base="productDetailImagesDownloadNameBase"
              label="商品图片"
            />
          </div>
          <div v-if="productDetailDisplayImages.length" class="detail-dialog-images">
            <img
              v-for="(url, idx) in productDetailDisplayImages"
              :key="idx"
              :src="url"
              alt=""
              @click="previewFn(url)"
            />
          </div>
          <span v-else class="detail-dialog-images-empty">无</span>
        </section>

        <section class="detail-section">
          <h4 class="detail-section__title">扩展属性</h4>
          <div class="detail-field-box detail-field-box--cols2">
            <div class="detail-field-cell">
              <div class="detail-field-label">购买渠道</div>
              <div class="detail-field-value">{{ labelInList(detailAttrExtra.purchaseChannel, purchaseChannelList) }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">保质期</div>
              <div class="detail-field-value">{{ labelInList(detailAttrExtra.shelfLife, shelfLifeList) }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">容量规格</div>
              <div class="detail-field-value">{{ formatCapacityMl(detailAttrExtra.capacityMl) }}</div>
            </div>
          </div>
        </section>

        <section class="detail-section">
          <h4 class="detail-section__title">卖家与价格</h4>
          <div class="detail-field-box">
            <div class="detail-field-cell">
              <div class="detail-field-label">卖家</div>
              <div class="detail-field-value">
                <div class="detail-seller-row">
                  <img
                    v-if="detail.sellerPhoto"
                    class="detail-seller-avatar"
                    :src="detail.sellerPhoto"
                    alt=""
                    @click="previewFn(detail.sellerPhoto)"
                  />
                  <span>{{ detail.sellerNickName || "-" }}</span>
                  <span v-if="detail.sellerUserId != null" class="detail-seller-uid">（用户ID：{{ detail.sellerUserId }}）</span>
                </div>
              </div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">原价(元)</div>
              <div class="detail-field-value">{{ formatMoney(detail.originalPrice) }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">售价(元)</div>
              <div class="detail-field-value">
                {{ formatMoney(detail.price) }}
                <span
                  v-if="isOfficialConsignList && resolveListingStrikePrice(detail)"
                  class="consign-listing-strike"
                >{{ formatMoney(resolveListingStrikePrice(detail)) }}</span>
              </div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">库存数量</div>
              <div class="detail-field-value">{{ detail.quantity != null ? detail.quantity : "-" }}</div>
            </div>
            <template v-if="isOfficialConsignList">
              <div class="detail-field-cell">
                <div class="detail-field-label">列表阶段</div>
                <div class="detail-field-value">{{ officialConsignStageLabel(detail) }}</div>
              </div>
              <div class="detail-field-cell">
                <div class="detail-field-label">评级</div>
                <div class="detail-field-value">{{ detail.gradeLevel || "-" }}</div>
              </div>
              <div class="detail-field-cell">
                <div class="detail-field-label">代号</div>
                <div class="detail-field-value">{{ resolveImportCode(detail) || "-" }}</div>
              </div>
              <div class="detail-field-cell">
                <div class="detail-field-label">闲鱼id</div>
                <div class="detail-field-value">
                  <div v-if="resolveXianyuItemEntries(detail).length" class="xianyu-id-cell">
                    <div
                      v-for="(e, idx) in resolveXianyuItemEntries(detail)"
                      :key="idx"
                      class="xianyu-id-row"
                    >
                      <span v-if="e.shop" class="xianyu-id-shop">{{ e.shop }}</span>
                      <span class="xianyu-id-value">{{ e.itemId }}</span>
                    </div>
                  </div>
                  <span v-else>-</span>
                </div>
              </div>
              <div class="detail-field-cell">
                <div class="detail-field-label">寄售订单号</div>
                <div class="detail-field-value">
                  <span v-if="detail.sourceConsignOrderNo" style="color: #67c23a">{{ detail.sourceConsignOrderNo }}</span>
                  <span v-else style="color: #f56c6c">未关联</span>
                </div>
              </div>
              <div class="detail-field-cell">
                <div class="detail-field-label">货架号</div>
                <div class="detail-field-value">{{ detail.sourceConsignShelfNo || "-" }}</div>
              </div>
              <div class="detail-field-cell detail-field-cell--span2">
                <div class="detail-field-label">寄售用户</div>
                <div class="detail-field-value">{{ formatConsignorDisplay(detail) }}</div>
              </div>
            </template>
            <div class="detail-field-cell detail-field-cell--span2">
              <div class="detail-field-label">可选数量</div>
              <div class="detail-field-value">{{ yesNoLabel(detail.allowQuantitySelect) }}</div>
            </div>
          </div>
        </section>

        <section class="detail-section">
          <h4 class="detail-section__title">物流与交易</h4>
          <div class="detail-field-box">
            <div class="detail-field-cell">
              <div class="detail-field-label">配送方式</div>
              <div class="detail-field-value">{{ labelInList(detail.deliveryType, deliveryTypeList) }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">运费(元)</div>
              <div class="detail-field-value">{{ formatMoney(detail.freight) }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">所在地</div>
              <div class="detail-field-value">{{ detail.location || "-" }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">允许砍价</div>
              <div class="detail-field-value">{{ yesNoLabel(detail.allowBargain) }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">最低砍价(元)</div>
              <div class="detail-field-value">{{ formatMoney(detail.minBargainPrice) }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">支持验货</div>
              <div class="detail-field-value">{{ yesNoLabel(detail.allowInspection) }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">验货费(元)</div>
              <div class="detail-field-value">{{ formatMoney(detail.inspectionFee) }}</div>
            </div>
          </div>
        </section>

        <section class="detail-section">
          <h4 class="detail-section__title">数据与状态</h4>
          <div class="detail-field-box">
            <div class="detail-field-cell">
              <div class="detail-field-label">浏览 / 点赞</div>
              <div class="detail-field-value">
                {{ detail.viewCount != null ? detail.viewCount : "-" }} / {{ detail.likeCount != null ? detail.likeCount : "-" }}
              </div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">创建时间</div>
              <div class="detail-field-value">{{ formatTime(detail.createTime) }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">更新时间</div>
              <div class="detail-field-value">{{ formatTime(detail.updateTime) }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">状态</div>
              <div class="detail-field-value" :style="{ color: statusColor(detail.status) }">
                {{ statusLabel(detail.status) }}
              </div>
            </div>
            <div v-if="Number(detail.status) === 9" class="detail-field-cell">
              <div class="detail-field-label">召回单号</div>
              <div class="detail-field-value">{{ detail.recallExpressNo || "-" }}</div>
            </div>
            <div class="detail-field-cell detail-field-cell--span2">
              <div class="detail-field-label">机审不通过次数</div>
              <div class="detail-field-value">{{ detail.sellerViolationCount }}</div>
            </div>
          </div>
        </section>

        <section class="detail-section detail-section--last">
          <h4 class="detail-section__title">审核与违规</h4>
          <div class="detail-field-box detail-field-box--cols2">
            <div class="detail-field-cell">
              <div class="detail-field-label">违规原因</div>
              <div class="detail-field-value detail-field-value--tooltip">
                <el-tooltip
                  effect="dark"
                  placement="top"
                  :content="detailTooltipContent(detail.violationReason)"
                  :disabled="detailTooltipDisabled(detail.violationReason)"
                  popper-class="secondhand-desc-tooltip"
                >
                  <div class="detail-field-ellipsis">{{ detail.violationReason || "-" }}</div>
                </el-tooltip>
              </div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">审核人</div>
              <div class="detail-field-value detail-field-value--tooltip">
                <el-tooltip
                  effect="dark"
                  placement="top"
                  :content="detailTooltipContent(detail.auditBy)"
                  :disabled="detailTooltipDisabled(detail.auditBy)"
                  popper-class="secondhand-desc-tooltip"
                >
                  <div class="detail-field-ellipsis">{{ detail.auditBy || "-" }}</div>
                </el-tooltip>
              </div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">审核时间</div>
              <div class="detail-field-value detail-field-value--tooltip">
                <el-tooltip
                  effect="dark"
                  placement="top"
                  :content="formatTime(detail.auditTime)"
                  :disabled="!detail.auditTime"
                  popper-class="secondhand-desc-tooltip"
                >
                  <div class="detail-field-ellipsis">{{ formatTime(detail.auditTime) }}</div>
                </el-tooltip>
              </div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">审核备注</div>
              <div class="detail-field-value detail-field-value--tooltip">
                <el-tooltip
                  effect="dark"
                  placement="top"
                  :content="detailTooltipContent(detail.auditRemark)"
                  :disabled="detailTooltipDisabled(detail.auditRemark)"
                  popper-class="secondhand-desc-tooltip"
                >
                  <div class="detail-field-ellipsis">{{ detail.auditRemark || "-" }}</div>
                </el-tooltip>
              </div>
            </div>
          </div>
        </section>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="detailVisible = false">关闭</el-button>
      </span>
    </el-dialog>

    <!-- 寄售子单详情（待评级/待上架等尚未生成商品 id 的行） -->
    <el-dialog
      title="寄售单详情"
      :visible.sync="consignOrderDetailVisible"
      width="920px"
      custom-class="secondhand-detail-dialog"
      @closed="onConsignOrderDetailClosed"
    >
      <div v-loading="consignOrderDetailLoading">
        <div v-if="consignOrderDetail" class="detail-dialog-body">
          <section class="detail-section">
            <h4 class="detail-section__title">寄售单信息</h4>
            <div class="detail-field-box">
              <div class="detail-field-cell">
                <div class="detail-field-label">寄售订单号</div>
                <div class="detail-field-value">
                  {{ consignOrderDetailOrderNo || "-" }}
                </div>
              </div>
              <div class="detail-field-cell">
                <div class="detail-field-label">列表阶段</div>
                <div class="detail-field-value">
                  {{ consignOrderDetailRow ? officialConsignStageLabel(consignOrderDetailRow) : "-" }}
                </div>
              </div>
              <div class="detail-field-cell">
                <div class="detail-field-label">开始鉴别时间</div>
                <div class="detail-field-value">
                  {{ consignOrderDetailRow ? formatTime(consignOrderDetailRow.inspectionStartTime) : "-" }}
                </div>
              </div>
              <div class="detail-field-cell">
                <div class="detail-field-label">品牌</div>
                <div class="detail-field-value">{{ consignOrderDetailBrandName || "-" }}</div>
              </div>
              <div class="detail-field-cell">
                <div class="detail-field-label">香型</div>
                <div class="detail-field-value">{{ consignOrderDetailTypeName || "-" }}</div>
              </div>
              <div class="detail-field-cell">
                <div class="detail-field-label">寄售价格(元)</div>
                <div class="detail-field-value">{{ formatMoney(consignOrderDetailJsPrice) }}</div>
              </div>
              <div class="detail-field-cell">
                <div class="detail-field-label">评级</div>
                <div class="detail-field-value">{{ consignOrderDetail.gradeLevel || "-" }}</div>
              </div>
              <div class="detail-field-cell">
                <div class="detail-field-label">综合分</div>
                <div class="detail-field-value">
                  {{ consignOrderDetail.compositeScore != null ? consignOrderDetail.compositeScore : "-" }}
                </div>
              </div>
              <div class="detail-field-cell">
                <div class="detail-field-label">规格</div>
                <div class="detail-field-value">{{ consignOrderDetailSpecDisplay || "-" }}</div>
              </div>
              <div class="detail-field-cell detail-field-cell--span2">
                <div class="detail-field-label">寄售用户</div>
                <div class="detail-field-value">
                  {{ consignOrderDetailRow ? formatConsignorDisplay(consignOrderDetailRow) : "-" }}
                </div>
              </div>
              <div class="detail-field-cell detail-field-cell--full">
                <div class="detail-field-label">上架描述</div>
                <div class="detail-field-value detail-field-value--multiline">
                  {{ consignOrderDetailListingDescription || "-" }}
                </div>
              </div>
            </div>
          </section>

          <section v-if="consignOrderDetailDefectImages.length" class="detail-section">
            <div class="detail-section__head">
              <h4 class="detail-section__title">瑕疵图</h4>
              <image-batch-download-btn
                :urls="consignOrderDetailDefectImages"
                :name-base="consignOrderImagesDownloadNameBase('瑕疵')"
                label="瑕疵图"
              />
            </div>
            <div class="detail-dialog-images">
              <img
                v-for="(url, idx) in consignOrderDetailDefectImages"
                :key="'defect-' + idx"
                :src="url"
                alt=""
                @click="previewFn(url)"
              />
            </div>
          </section>

          <section v-if="consignOrderDetailRemainImages.length" class="detail-section">
            <div class="detail-section__head">
              <h4 class="detail-section__title">余量图</h4>
              <image-batch-download-btn
                :urls="consignOrderDetailRemainImages"
                :name-base="consignOrderImagesDownloadNameBase('余量')"
                label="余量图"
              />
            </div>
            <div class="detail-dialog-images">
              <img
                v-for="(url, idx) in consignOrderDetailRemainImages"
                :key="'remain-' + idx"
                :src="url"
                alt=""
                @click="previewFn(url)"
              />
            </div>
          </section>

          <section v-if="consignOrderDetailDetailImages.length" class="detail-section detail-section--last">
            <div class="detail-section__head">
              <h4 class="detail-section__title">商品图</h4>
              <image-batch-download-btn
                :urls="consignOrderDetailDetailImages"
                :name-base="consignOrderImagesDownloadNameBase('商品')"
                label="商品图"
              />
            </div>
            <div class="detail-dialog-images">
              <img
                v-for="(url, idx) in consignOrderDetailDetailImages"
                :key="'detail-' + idx"
                :src="url"
                alt=""
                @click="previewFn(url)"
              />
            </div>
          </section>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="consignOrderDetailVisible = false">关闭</el-button>
        <el-button
          v-if="consignOrderDetailRow && canShowConsignGradeEntry(consignOrderDetailRow)"
          type="primary"
          @click="goConsignGradeFromOrderDetail"
        >
          去评级
        </el-button>
        <el-button
          v-if="consignOrderDetailRow && canEditAutoListPrice(consignOrderDetailRow)"
          type="warning"
          plain
          @click="openAutoListPriceFromOrderDetail"
        >
          改预设价
        </el-button>
        <el-button
          v-if="consignOrderDetailRow && canShowConsignPublishEntry(consignOrderDetailRow)"
          type="warning"
          @click="openConsignPublishFromOrderDetail"
        >
          定价上架
        </el-button>
      </span>
    </el-dialog>

    <!-- 人工审核：通过 / 驳回 / 取消 -->
    <el-dialog
      title="人工审核"
      :visible.sync="auditDialogVisible"
      width="640px"
      custom-class="secondhand-audit-dialog"
      :close-on-click-modal="false"
      @closed="onAuditDialogClosed"
    >
      <div v-if="auditRow" class="audit-dialog-body">
        <p class="audit-dialog-line"><strong>商品编号</strong>：{{ auditRow.productNo }}</p>
        <p class="audit-dialog-line"><strong>标题</strong>：{{ auditRow.title || "-" }}</p>
        <div class="audit-dialog-block">
          <div class="audit-dialog-block__label">商品描述</div>
          <div class="audit-dialog-desc">{{ auditDescriptionDisplay(auditRow) }}</div>
        </div>
        <div class="audit-dialog-block">
          <div class="audit-dialog-block__label">商品图片</div>
          <div v-if="imageList(auditRow.images).length" class="audit-dialog-images">
            <img
              v-for="(url, idx) in imageList(auditRow.images)"
              :key="idx"
              :src="url"
              alt=""
              @click="previewFn(url)"
            />
          </div>
          <span v-else class="audit-dialog-empty">无</span>
        </div>
        <div class="audit-dialog-block">
          <div class="audit-dialog-block__label">违规原因</div>
          <div class="audit-dialog-violation">{{ auditRow.violationReason || "-" }}</div>
        </div>

        <div class="audit-dialog-remark">
          <div class="audit-dialog-remark__label">驳回原因（点击「驳回」时必填）</div>
          <el-input
            v-model="auditRejectRemark"
            type="textarea"
            :rows="4"
            placeholder="通过可不填；驳回时请填写原因"
          />
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="auditDialogVisible = false">取消</el-button>
        <el-button type="danger" :loading="auditSubmitLoading" @click="submitAuditReject">驳回</el-button>
        <el-button type="success" :loading="auditSubmitLoading" @click="submitAuditApprove">通过</el-button>
      </span>
    </el-dialog>

    <!-- 编辑弹窗 -->
    <el-dialog
      :title="isEditingOfficialConsignProduct ? '编辑官方寄售商品' : '编辑商品'"
      :visible.sync="editVisible"
      width="640px"
      custom-class="secondhand-edit-dialog"
      :close-on-click-modal="false"
      @closed="onEditDialogClosed"
    >
      <div v-loading="editLoading">
        <el-form
          v-if="editForm"
          ref="editFormRef"
          :model="editForm"
          :rules="editRules"
          label-width="108px"
          size="small"
        >
          <el-form-item label="商品图片">
            <div class="sh-img-upload">
              <div class="sh-img-upload__grid">
                <div v-for="(imgUrl, idx) in editImageUrls" :key="idx" class="sh-img-upload__thumb">
                  <img :src="imgUrl" alt="" @click="previewFn(imgUrl)" />
                  <span class="sh-img-upload__remove" title="删除" @click.stop="removeEditImage(idx)">
                    <i class="el-icon-close"></i>
                  </span>
                </div>
                <el-upload
                  v-if="editImageUrls.length < 9"
                  class="sh-img-upload__trigger"
                  :show-file-list="false"
                  :disabled="editImageUploading"
                  accept="image/jpeg,image/png,image/gif,image/webp"
                  :http-request="uploadEditImageRequest"
                >
                  <div
                    class="sh-img-upload__add"
                    :class="{ 'is-loading': editImageUploading }"
                  >
                    <i v-if="!editImageUploading" class="el-icon-plus sh-img-upload__add-icon"></i>
                    <i v-else class="el-icon-loading sh-img-upload__add-icon"></i>
                    <span class="sh-img-upload__add-text">{{
                        editImageUploading ? "上传中…" : "添加图片"
                      }}</span>
                  </div>
                </el-upload>
              </div>
              <p class="sh-img-upload__hint">支持 JPG / PNG / GIF / WebP，单张建议不超过 5MB，最多 9 张</p>
            </div>
          </el-form-item>
          <el-form-item label="标题" prop="title">
            <el-input v-model="editForm.title" maxlength="200" show-word-limit placeholder="商品标题" />
          </el-form-item>
          <el-form-item label="描述" prop="description">
            <el-input
              v-model="editForm.description"
              type="textarea"
              :rows="4"
              maxlength="400"
              show-word-limit
              placeholder="商品描述"
            />
          </el-form-item>

          <template v-if="isEditingOfficialConsignProduct">
            <el-divider content-position="left">官方寄售</el-divider>
            <el-form-item label="代号">
              <el-input v-model="editForm.importCode" clearable maxlength="64" placeholder="闲鱼导入代号" />
            </el-form-item>
            <el-form-item label="闲鱼id">
              <el-input v-model="editForm.xianyuItemId" clearable maxlength="64" placeholder="闲鱼商品 id" />
            </el-form-item>
            <el-form-item label="品牌">
              <el-input v-model="editForm.brandName" clearable maxlength="64" placeholder="品牌名称" />
            </el-form-item>
            <el-form-item label="香型">
              <el-input v-model="editForm.typeName" clearable maxlength="64" placeholder="型号/香型" />
            </el-form-item>
            <el-form-item label="寄售订单号">
              <span>{{ editRaw.sourceConsignOrderNo || "未关联" }}</span>
            </el-form-item>
            <el-form-item label="货架号">
              <span>{{ editRaw.sourceConsignShelfNo || "-" }}</span>
            </el-form-item>
          </template>

          <el-form-item label="状态" prop="status">
            <div class="edit-status-row">
              <el-select
                v-model="editForm.status"
                placeholder="请选择"
                style="width: 100%"
                :disabled="isEditStatusLockedByAuction"
              >
                <el-option
                  v-for="s in editStatusOptions"
                  :key="s.value"
                  :label="s.label"
                  :value="s.value"
                  :disabled="s.value === 8 && !isEditStatusLockedByAuction"
                />
              </el-select>
              <div class="edit-status-hint">
                <template v-if="isEditStatusLockedByAuction">
                  拍卖中不可在此切换状态，请关闭弹窗后在列表点击「上架」结束拍卖
                </template>
                <template v-else>「上架」即前台展示；「下架/召回」均不前台展示</template>
              </div>
            </div>
          </el-form-item>
          <el-form-item
            v-if="editForm && Number(editForm.status) === 9"
            label="召回单号"
            prop="recallExpressNo"
          >
            <el-input
              v-model="editForm.recallExpressNo"
              maxlength="64"
              clearable
              show-word-limit
              placeholder="请输入召回快递单号"
            />
          </el-form-item>
          <el-form-item v-if="isEditingOfficialConsignProduct" label="挂牌价(元)" prop="listingPrice">
            <el-input-number
              v-model="editForm.listingPrice"
              :min="0.01"
              :max="9999999.99"
              :precision="2"
              :step="1"
              controls-position="right"
              style="width: 100%"
            />
            <div v-if="editListingPromoActive" class="edit-bargain-hint">
              买家展示价约 {{ formatMoney(editListingBuyerPreview) }} 元
            </div>
          </el-form-item>
          <el-form-item v-else label="售价(元)" prop="price">
            <el-input-number
              v-model="editForm.price"
              :min="0.01"
              :max="9999999.99"
              :precision="2"
              :step="1"
              controls-position="right"
              style="width: 100%"
            />
          </el-form-item>
          <el-form-item v-if="!isOfficialConsignList" label="原价(元)" prop="originalPrice">
            <el-input-number v-model="editForm.originalPrice" :min="0" :precision="2" :step="1" controls-position="right" style="width: 100%" />
          </el-form-item>
          <el-form-item label="库存数量" prop="quantity">
            <el-input-number v-model="editForm.quantity" :min="1" :precision="0" :step="1" controls-position="right" style="width: 100%" />
          </el-form-item>
          <el-divider content-position="left">渠道/规格/成色等扩展</el-divider>
          <el-form-item label="成色" prop="conditionLevel">
            <el-select v-model="editForm.conditionLevel" placeholder="请选择" clearable style="width: 100%">
              <el-option v-for="c in conditionList" :key="c.value" :label="c.label" :value="c.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="购买渠道">
            <el-select v-model="editForm.purchaseChannel" placeholder="请选择" clearable style="width: 100%">
              <el-option v-for="p in purchaseChannelList" :key="p.value" :label="p.label" :value="p.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="保质期">
            <el-select v-model="editForm.shelfLife" placeholder="请选择" clearable style="width: 100%">
              <el-option v-for="s in shelfLifeList" :key="s.value" :label="s.label" :value="s.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="容量规格">
            <el-input
              v-model="editForm.capacityMl"
              placeholder="如 100（单位 ml，闲鱼导入商品请在此维护）"
              clearable
              style="width: 100%"
            />
          </el-form-item>
          <el-divider content-position="left">配送配置</el-divider>
          <el-form-item label="配送方式" prop="deliveryType">
            <el-select
              v-model="editForm.deliveryType"
              placeholder="请选择"
              style="width: 100%"
              @change="onEditDeliveryTypeChange"
            >
              <el-option v-for="d in deliveryTypeFormOptions" :key="d.value" :label="d.label" :value="d.value" />
            </el-select>
          </el-form-item>
          <template v-if="Number(editForm.deliveryType) === 1">
            <el-form-item label="快递运费">
              <el-radio-group v-model="editForm.expressFreightMode" @change="onEditExpressFreightModeChange">
                <el-radio label="free">包邮</el-radio>
                <el-radio label="custom">自定义邮费</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item v-if="editForm.expressFreightMode === 'custom'" label="邮费(元)" prop="freight">
              <el-input-number
                v-model="editForm.freight"
                :min="0.01"
                :precision="2"
                :step="1"
                controls-position="right"
                style="width: 100%"
              />
            </el-form-item>
          </template>
          <el-form-item label="所在地区">
            <el-cascader
              v-model="editForm.regionCodes"
              :options="regionCascaderOptions"
              :props="{ expandTrigger: 'hover' }"
              clearable
              filterable
              placeholder="请选择省 / 市 / 区"
              style="width: 100%"
              @change="onEditRegionChange"
            />
            <div
              v-if="editForm.location && (!editForm.regionCodes || !editForm.regionCodes.length)"
              class="official-publish-field-hint"
            >
              当前保存：{{ editForm.location }}（可重新选择以更新）
            </div>
          </el-form-item>

          <el-divider content-position="left">还价</el-divider>
          <el-form-item label="接受还价" prop="allowBargain">
            <el-select
              v-model="editForm.allowBargain"
              placeholder="请选择"
              style="width: 100%"
              @change="onEditAllowBargainChange"
            >
              <el-option label="否" :value="0" />
              <el-option label="是" :value="1" />
            </el-select>
          </el-form-item>
          <el-form-item v-show="editForm.allowBargain === 1" label="还价最低(元)" prop="minBargainPrice">
            <el-input-number
              v-model="editForm.minBargainPrice"
              :min="0.01"
              :precision="2"
              :step="1"
              controls-position="right"
              style="width: 100%"
            />
            <div class="edit-bargain-hint">须低于售价；接受还价时必填</div>
          </el-form-item>

          <template v-if="!isOfficialConsignList">
            <el-divider content-position="left">安心购</el-divider>
            <el-form-item label="支持安心购" prop="allowInspection">
              <el-select
                v-model="editForm.allowInspection"
                placeholder="请选择"
                style="width: 100%"
                @change="onEditAllowInspectionChange"
              >
                <el-option label="否" :value="0" />
                <el-option label="是" :value="1" />
              </el-select>
            </el-form-item>
            <el-form-item
              v-show="editForm.allowInspection === 1"
              label="安心购费用(元)"
              prop="inspectionFee"
            >
              <el-input-number
                v-model="editForm.inspectionFee"
                :min="0"
                :precision="2"
                :step="1"
                controls-position="right"
                style="width: 100%"
              />
              <div class="edit-bargain-hint">不填则使用系统默认费用</div>
            </el-form-item>
          </template>

        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editVisible = false">取消</el-button>
        <el-button type="primary" :loading="editSubmitLoading" @click="submitEditFn">保存</el-button>
      </span>
    </el-dialog>

    <!-- 官方寄售：关联寄售单 -->
    <el-dialog
      title="关联寄售单"
      :visible.sync="consignLinkVisible"
      width="860px"
      :close-on-click-modal="false"
      @closed="onConsignLinkDialogClosed"
    >
      <div v-if="consignLinkProduct" class="consign-link-product-tip">
        闲置商品 ID={{ consignLinkProduct.id }}，{{ consignLinkProduct.title }}
        <span v-if="consignLinkProduct.sourceConsignOrderNo">（已关联 {{ consignLinkProduct.sourceConsignOrderNo }}）</span>
        <div class="consign-link-filter-tip">
          货主：{{ formatConsignorDisplay(consignLinkProduct) }}；仅展示该货主已支付、待发货至出具报告流程内的寄售单
        </div>
      </div>
      <div class="flex" style="flex-wrap: wrap; align-items: center; margin: 12px 0">
        <el-input v-model="consignLinkSearch.orderId" placeholder="寄售订单号" clearable style="width: 200px; margin-right: 8px" />
        <el-checkbox v-model="consignLinkSearch.unlinkedOnly" :true-label="1" :false-label="0">仅未关联闲置</el-checkbox>
        <el-button type="primary" size="small" style="margin-left: 8px" @click="searchConsignOrdersFn">搜索</el-button>
      </div>
      <el-table
        :data="consignLinkOrderList"
        border
        size="small"
        v-loading="consignLinkOrderLoading"
        highlight-current-row
        @current-change="onConsignLinkOrderSelect"
      >
        <el-table-column prop="orderId" label="寄售订单号" min-width="180" show-overflow-tooltip />
        <el-table-column prop="scentId" label="货主会员号" width="120" align="center">
          <template slot-scope="scope">
            {{ scope.row.scentId || "-" }}
          </template>
        </el-table-column>
        <el-table-column prop="brandName" label="品牌" width="100">
          <template slot-scope="scope">
            {{ scope.row.brandName || "-" }}
          </template>
        </el-table-column>
        <el-table-column prop="typeName" label="型号" width="120">
          <template slot-scope="scope">
            {{ scope.row.typeName || "-" }}
          </template>
        </el-table-column>
        <el-table-column prop="jsPrice" label="寄售价" width="90" align="center" />
        <el-table-column label="已关联闲置" width="100" align="center">
          <template slot-scope="scope">
            {{ scope.row.secondhandProductId || "-" }}
          </template>
        </el-table-column>
      </el-table>
      <list-pagination
        small
        :sticky="false"
        :show-size-select="false"
        :total="consignLinkOrderTotal"
        :current-page.sync="consignLinkOrderPage"
        :page-size.sync="consignLinkOrderSize"
        @page-change="searchConsignOrdersFn"
      />
      <div style="margin-top: 12px">
        <span style="margin-right: 8px">或手动输入订单号：</span>
        <el-input v-model="consignLinkManualOrderNo" placeholder="寄售订单号" style="width: 220px" />
      </div>
      <span slot="footer">
        <el-button @click="consignLinkVisible = false">取消</el-button>
        <el-button type="primary" :loading="consignLinkSubmitting" @click="submitConsignLinkFn">确认关联</el-button>
      </span>
    </el-dialog>

    <consign-order-link-import-modal
      :visible="consignLinkImportVisible"
      @close="consignLinkImportVisible = false"
      @success="onConsignLinkImportSuccess"
    />

    <goofish-auction-import-modal
      :visible="goofishAuctionImportVisible"
      @close="goofishAuctionImportVisible = false"
      @success="onGoofishAuctionImportSuccess"
    />

    <!-- 官方寄售：定价上架（寄售子单 publish / 导入商品改价后上架） -->
    <el-dialog
      title="定价上架"
      :visible.sync="consignPublishVisible"
      width="500px"
      :close-on-click-modal="false"
      @closed="onConsignPublishDialogClosed"
    >
      <div v-if="consignPublishRow" class="consign-price-dialog">
        <div class="consign-price-product">{{ consignPublishRow.title || "-" }}</div>
        <div class="consign-price-meta">
          <span v-if="isOfficialConsignOrderRow(consignPublishRow)">
            寄售订单：{{ consignPublishRow.sourceConsignOrderNo || consignPublishRow.sourceXwOrderId || "-" }}
          </span>
          <span v-else>商品编号：{{ consignPublishRow.productNo || consignPublishRow.id || "-" }}</span>
        </div>
        <div v-if="consignPublishRow.gradeLevel" class="consign-price-meta">
          评级：{{ consignPublishRow.gradeLevel }}
        </div>
        <el-form label-width="108px" size="small" @submit.native.prevent="submitConsignPublishFn">
          <el-form-item label="上架售价">
            <el-input-number
              v-model="consignPublishForm.listingPrice"
              :min="0.01"
              :max="9999999.99"
              :precision="2"
              :step="1"
              controls-position="right"
              style="width: 100%"
            />
            <div v-if="consignPublishPromoActive" class="consign-price-hint">
              买家实付约 ¥{{ formatMoney(consignPublishPreviewBuyer) }}（按 {{ consignPublishDiscountLabel }} 折自动计算）
            </div>
            <div v-else class="consign-price-hint">买家实付与上架售价相同（当前未启用补贴或尚无挂牌价）</div>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button @click="consignPublishVisible = false">取消</el-button>
        <el-button type="primary" :loading="consignPublishSubmitting" @click="submitConsignPublishFn">确认上架</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :title="goofishSoldDialogTitle"
      :visible.sync="goofishAuctionSoldVisible"
      width="500px"
      :close-on-click-modal="false"
      @closed="onGoofishAuctionSoldDialogClosed"
    >
      <div v-if="goofishAuctionSoldRow">
        <div class="consign-price-product">{{ goofishAuctionSoldRow.title || "—" }}</div>
        <el-form label-width="108px" size="small" style="margin-top: 12px">
          <el-form-item label="闲鱼订单号">
            <el-input v-model.trim="goofishAuctionSoldForm.goofishOrderNo" placeholder="选填" />
          </el-form-item>
          <el-form-item label="成交金额">
            <el-input
              v-model.trim="goofishAuctionSoldForm.orderAmount"
              :placeholder="goofishSoldAmountPlaceholder"
            />
          </el-form-item>
          <el-form-item label="备注">
            <el-input v-model.trim="goofishAuctionSoldForm.note" type="textarea" :rows="2" placeholder="选填" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button @click="goofishAuctionSoldVisible = false">取消</el-button>
        <el-button class="btn-goofish" :loading="goofishAuctionSoldSubmitting" @click="submitGoofishAuctionSold">
          确认登记
        </el-button>
      </span>
    </el-dialog>

    <el-dialog
      :title="nativeGoofishLinkDialogTitle"
      :visible.sync="nativeGoofishLinkVisible"
      width="520px"
      :close-on-click-modal="false"
      @closed="onNativeGoofishLinkDialogClosed"
    >
      <div v-if="nativeGoofishLinkRow">
        <div class="consign-price-product">{{ nativeGoofishLinkRow.title || "—" }}</div>
        <div class="consign-price-meta" style="margin-top: 6px">
          编号：{{ nativeGoofishLinkRow.productNo || nativeGoofishLinkRow.id || "—" }}
        </div>
        <el-alert
          :type="nativeGoofishLinkBindAllowed ? 'info' : 'warning'"
          :closable="false"
          show-icon
          style="margin: 12px 0"
          :title="nativeGoofishLinkAlertTitle"
        />
        <el-form label-width="120px" size="small">
          <el-form-item label="闲鱼店铺" required>
            <el-select
              v-model="nativeGoofishLinkForm.accountId"
              clearable
              placeholder="请选择"
              style="width: 100%"
              @change="onNativeGoofishLinkAccountChange"
            >
              <el-option
                v-for="a in goofishAccountOptions"
                :key="a.id"
                :label="a.name ? `${a.name}（${a.userName || ''}）` : a.userName"
                :value="a.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item v-if="nativeGoofishLinkBindAllowed" label="闲鱼商品 id" required>
            <el-input
              v-model.trim="nativeGoofishLinkForm.xianyuItemId"
              clearable
              maxlength="64"
              placeholder="闲鱼商品详情页 item_id"
            />
          </el-form-item>
          <el-form-item v-else label="已关联闲鱼 id">
            <el-input :value="nativeGoofishLinkForm.xianyuItemId || '—'" disabled />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button
          v-if="nativeGoofishLinkCanUnbind"
          type="danger"
          plain
          :loading="nativeGoofishLinkUnbinding"
          @click="submitUnbindNativeGoofishLink"
        >解除关联</el-button>
        <el-button @click="nativeGoofishLinkVisible = false">取消</el-button>
        <el-button
          v-if="nativeGoofishLinkBindAllowed"
          class="btn-goofish"
          :loading="nativeGoofishLinkSubmitting"
          @click="submitNativeGoofishLink"
        >
          确认关联
        </el-button>
      </span>
    </el-dialog>

    <!-- 官方寄售：一键上架（立即 / 定时） -->
    <el-dialog
      title="一键上架"
      :visible.sync="batchPublishDialogVisible"
      width="500px"
      :close-on-click-modal="false"
      @closed="onBatchPublishDialogClosed"
    >
      <div class="batch-publish-dialog">
        <div class="batch-publish-tip">
          已勾选 {{ batchPublishPendingCount }} 条自动上架寄售单
        </div>
        <el-radio-group v-model="batchPublishMode" style="margin-bottom: 16px">
          <el-radio label="immediate">立即上架</el-radio>
          <el-radio label="scheduled">定时上架</el-radio>
        </el-radio-group>
        <div v-if="batchPublishMode === 'scheduled'">
          <div style="margin-bottom: 8px; color: #606266">上架时间（日 / 时 / 分）</div>
          <el-date-picker
            v-model="batchPublishAt"
            type="datetime"
            placeholder="选择上架时间"
            format="yyyy-MM-dd HH:mm"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="batchPublishPickerOptions"
            style="width: 100%"
          />
        </div>
      </div>
      <span slot="footer">
        <el-button @click="batchPublishDialogVisible = false">取消</el-button>
        <el-button
          type="warning"
          :loading="batchPublishSubmitting"
          @click="confirmBatchPublishDialog"
        >
          {{ batchPublishMode === "scheduled" ? "确认预约" : "确认上架" }}
        </el-button>
      </span>
    </el-dialog>

    <!-- 官方寄售：改价（与货主端 consignor/updatePrice 一致） -->
    <el-dialog
      title="改价"
      :visible.sync="consignPriceVisible"
      width="500px"
      :close-on-click-modal="false"
      @closed="onConsignPriceDialogClosed"
    >
      <div v-if="consignPriceRow" class="consign-price-dialog">
        <div class="consign-price-product">{{ consignPriceRow.title || "-" }}</div>
        <div class="consign-price-meta">寄售用户：{{ formatConsignorDisplay(consignPriceRow) }}</div>
        <el-form label-width="108px" size="small" @submit.native.prevent="submitConsignPriceFn">
          <el-form-item label="货主售卖价">
            <el-input-number
              v-model="consignPriceForm.listingPrice"
              :min="0.01"
              :max="9999999.99"
              :precision="2"
              :step="1"
              controls-position="right"
              style="width: 100%"
            />
            <div v-if="consignPricePromoActive" class="consign-price-hint">
              买家实付约 ¥{{ formatMoney(consignPricePreviewBuyer) }}（按 {{ consignPriceDiscountLabel }} 折自动计算）
            </div>
            <div v-else class="consign-price-hint">买家实付与货主售卖价相同（当前未启用补贴或尚无挂牌价）</div>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button @click="consignPriceVisible = false">取消</el-button>
        <el-button type="primary" :loading="consignPriceSubmitting" @click="submitConsignPriceFn">确认改价</el-button>
      </span>
    </el-dialog>

    <!-- 官方寄售：代改自动上架预设价（写寄售子单 js_price） -->
    <el-dialog
      title="修改自动上架预设价"
      :visible.sync="autoListPriceVisible"
      width="500px"
      :close-on-click-modal="false"
      @closed="onAutoListPriceDialogClosed"
    >
      <div v-if="autoListPriceRow" class="consign-price-dialog">
        <div class="consign-price-product">{{ listRowDisplayTitle(autoListPriceRow) || "-" }}</div>
        <div class="consign-price-meta">寄售用户：{{ formatConsignorDisplay(autoListPriceRow) }}</div>
        <div class="consign-price-meta">当前预设价：¥{{ formatAutoListPrice(autoListPriceRow) }}</div>
        <el-form label-width="108px" size="small" @submit.native.prevent="submitAutoListPriceFn">
          <el-form-item label="预设售价">
            <el-input-number
              v-model="autoListPriceForm.listingPrice"
              :min="0.01"
              :max="9999999.99"
              :precision="2"
              :step="1"
              controls-position="right"
              style="width: 100%"
            />
            <div class="consign-price-hint">平台按此价格自动上架；仅未正式上架前可改</div>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button @click="autoListPriceVisible = false">取消</el-button>
        <el-button type="primary" :loading="autoListPriceSubmitting" @click="submitAutoListPriceFn">确认改价</el-button>
      </span>
    </el-dialog>

    <!-- 官方寄售：代用户发闲置（卖家=官方帐号，货主=寄售用户） -->
    <el-dialog
      title="发闲置（官方寄售）"
      :visible.sync="officialPublishVisible"
      width="820px"
      top="5vh"
      custom-class="secondhand-official-publish-dialog"
      :close-on-click-modal="false"
      @closed="onOfficialPublishDialogClosed"
    >
      <div v-loading="officialPublishLoading" class="official-publish-wrap">
        <p class="official-publish-tip">
          由所选官方帐号作为卖家上架展示，货主为寄售用户；便于前台展示与筛选。
        </p>
        <div class="official-publish-body">
          <el-form
            v-if="officialPublishForm"
            ref="officialPublishFormRef"
            :model="officialPublishForm"
            :rules="officialPublishRules"
            label-width="122px"
            size="small"
          >
            <el-divider content-position="left">上架帐号</el-divider>
            <el-form-item label="官方帐号" prop="officialSellerUserId" class="official-publish-official-item">
              <el-select
                v-model="officialPublishForm.officialSellerUserId"
                placeholder="请选择作为卖家的官方帐号"
                style="width: 100%"
                filterable
                popper-class="official-publish-official-dropdown"
              >
                <el-option
                  v-for="acc in officialAccountList"
                  :key="'oa-' + acc.id"
                  :label="officialAccountOptionLabel(acc)"
                  :value="acc.officialUserId"
                >
                  <div class="official-account-opt">
                    <div class="official-account-opt__avatar-wrap">
                      <img v-if="acc.photo" :src="acc.photo" alt="" class="official-account-opt__avatar" />
                      <span v-else class="official-account-opt__avatar official-account-opt__avatar--ph">
                        <i class="el-icon-user-solid"></i>
                      </span>
                    </div>
                    <div class="official-account-opt__meta">
                      <div class="official-account-opt__nick">{{ displayOfficialAccountNick(acc) }}</div>
                      <div class="official-account-opt__sub">
                        用户 ID {{ acc.officialUserId != null ? acc.officialUserId : "—" }}
                        <template v-if="acc.remark"> · {{ acc.remark }}</template>
                      </div>
                    </div>
                  </div>
                </el-option>
              </el-select>
              <div class="official-publish-field-hint">
                前台展示卖家为该帐号；若配置多个官方帐号，可在此切换。
              </div>
            </el-form-item>

            <el-divider content-position="left">寄售货主</el-divider>
            <el-form-item label="寄售货主" prop="consignorUserId" class="official-publish-consignor-item">
              <el-select
                v-model="officialPublishForm.consignorUserId"
                filterable
                remote
                reserve-keyword
                clearable
                placeholder="昵称搜索并选择"
                :remote-method="remoteSearchConsignorUser"
                :loading="consignorSearchLoading"
                style="width: 100%"
              >
                <el-option
                  v-for="u in consignorSearchOptions"
                  :key="'c-' + u.id"
                  :label="consignorUserOptionLabel(u)"
                  :value="u.id"
                />
              </el-select>
              <div class="official-publish-field-hint">将作为货主（consignor）</div>
            </el-form-item>

            <el-divider content-position="left">商品信息</el-divider>
            <el-form-item label="商品图片" required>
              <div class="sh-img-upload">
                <div class="sh-img-upload__grid">
                  <div
                    v-for="(imgUrl, idx) in officialPublishImageUrls"
                    :key="idx"
                    class="sh-img-upload__thumb"
                  >
                    <img :src="imgUrl" alt="" @click="previewFn(imgUrl)" />
                    <span class="sh-img-upload__remove" title="删除" @click.stop="removeOfficialPublishImage(idx)">
                      <i class="el-icon-close"></i>
                    </span>
                    <span v-if="idx === 0" class="sh-img-upload__cover">封面</span>
                  </div>
                  <el-upload
                    v-if="officialPublishImageUrls.length < 9"
                    class="sh-img-upload__trigger"
                    :show-file-list="false"
                    :disabled="officialPublishImageUploading"
                    accept="image/jpeg,image/png,image/gif,image/webp"
                    :http-request="uploadOfficialPublishImageRequest"
                  >
                    <div
                      class="sh-img-upload__add"
                      :class="{ 'is-loading': officialPublishImageUploading }"
                    >
                      <i v-if="!officialPublishImageUploading" class="el-icon-plus sh-img-upload__add-icon"></i>
                      <i v-else class="el-icon-loading sh-img-upload__add-icon"></i>
                      <span class="sh-img-upload__add-text">{{
                          officialPublishImageUploading ? "上传中…" : "添加图片"
                        }}</span>
                    </div>
                  </el-upload>
                </div>
                <p class="sh-img-upload__hint">
                  支持 JPG / PNG / GIF / WebP；最多 9 张，<span class="sh-img-upload__hint-em">第 1 张为封面</span>
                </p>
              </div>
            </el-form-item>
            <el-form-item label="标题" prop="title">
              <el-input
                v-model="officialPublishForm.title"
                maxlength="200"
                show-word-limit
                placeholder="品牌型号、规格等"
              />
            </el-form-item>
            <el-form-item label="描述" prop="description">
              <el-input
                v-model="officialPublishForm.description"
                type="textarea"
                :rows="5"
                maxlength="400"
                show-word-limit
                placeholder="描述品牌型号、成色、出手原因等"
              />
            </el-form-item>

            <el-divider content-position="left">价格</el-divider>
            <el-row :gutter="16">
              <el-col :span="12">
                <el-form-item label="售价(元)" prop="price">
                  <el-input-number
                    v-model="officialPublishForm.price"
                    :min="0.01"
                    :max="9999999.99"
                    :precision="2"
                    :step="1"
                    controls-position="right"
                    style="width: 100%"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="原价(元)">
                  <el-input-number
                    v-model="officialPublishForm.originalPrice"
                    :min="0"
                    :precision="2"
                    :step="1"
                    controls-position="right"
                    style="width: 100%"
                  />
                </el-form-item>
              </el-col>
            </el-row>

            <el-divider content-position="left">发货与地区</el-divider>
            <el-row :gutter="16">
              <el-col :span="12">
                <el-form-item label="发货方式" prop="deliveryType">
                  <el-select
                    v-model="officialPublishForm.deliveryType"
                    placeholder="请选择"
                    style="width: 100%"
                    @change="onOfficialPublishDeliveryTypeChange"
                  >
                    <el-option v-for="d in deliveryTypeFormOptions" :key="d.value" :label="d.label" :value="d.value" />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="Number(officialPublishForm.deliveryType) === 1" :gutter="16">
              <el-col :span="24">
                <el-form-item label="快递运费">
                  <el-radio-group
                    v-model="officialPublishForm.expressFreightMode"
                    @change="onOfficialPublishExpressFreightModeChange"
                  >
                    <el-radio label="free">包邮</el-radio>
                    <el-radio label="custom">自定义邮费</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col v-if="officialPublishForm.expressFreightMode === 'custom'" :span="12">
                <el-form-item label="邮费(元)">
                  <el-input-number
                    v-model="officialPublishForm.freight"
                    :min="0.01"
                    :precision="2"
                    :step="1"
                    controls-position="right"
                    style="width: 100%"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item label="所在地区">
              <el-cascader
                v-model="officialPublishForm.regionCodes"
                :options="regionCascaderOptions"
                :props="{ expandTrigger: 'hover' }"
                clearable
                filterable
                placeholder="请选择省 / 市 / 区（可选）"
                style="width: 100%"
              />
              <div class="official-publish-field-hint">不选则前台地区展示为空</div>
            </el-form-item>

            <el-divider content-position="left">品牌与型号</el-divider>
            <el-row :gutter="16">
              <el-col :span="12">
                <el-form-item label="品牌">
                  <el-select
                    v-model="officialPublishForm.brandId"
                    filterable
                    remote
                    clearable
                    reserve-keyword
                    placeholder="搜索并选择品牌"
                    style="width: 100%"
                    :remote-method="remoteSearchOfficialPublishBrand"
                    :loading="officialPublishBrandSearchLoading"
                    @visible-change="(open) => open && remoteSearchOfficialPublishBrand('')"
                    @change="onOfficialPublishBrandChange"
                  >
                    <el-option
                      v-for="b in officialPublishBrandOptions"
                      :key="'b' + b.id"
                      :label="officialPublishBrandOptionLabel(b)"
                      :value="b.id"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="型号">
                  <el-select
                    v-model="officialPublishForm.typeId"
                    filterable
                    remote
                    clearable
                    reserve-keyword
                    placeholder="请先选品牌，再搜索型号"
                    style="width: 100%"
                    :disabled="!officialPublishForm.brandId"
                    :remote-method="remoteSearchOfficialPublishType"
                    :loading="officialPublishTypeSearchLoading"
                    @visible-change="
                      (open) => open && officialPublishForm.brandId && remoteSearchOfficialPublishType('')
                    "
                    @change="onOfficialPublishTypeChange"
                  >
                    <el-option
                      v-for="t in officialPublishTypeOptions"
                      :key="'t' + t.id"
                      :label="officialPublishTypeOptionLabel(t)"
                      :value="t.id"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-divider content-position="left">品牌 / 成色等</el-divider>
            <el-form-item label="成色">
              <el-select v-model="officialPublishForm.conditionLevel" placeholder="可选" clearable style="width: 100%">
                <el-option v-for="c in conditionList" :key="c.value" :label="c.label" :value="c.value" />
              </el-select>
            </el-form-item>
            <el-form-item label="购买渠道">
              <el-select v-model="officialPublishForm.purchaseChannel" clearable placeholder="可选" style="width: 100%">
                <el-option v-for="p in purchaseChannelList" :key="p.value" :label="p.label" :value="p.value" />
              </el-select>
            </el-form-item>
            <el-form-item label="剩余保质期">
              <el-select v-model="officialPublishForm.shelfLife" clearable placeholder="可选" style="width: 100%">
                <el-option v-for="s in shelfLifeList" :key="s.value" :label="s.label" :value="s.value" />
              </el-select>
            </el-form-item>

            <el-divider content-position="left">还价与安心购</el-divider>
            <el-form-item label="接受还价">
              <el-select
                v-model="officialPublishForm.allowBargain"
                style="width: 160px"
                @change="onOfficialPublishAllowBargainChange"
              >
                <el-option label="否" :value="0" />
                <el-option label="是" :value="1" />
              </el-select>
            </el-form-item>
            <el-form-item v-if="officialPublishForm.allowBargain === 1" label="还价最低(元)" prop="minBargainPrice">
              <el-input-number
                v-model="officialPublishForm.minBargainPrice"
                :min="0"
                :precision="2"
                :step="1"
                controls-position="right"
                style="width: 220px"
              />
              <span class="official-publish-field-hint inline-hint">0 表示不设底价，大于 0 时须低于售价</span>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="officialPublishVisible = false">取消</el-button>
        <el-button type="primary" :loading="officialPublishSubmitting" @click="submitOfficialPublishFn">发布并上架</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { returnTime, isJSON } from "@/util/utils";
import { regionData, CodeToText } from "element-china-area-data";
import {
  applyBuyerPriceFromListing,
  resolveConsignorDisplayPrice,
  resolveConsignPromoDiscountRate,
  shouldApplyConsignPromoOnEdit,
} from "@/util/officialConsignment";
import { formatSpecificationDisplay } from "@/util/specCapacityCompat";
import { uploadImageWithCompressFallback } from "@/util/uploadImageWithCompressFallback";
import { joinDownloadNameParts } from "@/util/imageBatchDownload";
import ImageBatchDownloadBtn from "@/components/ImageBatchDownloadBtn.vue";
import ConsignOrderLinkImportModal from "./consignOrderLinkImportModal.vue";
import GoofishAuctionImportModal from "./goofishAuctionImportModal.vue";

export default {
  components: { ConsignOrderLinkImportModal, GoofishAuctionImportModal, ImageBatchDownloadBtn },
  data() {
    return {
      /** all：全量列表；audit：仅待人工审核 status=4 */
      activeMainTab: "all",
      loading: false,

      statusOptions: [
        { label: "全部", value: null },
        { label: "下架", value: 0 },
        { label: "上架", value: 1 },
        { label: "已售出", value: 2 },
        { label: "已删除", value: 3 },
        { label: "待人工审核", value: 4 },
        { label: "待修改", value: 5 },
        { label: "人工驳回", value: 6 },
        { label: "召回", value: 9 },
      ],

      consignStageOptions: [
        { label: "全部", value: null },
        { label: "待评级", value: "PENDING_GRADE" },
        { label: "已评级待上架", value: "GRADED_WAIT_LIST" },
        { label: "在售", value: "LISTED" },
        { label: "拍卖中", value: "IN_AUCTION" },
        { label: "已下架", value: "OFF_SHELF" },
        { label: "召回", value: "RECALL" },
        { label: "已售出", value: "SOLD" },
      ],
      /** 官方寄售主 Tab：全部 + 各阶段 */
      officialConsignMainTabs: [
        { label: "全部", name: "all" },
        { label: "待评级", name: "PENDING_GRADE" },
        { label: "已评级待上架", name: "GRADED_WAIT_LIST" },
        { label: "在售", name: "LISTED" },
        { label: "拍卖中", name: "IN_AUCTION" },
        { label: "已下架", name: "OFF_SHELF" },
        { label: "召回", name: "RECALL" },
        { label: "已售出", name: "SOLD" },
      ],

      query: {
        status: null,
        consignStage: null,
        title: "",
        sellerNickName: "",
        linkStatus: 0,
        productNo: "",
        consignOrderNo: "",
        inspectionSeq: "",
        shelfNo: "",
        importCode: "",
        xianyuItemId: "",
        gradeLevel: "",
        brandKeyword: "",
        xianyuOnly: 0,
        autoList: null,
      },
      queryExpanded: false,
      gradeLevelOptions: ["SS", "S", "A", "B", "C"],

      /** 省市区三级（element-china-area-data），用于 el-cascader */
      regionCascaderOptions: regionData,

      tableData: [],
      pageSize: 50,
      currentPage: 1,
      tableTotal: 0,
      tableMaxHeight: 560,

      detailVisible: false,
      detail: null,
      detailLoading: false,

      consignOrderDetailVisible: false,
      consignOrderDetailLoading: false,
      consignOrderDetail: null,
      consignOrderDetailRow: null,

      auditDialogVisible: false,
      auditRow: null,
      auditRejectRemark: "",
      auditSubmitLoading: false,

      editVisible: false,
      editLoading: false,
      editSubmitLoading: false,
      shelfActionId: null,
      goofishSyncVisible: false,
      goofishSyncRow: null,
      goofishSyncMode: "schedule",
      goofishSyncLoading: false,
      goofishAccountOptions: [],
      goofishSyncAccountIds: [],
      batchGoofishSyncVisible: false,
      batchGoofishSyncSubmitting: false,
      syncAllGoofishVisible: false,
      syncAllGoofishSubmitting: false,
      syncAllGoofishLimit: 2000,
      syncAllFreightVisible: false,
      syncAllFreightSubmitting: false,
      syncAllFreightLimit: 2000,
      deleteActionId: null,
      batchSyncEsSubmitting: false,
      editRaw: null,
      editForm: null,
      editImageUrls: [],
      editImageUploading: false,

      officialPublishVisible: false,
      officialPublishLoading: false,
      officialPublishSubmitting: false,
      /** 后台「官方帐号列表」全部行，用于发闲置时选择卖家 */
      officialAccountList: [],
      officialPublishForm: null,
      officialPublishImageUrls: [],
      officialPublishImageUploading: false,
      consignorSearchOptions: [],
      consignorSearchLoading: false,
      consignorSearchTimer: null,

      consignLinkImportVisible: false,
      goofishAuctionImportVisible: false,
      consignLinkVisible: false,
      consignLinkProduct: null,
      consignLinkSearch: { orderId: "", unlinkedOnly: 1 },
      consignLinkOrderList: [],
      consignLinkOrderLoading: false,
      consignLinkOrderPage: 1,
      consignLinkOrderSize: 50,
      consignLinkOrderTotal: 0,
      consignLinkSelectedOrder: null,
      consignLinkManualOrderNo: "",
      consignLinkSubmitting: false,

      consignPriceVisible: false,
      consignPriceRow: null,
      consignPriceForm: { listingPrice: null },
      consignPriceSubmitting: false,

      autoListPriceVisible: false,
      autoListPriceRow: null,
      autoListPriceForm: { listingPrice: null },
      autoListPriceSubmitting: false,

      consignPublishVisible: false,
      consignPublishRow: null,
      consignPublishForm: { listingPrice: null },
      consignPublishSubmitting: false,

      goofishAuctionSoldVisible: false,
      goofishAuctionSoldRow: null,
      goofishAuctionSoldForm: { goofishOrderNo: "", orderAmount: "", note: "" },
      goofishAuctionSoldSubmitting: false,

      nativeGoofishLinkVisible: false,
      nativeGoofishLinkRow: null,
      nativeGoofishLinkForm: { accountId: null, xianyuItemId: "" },
      nativeGoofishLinkSubmitting: false,
      nativeGoofishLinkUnbinding: false,
      nativeGoofishLinkCanUnbind: false,

      batchPublishSubmitting: false,
      cancelScheduleSubmitting: false,
      batchPublishSelection: [],
      batchPublishDialogVisible: false,
      batchPublishMode: "immediate",
      batchPublishAt: "",
      batchPublishPendingCount: 0,
      batchPublishPickerOptions: {
        disabledDate(time) {
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          return time.getTime() < today.getTime();
        },
      },

      officialPublishBrandOptions: [],
      officialPublishBrandSearchLoading: false,
      officialPublishBrandSearchTimer: null,
      officialPublishTypeOptions: [],
      officialPublishTypeSearchLoading: false,
      officialPublishTypeSearchTimer: null,
      officialPublishSelectedBrand: null,
      officialPublishSelectedType: null,
      officialPublishRules: {
        officialSellerUserId: [{ required: true, message: "请选择上架官方帐号", trigger: "change" }],
        consignorUserId: [{ required: true, message: "请搜索并选择寄售货主", trigger: "change" }],
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        price: [{ required: true, message: "请输入售价", trigger: "change" }],
        deliveryType: [{ required: true, message: "请选择发货方式", trigger: "change" }],
      },

      editRules: {
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        price: [{ required: true, message: "请输入售价", trigger: "change" }],
        quantity: [{ required: true, message: "请输入库存", trigger: "change" }],
        status: [{ required: true, message: "请选择售卖状态", trigger: "change" }],
        recallExpressNo: [
          {
            validator: (rule, value, callback) => {
              const f = this.editForm;
              if (!f || Number(f.status) !== 9) {
                callback();
                return;
              }
              if (value == null || String(value).trim() === "") {
                callback(new Error("召回状态请填写召回单号"));
                return;
              }
              callback();
            },
            trigger: "blur",
          },
        ],
        minBargainPrice: [
          {
            validator: (rule, value, callback) => {
              const f = this.editForm;
              if (!f || f.allowBargain !== 1) {
                callback();
                return;
              }
              if (value == null || value === "") {
                callback(new Error("接受还价时请填写还价最低金额"));
                return;
              }
              const n = Number(value);
              if (Number.isNaN(n) || n <= 0) {
                callback(new Error("还价最低金额须大于 0"));
                return;
              }
              if (f.price != null && n >= Number(f.price)) {
                callback(new Error("还价最低金额须低于售价"));
                return;
              }
              callback();
            },
            trigger: "change",
          },
        ],
        inspectionFee: [
          {
            validator: (rule, value, callback) => {
              const f = this.editForm;
              if (!f || f.allowInspection !== 1) {
                callback();
                return;
              }
              if (value == null || value === "") {
                callback();
                return;
              }
              const n = Number(value);
              if (Number.isNaN(n) || n < 0) {
                callback(new Error("安心购费用须为不小于 0 的数字"));
                return;
              }
              callback();
            },
            trigger: "change",
          },
        ],
      },

      /** 编辑弹窗内可选状态（不含已售出 2；拍卖中 8 仅回显，流转走列表按钮） */
      editStatusOptions: [
        { label: "下架", value: 0 },
        { label: "上架", value: 1 },
        { label: "已删除", value: 3 },
        { label: "待人工审核", value: 4 },
        { label: "待修改", value: 5 },
        { label: "人工驳回", value: 6 },
        { label: "拍卖中", value: 8 },
        { label: "召回", value: 9 },
      ],

      conditionList: [
        { label: "全新", value: 1 },
        { label: "几乎全新", value: 2 },
        { label: "轻微使用", value: 3 },
        { label: "明显使用", value: 4 },
        { label: "需要维修", value: 5 },
      ],
      purchaseChannelList: [
        { label: "品牌专柜", value: "counter" },
        { label: "其他线下渠道", value: "offline" },
        { label: "品牌官网", value: "official" },
      ],
      shelfLifeList: [
        { label: "1年以上", value: "y1" },
        { label: "7-12个月", value: "m7_12" },
        { label: "0-6个月", value: "m0_6" },
      ],
      specTypeList: [
        { label: "套装", value: "set" },
        { label: "小样", value: "sample" },
        { label: "正常规格", value: "normal" },
      ],
      genderList: [
        { label: "男", value: "male" },
        { label: "女", value: "female" },
        { label: "男女通用", value: "unisex" },
      ],
      deliveryTypeList: [
        { label: "快递", value: 1 },
        { label: "自提", value: 2 },
        { label: "同城", value: 3 },
      ],
    };
  },

  computed: {
    /** 卖家闲置商品列表：0；官方寄售商品列表：1 */
    listProductType() {
      return this.$route.path === "/secondhandOfficialProduct" ? 1 : 0;
    },
    historyArr() {
      const sub = this.listProductType === 1 ? "官方寄售商品列表" : "卖家闲置商品列表";
      return ["商品管理", sub];
    },
    /** 官方寄售商品列表不展示人工审核 Tab/入口及相关列 */
    showManualAuditUi() {
      return this.listProductType === 0;
    },
    /** 官方寄售：全部 + 各阶段 Tab；卖家闲置：商品列表 + 人工审核 */
    showMainTabs() {
      return this.showManualAuditUi || this.isOfficialConsignList;
    },
    isOfficialConsignList() {
      return this.listProductType === 1;
    },
    isAuctionTab() {
      return this.isOfficialConsignList && this.activeMainTab === "IN_AUCTION";
    },
    /** 在售残留预关联时：弹窗仅允许解除，不可再绑拍卖 id */
    nativeGoofishLinkBindAllowed() {
      const row = this.nativeGoofishLinkRow;
      return !!(row && this.canShowGoofishAuctionSoldEntry(row));
    },
    nativeGoofishLinkDialogTitle() {
      return this.nativeGoofishLinkBindAllowed ? "关联闲鱼侧自建商品" : "解除闲鱼预关联";
    },
    nativeGoofishLinkAlertTitle() {
      if (this.nativeGoofishLinkBindAllowed) {
        return "在闲鱼上自建竞拍商品后，把闲鱼商品 id 填到此处并选店铺。成交回调将自动生成履约单，可在「待发货列表 / 官方寄售待发货」发货回写闲鱼。";
      }
      return "该商品已恢复在售，但仍残留拍卖预关联，会阻止「同步闲鱼」出站上架。请先解除关联，再点同步闲鱼。";
    },
    goofishSoldDialogTitle() {
      const row = this.goofishAuctionSoldRow;
      if (row && this.canShowGoofishAuctionSoldEntry(row)) {
        return "登记闲鱼拍卖售出";
      }
      return "登记闲鱼售出";
    },
    goofishSoldAmountPlaceholder() {
      const row = this.goofishAuctionSoldRow;
      if (row && this.canShowGoofishAuctionSoldEntry(row)) {
        return "请填闲鱼落槌价（勿填挂牌价）";
      }
      return "请填闲鱼成交价（未填则使用挂牌价）";
    },
    /** 官方寄售阶段 Tab（非全部） */
    officialConsignStageTab() {
      if (!this.isOfficialConsignList || this.activeMainTab === "all") {
        return null;
      }
      const names = (this.officialConsignMainTabs || [])
        .map((t) => t.name)
        .filter((n) => n && n !== "all");
      return names.indexOf(this.activeMainTab) >= 0 ? this.activeMainTab : null;
    },
    batchPublishSelectedCount() {
      return this.getBatchPublishOrderIds().length;
    },
    cancelScheduleSelectedCount() {
      return this.getCancelScheduleOrderIds().length;
    },
    batchSyncEsSelectedCount() {
      return this.getBatchSyncEsProductIds().length;
    },
    batchGoofishSyncSelectedCount() {
      return this.getBatchGoofishProductIds().length;
    },
    /** 表单可选配送方式（不含已下线的同城） */
    deliveryTypeFormOptions() {
      return [
        { label: "快递", value: 1 },
        { label: "自提", value: 2 },
      ];
    },
    detailAttrExtra() {
      if (!this.detail || !this.detail.attrJson) return {};
      try {
        if (isJSON(this.detail.attrJson)) {
          const o = JSON.parse(this.detail.attrJson);
          return o.attrExtra && typeof o.attrExtra === "object" ? o.attrExtra : {};
        }
      } catch (e) {}
      return {};
    },
    consignPricePromoActive() {
      if (!this.consignPriceRow) return false;
      return shouldApplyConsignPromoOnEdit({ ...this.consignPriceRow, productType: 1 });
    },
    consignPriceDiscountRate() {
      return resolveConsignPromoDiscountRate({ ...this.consignPriceRow, productType: 1 });
    },
    consignPriceDiscountLabel() {
      const rate = this.consignPriceDiscountRate;
      if (!Number.isFinite(rate) || rate <= 0 || rate >= 1) return "96";
      return String(Math.round(rate * 100));
    },
    consignPricePreviewBuyer() {
      const listing = this.consignPriceForm && this.consignPriceForm.listingPrice;
      if (!this.consignPricePromoActive) return listing;
      return applyBuyerPriceFromListing(listing, this.consignPriceDiscountRate);
    },
    consignPublishPromoActive() {
      if (!this.consignPublishRow) return false;
      return shouldApplyConsignPromoOnEdit({ ...this.consignPublishRow, productType: 1 });
    },
    consignPublishDiscountRate() {
      return resolveConsignPromoDiscountRate({ ...this.consignPublishRow, productType: 1 });
    },
    consignPublishDiscountLabel() {
      const rate = this.consignPublishDiscountRate;
      if (!Number.isFinite(rate) || rate <= 0 || rate >= 1) return "96";
      return String(Math.round(rate * 100));
    },
    consignPublishPreviewBuyer() {
      const listing = this.consignPublishForm && this.consignPublishForm.listingPrice;
      if (!this.consignPublishPromoActive) return listing;
      return applyBuyerPriceFromListing(listing, this.consignPublishDiscountRate);
    },
    isEditingOfficialConsignProduct() {
      return !!(this.editRaw && Number(this.editRaw.productType) === 1);
    },
    /** 拍卖中：编辑弹窗仅回显，禁止在此切换状态（1↔8 走列表专用按钮） */
    isEditStatusLockedByAuction() {
      return !!(this.editRaw && Number(this.editRaw.status) === 8);
    },
    editListingPromoActive() {
      return this.isEditingOfficialConsignProduct && this.editRaw && shouldApplyConsignPromoOnEdit(this.editRaw);
    },
    editListingBuyerPreview() {
      if (!this.editListingPromoActive || !this.editForm) return null;
      return applyBuyerPriceFromListing(this.editForm.listingPrice, resolveConsignPromoDiscountRate(this.editRaw));
    },
    consignOrderDetailOrderNo() {
      const row = this.consignOrderDetailRow;
      const order = this.consignOrderDetail && this.consignOrderDetail.order;
      if (row && row.sourceConsignOrderNo) return row.sourceConsignOrderNo;
      if (order && order.orderId) return order.orderId;
      if (row && row.sourceXwOrderId) return String(row.sourceXwOrderId);
      return "";
    },
    consignOrderDetailBrandName() {
      const row = this.consignOrderDetailRow;
      const order = this.consignOrderDetail && this.consignOrderDetail.order;
      return (row && row.brandName) || (order && order.brandName) || "";
    },
    consignOrderDetailTypeName() {
      const row = this.consignOrderDetailRow;
      const order = this.consignOrderDetail && this.consignOrderDetail.order;
      return (row && row.typeName) || (order && order.typeName) || "";
    },
    consignOrderDetailJsPrice() {
      const row = this.consignOrderDetailRow;
      const order = this.consignOrderDetail && this.consignOrderDetail.order;
      if (order && order.jsPrice != null) return order.jsPrice;
      if (row && row.price != null) return row.price;
      return null;
    },
    consignOrderDetailSpecDisplay() {
      const ctx = this.consignOrderDetail;
      if (!ctx) return "";
      const order = ctx.order;
      const job = ctx.inspectionJob;
      const specRaw = (order && order.specification) || (job && job.specification) || null;
      if (specRaw) {
        const display = formatSpecificationDisplay(specRaw);
        if (display) return display;
      }
      const extra = ctx.gradeJson && ctx.gradeJson.attrExtra;
      if (extra && typeof extra === "object") {
        if (extra.capacityMl != null && extra.capacityMl !== "") {
          return this.formatCapacityMl(extra.capacityMl);
        }
        if (extra.specType != null && extra.specType !== "") {
          return this.labelInList(extra.specType, this.specTypeList);
        }
      }
      return "";
    },
    consignOrderDetailListingDescription() {
      const ctx = this.consignOrderDetail;
      if (!ctx) return "";
      if (ctx.listingDescription) return ctx.listingDescription;
      const row = this.consignOrderDetailRow;
      return (row && row.description) || "";
    },
    consignOrderDetailDefectImages() {
      const ctx = this.consignOrderDetail;
      return ctx && Array.isArray(ctx.defectImages) ? ctx.defectImages : [];
    },
    consignOrderDetailRemainImages() {
      const ctx = this.consignOrderDetail;
      return ctx && Array.isArray(ctx.remainImages) ? ctx.remainImages : [];
    },
    consignOrderDetailDetailImages() {
      const ctx = this.consignOrderDetail;
      if (ctx && Array.isArray(ctx.detailImages) && ctx.detailImages.length) {
        return ctx.detailImages;
      }
      const row = this.consignOrderDetailRow;
      return row ? this.imageList(row.images) : [];
    },
    /** 商品详情弹窗：商品图片下载前缀 */
    productDetailImagesDownloadNameBase() {
      const d = this.detail || {};
      return joinDownloadNameParts(
        d.brandName || "未知品牌",
        d.typeName || "未知型号",
        d.productNo || "商品"
      );
    },
    /**
     * 商品详情图：首图保留，余量图插到第 2 张起（与上架拼图 / 小程序详情一致；兼容旧数据余量在末尾）
     */
    productDetailDisplayImages() {
      const d = this.detail || {};
      const main = this.imageList(d.images);
      if (!main.length) return [];
      const remain = this.parseRemainImageUrls(d);
      if (!remain.length) return main;
      const remainSet = new Set(remain);
      const head = [main[0]];
      const rest = main.slice(1).filter((u) => !remainSet.has(u));
      const remainInsert = remain.filter((u) => u && u !== head[0]);
      return head.concat(remainInsert, rest);
    },
  },

  watch: {
    "$route.path"(path) {
      this.currentPage = 1;
      if (path === "/secondhandOfficialProduct" && this.activeMainTab === "audit") {
        this.activeMainTab = "all";
      }
      if (path !== "/secondhandOfficialProduct" && this.isOfficialConsignStageName(this.activeMainTab)) {
        this.activeMainTab = "all";
      }
      this.fetchList(1);
    },
    queryExpanded() {
      this.syncTableMaxHeight();
    },
  },

  mounted() {
    const q = this.$route && this.$route.query;
    if (q && q.productNo) {
      this.query.productNo = String(q.productNo);
    }
    this.fetchList(1);
    this.syncTableMaxHeight();
    window.addEventListener("resize", this.syncTableMaxHeight);
    this.bindTableResizeObserver();
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.syncTableMaxHeight);
    this.unbindTableResizeObserver();
  },

  methods: {
    statusLabel(v) {
      if (v === 0) return "下架";
      if (v === 1) return "上架";
      if (v === 2) return "已售出";
      if (v === 3) return "已删除";
      if (v === 4) return "待人工审核";
      if (v === 5) return "待修改";
      if (v === 6) return "人工驳回";
      if (v === 8) return "拍卖中";
      if (v === 9) return "召回";
      return String(v == null ? "-" : v);
    },

    statusColor(v) {
      if (v === 4) return "#e29428";
      if (v === 5) return "#f56c6c";
      if (v === 6) return "#e6a23c";
      if (v === 1) return "#67c23a";
      if (v === 8) return "#e6a23c";
      if (v === 9) return "#909399";
      return "#999";
    },

    isOfficialConsignOrderRow(row) {
      return !!(row && row.rowType === "ORDER");
    },

    isOfficialConsignPendingGradeRow(row) {
      return !!(this.isOfficialConsignList && row && row.consignStage === "PENDING_GRADE");
    },

    isOfficialConsignGradedWaitListOrderRow(row) {
      return !!(
        this.isOfficialConsignList
        && this.isOfficialConsignOrderRow(row)
        && row.consignStage === "GRADED_WAIT_LIST"
      );
    },

    listRowDisplayImage(row) {
      if (!row) return "";
      const productImg = this.firstImage(row.images);
      if (productImg) return productImg;
      if (this.isOfficialConsignPendingGradeRow(row) || this.isOfficialConsignGradedWaitListOrderRow(row)) {
        return this.firstImage(row.typeImage) || "";
      }
      return "";
    },

    listRowDisplayTitle(row) {
      if (!row) return "-";
      if (this.isOfficialConsignPendingGradeRow(row)) {
        const typeName = String(row.typeName || "").trim();
        if (typeName) return typeName;
      }
      if (this.isOfficialConsignGradedWaitListOrderRow(row)) {
        const brand = String(row.brandName || "").trim();
        const typeName = String(row.typeName || "").trim();
        let base = `${brand} ${typeName}`.trim();
        if (!base) {
          base = row.title != null ? String(row.title).trim() : "";
        }
        const level = String(row.gradeLevel || "").trim();
        if (level) {
          return base ? `${base} 【${level}级】` : `【${level}级】`;
        }
        return base || "-";
      }
      const title = row.title != null ? String(row.title).trim() : "";
      return title || "-";
    },

    shouldShowListRowPrice(row) {
      if (this.isOfficialConsignPendingGradeRow(row)) {
        return false;
      }
      return true;
    },

    officialConsignStageLabel(row) {
      if (!row) return "-";
      if (row.consignStage === "RECALL" || Number(row.status) === 9) return "召回";
      if (row.consignStage === "PENDING_GRADE") return "待评级";
      if (row.consignStage === "GRADED_WAIT_LIST") return "已评级待上架";
      if (row.consignStage === "LISTED") return "在售";
      if (row.consignStage === "IN_AUCTION") return "拍卖中";
      if (row.consignStage === "OFF_SHELF") return "已下架";
      if (row.consignStage === "SOLD") return "已售出";
      return this.statusLabel(row.status);
    },

    officialConsignStageColor(row) {
      if (!row) return "#999";
      if (row.consignStage === "RECALL" || Number(row.status) === 9) return "#909399";
      if (row.consignStage === "PENDING_GRADE") return "#409EFF";
      if (row.consignStage === "GRADED_WAIT_LIST") return "#e6a23c";
      if (row.consignStage === "LISTED") return "#67c23a";
      if (row.consignStage === "IN_AUCTION") return "#e6a23c";
      if (row.consignStage === "OFF_SHELF") return "#909399";
      if (row.consignStage === "SOLD") return "#909399";
      return "#999";
    },

    goConsignGrade(row) {
      const orderId = row && row.sourceXwOrderId;
      if (!orderId) {
        this.$message.warning("缺少寄售子单信息");
        return;
      }
      this.$router.push({
        path: "/goodsOrder/consignmentGrade",
        query: { orderId, from: "officialProductList" },
      });
    },

    canShowConsignGradeEntry(row) {
      return (
        this.isOfficialConsignList
        && row
        && row.consignStage === "PENDING_GRADE"
        && row.sourceXwOrderId
      );
    },

    canShowConsignPublishEntry(row) {
      if (!this.isOfficialConsignList || !row || row.consignStage !== "GRADED_WAIT_LIST") {
        return false;
      }
      if (this.isOfficialConsignOrderRow(row)) {
        return !!row.sourceXwOrderId;
      }
      return !!row.id;
    },

    /** 在售：下架 */
    canShowOfflineEntry(row) {
      if (!row || !row.id) return false;
      if (this.isOfficialConsignList) {
        return row.consignStage === "LISTED" && Number(row.status) === 1;
      }
      return Number(row.status) === 1;
    },

    /** 官方寄售在售：设为拍卖中 */
    canShowStartAuctionEntry(row) {
      return this.isOfficialConsignList
        && row
        && row.id
        && row.consignStage === "LISTED"
        && Number(row.status) === 1;
    },

    /** 官方寄售拍卖中：结束拍卖并恢复上架 */
    canShowEndAuctionEntry(row) {
      return this.isOfficialConsignList
        && row
        && row.id
        && row.consignStage === "IN_AUCTION"
        && Number(row.status) === 8;
    },

    /** 官方寄售拍卖中：闲鱼侧已拍出，登记售出 */
    canShowGoofishAuctionSoldEntry(row) {
      return this.isOfficialConsignList
        && row
        && row.id
        && row.consignStage === "IN_AUCTION"
        && Number(row.status) === 8;
    },

    /** 官方寄售在售 / 已评级待上架：闲鱼侧已成交，登记售出 */
    canShowGoofishListedSoldEntry(row) {
      if (!this.isOfficialConsignList || !row || !row.id || this.isOfficialConsignOrderRow(row)) {
        return false;
      }
      if (row.consignStage === "LISTED" && Number(row.status) === 1) {
        return true;
      }
      return row.consignStage === "GRADED_WAIT_LIST" && Number(row.status) === 0;
    },

    canShowGoofishSoldEntry(row) {
      return this.canShowGoofishAuctionSoldEntry(row) || this.canShowGoofishListedSoldEntry(row);
    },

    goofishSoldEntryLabel(row) {
      return this.canShowGoofishAuctionSoldEntry(row) ? "闲鱼拍卖售出" : "闲鱼售出";
    },

    /**
     * 预关联入口：
     * - 拍卖中：可新建/查看关联
     * - 已恢复在售但仍残留 native：仍展示，便于解除后重新同步闲鱼
     */
    canShowNativeGoofishLinkEntry(row) {
      if (!this.isOfficialConsignList || !row || !row.id) return false;
      if (this.canShowGoofishAuctionSoldEntry(row)) return true;
      return this.hasNativeGoofishLink(row);
    },

    nativeGoofishLinkEntryLabel(row) {
      if (this.hasNativeGoofishLink(row) && !this.canShowGoofishAuctionSoldEntry(row)) {
        return "解除闲鱼预关联";
      }
      return this.hasNativeGoofishLink(row) ? "闲鱼商品关联" : "关联闲鱼商品";
    },

    parseProductAttrJson(row) {
      if (!row || !row.attrJson) return null;
      try {
        return isJSON(row.attrJson) ? JSON.parse(row.attrJson) : null;
      } catch (e) {
        return null;
      }
    },

    /** 是否已有拍卖预关联（auctionNative 或旧版根上 linkSource=native） */
    hasNativeGoofishLink(row) {
      const attr = this.parseProductAttrJson(row);
      const byAccount = attr && (attr.goofishByAccount || attr.goofish_by_account);
      if (!byAccount || typeof byAccount !== "object") return false;
      return Object.keys(byAccount).some((key) => {
        const shop = byAccount[key];
        if (!shop || typeof shop !== "object") return false;
        const auctionNative = shop.auctionNative || shop.auction_native;
        if (auctionNative && typeof auctionNative === "object") {
          const src = String(auctionNative.linkSource || auctionNative.link_source || "").trim().toLowerCase();
          if (src === "native") return true;
          if (String(auctionNative.xianyuItemId || auctionNative.xianyu_item_id || "").trim()) return true;
        }
        const src = String(shop.linkSource || shop.link_source || "").trim().toLowerCase();
        return src === "native";
      });
    },

    resolveNativeGoofishLinkPrefill(row) {
      const attr = this.parseProductAttrJson(row);
      const byAccount = attr && (attr.goofishByAccount || attr.goofish_by_account);
      let accountId = null;
      let xianyuItemId = "";
      if (byAccount && typeof byAccount === "object") {
        const keys = Object.keys(byAccount);
        for (let i = 0; i < keys.length; i++) {
          const key = keys[i];
          const shop = byAccount[key];
          if (!shop || typeof shop !== "object") continue;
          const auctionNative = shop.auctionNative || shop.auction_native;
          const auctionSrc = auctionNative && typeof auctionNative === "object"
            ? String(auctionNative.linkSource || auctionNative.link_source || "").trim().toLowerCase()
            : "";
          const rootSrc = String(shop.linkSource || shop.link_source || "").trim().toLowerCase();
          const isNative = auctionSrc === "native"
            || (auctionNative && String(auctionNative.xianyuItemId || auctionNative.xianyu_item_id || "").trim())
            || rootSrc === "native";
          if (!isNative) continue;
          if (auctionNative && typeof auctionNative === "object") {
            xianyuItemId = String(auctionNative.xianyuItemId || auctionNative.xianyu_item_id || "").trim();
          }
          if (!xianyuItemId && rootSrc === "native") {
            xianyuItemId = String(shop.xianyuItemId || shop.xianyu_item_id || "").trim();
          }
          const matched = (this.goofishAccountOptions || []).find(
            (a) => a && (String(a.userName || "") === String(key) || String(a.id) === String(key))
          );
          if (matched) accountId = matched.id;
          break;
        }
      }
      if (!xianyuItemId) {
        xianyuItemId = String((attr && (attr.xianyuItemId || attr.xianyu_item_id)) || row.xianyuItemId || "").trim();
      }
      return { accountId, xianyuItemId };
    },

    openNativeGoofishLinkDialog(row) {
      if (!this.canShowNativeGoofishLinkEntry(row)) return;
      this.nativeGoofishLinkRow = { ...row };
      this.nativeGoofishLinkVisible = true;
      this.ensureGoofishAccounts().then(() => {
        const prefill = this.resolveNativeGoofishLinkPrefill(row);
        let accountId = prefill.accountId;
        if (!accountId && this.goofishAccountOptions.length === 1) {
          accountId = this.goofishAccountOptions[0].id;
        }
        this.nativeGoofishLinkForm = {
          accountId: accountId || null,
          xianyuItemId: prefill.xianyuItemId || "",
        };
        this.refreshNativeGoofishLinkCanUnbind();
      });
    },

    onNativeGoofishLinkDialogClosed() {
      this.nativeGoofishLinkRow = null;
      this.nativeGoofishLinkForm = { accountId: null, xianyuItemId: "" };
      this.nativeGoofishLinkSubmitting = false;
      this.nativeGoofishLinkUnbinding = false;
      this.nativeGoofishLinkCanUnbind = false;
    },

    onNativeGoofishLinkAccountChange() {
      this.refreshNativeGoofishLinkCanUnbind();
    },

    refreshNativeGoofishLinkCanUnbind() {
      const row = this.nativeGoofishLinkRow;
      this.nativeGoofishLinkCanUnbind = !!(
        row
        && this.hasNativeGoofishLink(row)
        && this.nativeGoofishLinkForm
        && this.nativeGoofishLinkForm.accountId
      );
    },

    submitNativeGoofishLink() {
      const row = this.nativeGoofishLinkRow;
      if (!row || !row.id) return;
      if (!this.canShowGoofishAuctionSoldEntry(row)) {
        this.$message.error("仅拍卖中商品可新建关联；当前请先解除预关联后再同步闲鱼");
        return;
      }
      if (!this.nativeGoofishLinkForm.accountId) {
        this.$message.error("请选择闲鱼店铺");
        return;
      }
      const xianyuItemId = String(this.nativeGoofishLinkForm.xianyuItemId || "").trim();
      if (!xianyuItemId) {
        this.$message.error("请填写闲鱼商品 id");
        return;
      }
      const payload = {
        productId: row.id,
        accountId: this.nativeGoofishLinkForm.accountId,
        xianyuItemId,
      };
      this.nativeGoofishLinkSubmitting = true;
      this.$https(this.$api.api.goofishBindNativeAuctionListing, payload, "POST")
        .then((res) => {
          if (res.data && res.data.code == 200) {
            this.$message.success((res.data && res.data.msg) || "已关联");
            this.nativeGoofishLinkVisible = false;
            this.fetchList(this.currentPage);
          } else {
            this.$message.error((res.data && res.data.msg) || "关联失败");
          }
        })
        .finally(() => {
          this.nativeGoofishLinkSubmitting = false;
        });
    },

    submitUnbindNativeGoofishLink() {
      const row = this.nativeGoofishLinkRow;
      if (!row || !row.id || !this.nativeGoofishLinkForm.accountId) return;
      this.$confirm(
        "确定解除该闲鱼商品预关联吗？解除后可重新「同步闲鱼」走正常售卖上架；若仍在拍卖中，成交回调将重新进入「闲鱼拍卖待发货」。",
        "提示",
        {
          type: "warning",
        }
      )
        .then(() => {
          this.nativeGoofishLinkUnbinding = true;
          return this.$https(
            this.$api.api.goofishUnbindNativeAuctionListing,
            { productId: row.id, accountId: this.nativeGoofishLinkForm.accountId },
            "POST"
          );
        })
        .then((res) => {
          if (res.data && res.data.code == 200) {
            this.$message.success((res.data && res.data.msg) || "已解除");
            this.nativeGoofishLinkVisible = false;
            this.fetchList(this.currentPage);
          } else {
            this.$message.error((res.data && res.data.msg) || "解除失败");
          }
        })
        .catch(() => {})
        .finally(() => {
          this.nativeGoofishLinkUnbinding = false;
        });
    },

    openGoofishSoldDialog(row) {
      if (!this.canShowGoofishSoldEntry(row)) return;
      const listing = resolveConsignorDisplayPrice(row);
      this.goofishAuctionSoldRow = { ...row };
      this.goofishAuctionSoldForm = {
        goofishOrderNo: "",
        orderAmount: listing != null && listing !== "" ? String(listing) : "",
        note: "",
      };
      this.goofishAuctionSoldVisible = true;
    },

    onGoofishAuctionSoldDialogClosed() {
      this.goofishAuctionSoldRow = null;
      this.goofishAuctionSoldForm = { goofishOrderNo: "", orderAmount: "", note: "" };
      this.goofishAuctionSoldSubmitting = false;
    },

    submitGoofishAuctionSold() {
      const row = this.goofishAuctionSoldRow;
      if (!row || !row.id) return;
      const payload = {
        productId: row.id,
        goofishOrderNo: String(this.goofishAuctionSoldForm.goofishOrderNo || "").trim() || undefined,
        note: String(this.goofishAuctionSoldForm.note || "").trim() || undefined,
      };
      const amount = String(this.goofishAuctionSoldForm.orderAmount || "").trim();
      if (amount) {
        const n = Number(amount);
        if (!Number.isFinite(n) || n <= 0) {
          this.$message.error("成交金额无效");
          return;
        }
        payload.orderAmount = n;
      }
      this.goofishAuctionSoldSubmitting = true;
      this.shelfActionId = row.id;
      this.$https(this.$api.api.goofishMarkAuctionSold, payload, "POST")
        .then((res) => {
          if (res.data && res.data.code == 200) {
            this.$message.success(
              (res.data && res.data.msg)
                || (this.canShowGoofishAuctionSoldEntry(row) ? "已登记闲鱼拍卖售出" : "已登记闲鱼售出")
            );
            this.goofishAuctionSoldVisible = false;
            this.fetchList(this.currentPage);
          } else {
            this.$message.error((res.data && res.data.msg) || "登记失败");
          }
        })
        .finally(() => {
          this.goofishAuctionSoldSubmitting = false;
          this.shelfActionId = null;
        });
    },

    /** 已下架商品：重新上架（与「已评级待上架」的定价上架区分） */
    canShowConsignRelistEntry(row) {
      if (!this.isOfficialConsignList || !row || !row.id) {
        return false;
      }
      if (row.consignStage !== "OFF_SHELF") {
        return false;
      }
      return Number(row.status) === 0;
    },

    /** 编辑：仅已生成商品（有 id 的 PRODUCT 行）可编辑 */
    canShowConsignEditEntry(row) {
      if (!row || !row.id) return false;
      if (this.isOfficialConsignList) {
        if (this.isOfficialConsignOrderRow(row)) return false;
        if (Number(row.status) === 3) return false;
      }
      return true;
    },

    /** 官方寄售商品行：除已删除外展示删除（含在售、拍卖中，管理端可强制逻辑删除） */
    canShowConsignDeleteEntry(row) {
      if (!this.isOfficialConsignList || !row || !row.id) {
        return false;
      }
      if (this.isOfficialConsignOrderRow(row)) {
        return false;
      }
      const st = Number(row.status);
      if (st === 3) return false; // 已删除
      return true;
    },

    openConsignPublishDialog(row) {
      if (!this.canShowConsignPublishEntry(row)) {
        this.$message.warning("当前状态不可定价上架");
        return;
      }
      const cur = resolveConsignorDisplayPrice(row);
      const fallback = row.price != null && row.price !== "" ? Number(row.price) : null;
      const listing = cur != null && cur !== "" ? Number(cur) : fallback;
      this.consignPublishRow = { ...row };
      this.consignPublishForm = {
        listingPrice: Number.isFinite(listing) && listing > 0 ? listing : null,
      };
      this.consignPublishVisible = true;
    },

    onConsignPublishDialogClosed() {
      this.consignPublishRow = null;
      this.consignPublishForm = { listingPrice: null };
      this.consignPublishSubmitting = false;
    },

    submitConsignPublishFn() {
      if (!this.consignPublishRow || this.consignPublishSubmitting) return;
      const price = Number(this.consignPublishForm && this.consignPublishForm.listingPrice);
      if (!Number.isFinite(price) || price <= 0) {
        this.$message.warning("请输入有效上架售价");
        return;
      }
      const row = this.consignPublishRow;
      this.consignPublishSubmitting = true;
      const done = () => {
        this.consignPublishVisible = false;
        this.fetchList(this.currentPage);
      };
      if (this.isOfficialConsignOrderRow(row)) {
        this.$https(
          this.$api.api.consignmentGradePublish,
          { orderId: row.sourceXwOrderId, price },
          "POST"
        )
          .then((res) => {
            if (res.data && res.data.code == 200) {
              this.$message.success((res.data && res.data.msg) || "上架成功");
              done();
            } else {
              this.$message.error((res.data && res.data.msg) || "上架失败");
            }
          })
          .finally(() => {
            this.consignPublishSubmitting = false;
          });
        return;
      }
      this.publishOrphanOfficialConsignProduct(row, price)
        .then((ok) => {
          if (ok) {
            this.$message.success("上架成功");
            done();
          }
        })
        .finally(() => {
          this.consignPublishSubmitting = false;
        });
    },

    isAutoListRow(row) {
      if (!row) return false;
      const raw = row.autoList != null ? row.autoList : row.auto_list;
      return Number(raw) === 1;
    },

    /** 自动上架预设售价：仅勾选自动上架时展示 jsPrice / 挂牌价 */
    formatAutoListPrice(row) {
      if (!this.isAutoListRow(row)) return "-";
      const price = this.resolveBatchPublishListingPrice(row);
      return price != null ? this.formatMoney(price) : "-";
    },

    /** 一键上架可用售价（子单 js_price / 商品 consignListingPrice 或 price） */
    resolveBatchPublishListingPrice(row) {
      if (!row) return null;
      const cur = resolveConsignorDisplayPrice(row);
      const n = cur != null && cur !== "" ? Number(cur) : NaN;
      return Number.isFinite(n) && n > 0 ? n : null;
    },

    /**
     * 一键上架可勾选：已评级待上架的自动上架寄售子单（下单时勾选自动上架且有预设售价）
     */
    canBatchPublishRow(row) {
      if (!this.isOfficialConsignList || !row || row.consignStage !== "GRADED_WAIT_LIST") {
        return false;
      }
      if (!this.isOfficialConsignOrderRow(row) || !row.sourceXwOrderId) {
        return false;
      }
      if (!this.isAutoListRow(row)) {
        return false;
      }
      return this.resolveBatchPublishListingPrice(row) != null;
    },

    batchPublishRowKey(row) {
      if (!row) return "";
      if (this.isOfficialConsignOrderRow(row) && row.sourceXwOrderId) {
        return `order-${row.sourceXwOrderId}`;
      }
      if (row.id) return `product-${row.id}`;
      return `row-${row.sourceConsignOrderNo || row.productNo || Math.random()}`;
    },

    /** 可勾选：能同步 ES / 可一键上架 / 有待执行预约（可取消） */
    tableRowSelectable(row) {
      return this.canSyncEsEntry(row)
        || this.canBatchPublishRow(row)
        || this.canCancelScheduledPublishRow(row);
    },

    /** 有待执行预约的寄售子单行，可勾选取消预约 */
    canCancelScheduledPublishRow(row) {
      if (!this.isOfficialConsignList || !row || !row.scheduledPublishAt) {
        return false;
      }
      return this.isOfficialConsignOrderRow(row) && !!row.sourceXwOrderId;
    },

    getCancelScheduleOrderIds() {
      return (this.batchPublishSelection || [])
        .filter((r) => this.canCancelScheduledPublishRow(r))
        .map((r) => r.sourceXwOrderId)
        .filter(Boolean);
    },

    openCancelScheduleConfirm() {
      if (this.cancelScheduleSubmitting) return;
      const orderIds = this.getCancelScheduleOrderIds();
      if (!orderIds.length) {
        this.$message.warning("请勾选有预约上架时间的寄售单");
        return;
      }
      this.cancelScheduleSubmitting = true;
      this.$confirm(
        `确认取消已勾选的 ${orderIds.length} 条预约上架？`,
        "取消预约",
        {
          confirmButtonText: "确认取消",
          cancelButtonText: "返回",
          type: "warning",
        }
      )
        .then(() => {
          this.submitCancelScheduleFn(orderIds);
        })
        .catch(() => {
          this.cancelScheduleSubmitting = false;
        });
    },

    submitCancelScheduleFn(orderIds) {
      const ids = orderIds && orderIds.length ? orderIds : this.getCancelScheduleOrderIds();
      if (!ids.length) {
        this.cancelScheduleSubmitting = false;
        this.$message.warning("请勾选有预约上架时间的寄售单");
        return;
      }
      this.cancelScheduleSubmitting = true;
      this.$https(
        this.$api.api.consignmentGradeCancelScheduledPublish,
        { orderIds: ids },
        "POST"
      )
        .then((res) => {
          if (res.data && res.data.code == 200 && res.data.data) {
            const success = Number(res.data.data.successCount) || 0;
            const fail = Number(res.data.data.failCount) || 0;
            const failMessages = Array.isArray(res.data.data.failMessages)
              ? res.data.data.failMessages
              : [];
            const detail = failMessages.slice(0, 3).join("；");
            if (fail > 0) {
              this.$message.warning(
                `取消完成：成功 ${success}，失败 ${fail}${detail ? "（" + detail + "）" : ""}`
              );
            } else {
              this.$message.success(`已取消 ${success} 条预约`);
            }
          } else {
            this.$message.error((res.data && res.data.msg) || "取消预约失败");
          }
        })
        .catch(() => {
          this.$message.error("取消预约失败");
        })
        .finally(() => {
          this.clearBatchPublishSelection();
          this.fetchList(this.currentPage);
          this.cancelScheduleSubmitting = false;
        });
    },

    handleBatchPublishSelectionChange(rows) {
      this.batchPublishSelection = rows || [];
    },

    getBatchSyncEsProductIds() {
      return (this.batchPublishSelection || [])
        .filter((r) => this.canSyncEsEntry(r))
        .map((r) => r.id)
        .filter(Boolean);
    },

    openBatchSyncEsConfirm() {
      if (this.batchSyncEsSubmitting) return;
      const ids = this.getBatchSyncEsProductIds();
      if (!ids.length) {
        this.$message.warning("请勾选已生成商品的行");
        return;
      }
      this.$confirm(`确认同步已勾选的 ${ids.length} 个商品到 ES？`, "同步ES", {
        confirmButtonText: "确认同步",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.submitBatchSyncEsFn(ids);
        })
        .catch(() => {});
    },

    /** 批量接口未部署/404/405 时走单条兜底 */
    isSyncEsBatchApiMissing(errOrRes) {
      if (!errOrRes) return false;
      const status =
        (errOrRes.response && errOrRes.response.status) ||
        errOrRes.status ||
        (errOrRes.data && errOrRes.data.status);
      if (status === 404 || status === 405) return true;
      const data = errOrRes.data;
      if (data && (data.code === 404 || Number(data.code) === 404)) return true;
      const msg = String(
        (data && (data.msg || data.message)) || errOrRes.message || ""
      );
      return /404|Not Found|No mapping|接口不存在|不支持该请求/i.test(msg);
    },

    showBatchSyncEsResult(success, fail) {
      if (fail > 0) {
        this.$message.warning(`同步完成：成功 ${success}，失败 ${fail}`);
      } else {
        this.$message.success(`同步完成：成功 ${success} 个`);
      }
      this.clearBatchPublishSelection();
    },

    submitBatchSyncEsFn(productIds) {
      const ids = productIds && productIds.length ? productIds : this.getBatchSyncEsProductIds();
      if (!ids.length) {
        this.$message.warning("请勾选已生成商品的行");
        return;
      }
      this.batchSyncEsSubmitting = true;
      this.$https(this.$api.api.syncSecondhandProductEsBatch, { ids }, "POST")
        .then((res) => {
          if (res && res.data && res.data.code == 200) {
            const data = res.data.data || {};
            const success = Number(data.successCount) || 0;
            const fail = Number(data.failCount) || 0;
            this.showBatchSyncEsResult(success, fail);
            return false;
          }
          if (this.isSyncEsBatchApiMissing(res)) {
            return true;
          }
          this.$message.error((res && res.data && res.data.msg) || "同步ES失败");
          return false;
        })
        .catch((err) => {
          if (this.isSyncEsBatchApiMissing(err)) {
            return true;
          }
          this.$message.error("同步ES失败");
          return false;
        })
        .then((needFallback) => {
          if (!needFallback) return null;
          this.$message.info("批量同步接口不可用，改为逐条同步");
          return this.submitSyncEsOneByOneFn(ids);
        })
        .finally(() => {
          this.batchSyncEsSubmitting = false;
        });
    },

    /** 批量接口不可用时的兜底：逐条调用单条同步（loading 由调用方管理） */
    async submitSyncEsOneByOneFn(productIds) {
      const ids = productIds && productIds.length ? productIds : this.getBatchSyncEsProductIds();
      if (!ids.length) {
        this.$message.warning("请勾选已生成商品的行");
        return;
      }
      let success = 0;
      let fail = 0;
      for (const id of ids) {
        try {
          const res = await this.$https(this.$api.api.syncSecondhandProductEs, { id }, "POST");
          if (res && res.data && res.data.code == 200) {
            success++;
          } else {
            fail++;
          }
        } catch (e) {
          fail++;
        }
      }
      this.showBatchSyncEsResult(success, fail);
    },

    clearBatchPublishSelection() {
      this.batchPublishSelection = [];
      const table = this.$refs.productTable;
      if (table && table.clearSelection) {
        table.clearSelection();
      }
    },

    buildOfficialConsignListQuery(options = {}) {
      const { includePaging = false, page, size } = options;
      const obj = {
        productType: this.listProductType,
      };
      if (includePaging) {
        obj.page = page || 1;
        obj.size = size || this.pageSize;
      }
      if (this.activeMainTab === "audit") {
        obj.status = 4;
      } else if (this.isOfficialConsignList) {
        const stage = this.officialConsignStageTab;
        if (stage) {
          // 具体阶段 Tab：按 Tab 固定筛选
          obj.consignStage = stage;
        } else if (this.query.consignStage) {
          // 「全部」Tab：用筛选框状态过滤
          obj.consignStage = this.query.consignStage;
        }
      } else if (this.query.status != null) {
        obj.status = this.query.status;
      }
      if (this.query.title) obj.title = this.query.title;
      const nick = String(this.query.sellerNickName || "").trim();
      if (nick) {
        if (this.isOfficialConsignList) {
          obj.consignorKeyword = nick;
        } else {
          obj.sellerNickName = nick;
        }
      }
      if (this.isOfficialConsignList) {
        this.appendOfficialConsignQueryFilters(obj);
      } else {
        const productNo = String(this.query.productNo || "").trim();
        if (productNo) obj.filterProductNo = productNo;
      }
      return obj;
    },

    getBatchPublishOrderIds() {
      return (this.batchPublishSelection || [])
        .filter((r) => this.canBatchPublishRow(r))
        .map((r) => r.sourceXwOrderId)
        .filter(Boolean);
    },

    openBatchPublishConfirm() {
      if (this.batchPublishSubmitting) return;
      const orderIds = this.getBatchPublishOrderIds();
      if (!orderIds.length) {
        this.$message.warning("请勾选可一键上架的自动上架寄售单");
        return;
      }
      this.batchPublishPendingCount = orderIds.length;
      this.batchPublishMode = "immediate";
      this.batchPublishAt = "";
      this.batchPublishDialogVisible = true;
    },

    onBatchPublishDialogClosed() {
      this.batchPublishMode = "immediate";
      this.batchPublishAt = "";
      this.batchPublishPendingCount = 0;
    },

    confirmBatchPublishDialog() {
      if (this.batchPublishSubmitting) return;
      if (this.batchPublishMode === "scheduled") {
        if (!this.batchPublishAt) {
          this.$message.warning("请选择上架时间");
          return;
        }
        const at = new Date(String(this.batchPublishAt).replace(/-/g, "/"));
        if (Number.isNaN(at.getTime()) || at.getTime() <= Date.now()) {
          this.$message.warning("上架时间需晚于当前时间");
          return;
        }
      }
      this.submitBatchPublishFn(
        this.batchPublishMode === "scheduled" ? this.batchPublishAt : null
      );
    },

    submitBatchPublishFn(publishAt) {
      const orderIds = this.getBatchPublishOrderIds();
      if (!orderIds.length) {
        this.batchPublishSubmitting = false;
        this.$message.warning("请勾选可一键上架的自动上架寄售单");
        return;
      }
      this.batchPublishSubmitting = true;
      const payload = { orderIds, autoListOnly: true };
      if (publishAt) {
        payload.publishAt = publishAt;
      }
      let mode = publishAt ? "scheduled" : "immediate";
      let success = 0;
      let scheduled = 0;
      let fail = 0;
      const failMessages = [];
      let successItems = [];
      let resultPublishAt = publishAt || "";

      this.$https(this.$api.api.consignmentGradeBatchPublish, payload, "POST")
        .then((res) => {
          if (res.data && res.data.code == 200 && res.data.data) {
            mode = res.data.data.mode || mode;
            success += Number(res.data.data.successCount) || 0;
            scheduled += Number(res.data.data.scheduledCount) || 0;
            fail += Number(res.data.data.failCount) || 0;
            if (res.data.data.publishAt) {
              resultPublishAt = res.data.data.publishAt;
            }
            if (Array.isArray(res.data.data.failMessages)) {
              failMessages.push(...res.data.data.failMessages);
            }
            if (Array.isArray(res.data.data.successItems)) {
              successItems = res.data.data.successItems;
            }
          } else {
            fail += orderIds.length;
            failMessages.push((res.data && res.data.msg) || "批量上架失败");
          }
          return mode === "immediate" ? successItems : [];
        })
        .then((items) => {
          if (items && items.length) {
            return this.exportBatchPublishResultExcel(items);
          }
          return null;
        })
        .then(() => {
          this.batchPublishDialogVisible = false;
          const detail = failMessages.slice(0, 3).join("；");
          if (mode === "scheduled") {
            if (scheduled === 0 && fail === 0) {
              this.$message.info("未预约任何商品");
              return;
            }
            if (fail > 0) {
              this.$message.warning(
                `预约完成：成功 ${scheduled}，失败 ${fail}${detail ? "（" + detail + "）" : ""}${
                  resultPublishAt ? "，将于 " + resultPublishAt + " 上架" : ""
                }`
              );
            } else {
              this.$message.success(
                `已预约 ${scheduled} 单${resultPublishAt ? "，将于 " + resultPublishAt + " 上架" : ""}`
              );
            }
            return;
          }
          if (success === 0 && fail === 0) {
            this.$message.info("未上架任何商品");
            return;
          }
          if (fail > 0) {
            this.$message.warning(
              `上架完成：成功 ${success}，失败 ${fail}${detail ? "（" + detail + "）" : ""}${
                success > 0 ? "，已导出成功明细" : ""
              }`
            );
          } else {
            this.$message.success(`上架完成：成功 ${success} 单，已导出成功明细`);
          }
        })
        .finally(() => {
          this.clearBatchPublishSelection();
          this.fetchList(this.currentPage);
          this.batchPublishSubmitting = false;
        });
    },

    exportBatchPublishResultExcel(items) {
      if (!items || !items.length) {
        return Promise.resolve();
      }
      return this.$https(this.$api.api.exportConsignmentBatchPublishResult, items, "FILE")
        .then((res) => {
          if (!res.data) {
            this.$message.warning("上架成功，但导出明细失败");
            return;
          }
          const blob = new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          const now = new Date();
          const timeStr = `${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, "0")}${String(now.getDate()).padStart(2, "0")}${String(now.getHours()).padStart(2, "0")}${String(now.getMinutes()).padStart(2, "0")}${String(now.getSeconds()).padStart(2, "0")}`;
          link.download = `一键上架记录_${timeStr}.xlsx`;
          link.click();
          window.URL.revokeObjectURL(url);
        })
        .catch(() => {
          this.$message.warning("上架成功，但导出明细失败");
        });
    },

    publishOrphanOfficialConsignProduct(row, price) {
      if (!row || !row.id) {
        return Promise.resolve(false);
      }
      const priceReq = {
        id: row.id,
        consignorUserId: row.consignorUserId,
        price,
      };
      return this.$https(this.$api.api.updateConsignorSecondhandPrice, priceReq, "POST")
        .then((res) => {
          if (!(res.data && res.data.code == 200)) {
            this.$message.error((res.data && res.data.msg) || "定价失败");
            return false;
          }
          return this.$https(this.$api.api.getSecondhandProductById, { id: row.id }, "GET");
        })
        .then((res) => {
          if (res === false) return false;
          if (!(res.data && res.data.code == 200 && res.data.data)) {
            this.$message.error((res.data && res.data.msg) || "加载商品失败");
            return false;
          }
          const full = res.data.data;
          full.status = 1;
          return this.$https(this.$api.api.updateSecondhandProduct, full, "POST");
        })
        .then((res) => {
          if (res === false) return false;
          if (res.data && res.data.code == 200) {
            return true;
          }
          this.$message.error((res.data && res.data.msg) || "上架失败");
          return false;
        })
        .catch(() => false);
    },

    formatTime(t) {
      if (!t) return "-";
      try {
        return returnTime(t, "-", "s");
      } catch (e) {
        return String(t);
      }
    },

    labelInList(value, list) {
      if (value == null || value === "") return "-";
      const item = (list || []).find((x) => x.value === value);
      return item ? item.label : String(value);
    },

    conditionLabel(level) {
      return this.labelInList(level, this.conditionList);
    },

    formatMoney(v) {
      if (v == null || v === "") return "-";
      const n = Number(v);
      if (Number.isNaN(n)) return String(v);
      return n.toFixed(2);
    },

    formatCapacityMl(v) {
      if (v == null || v === "") return "-";
      const s = String(v).trim();
      if (!s) return "-";
      return /ml$/i.test(s) ? s : s + "ml";
    },

    /** 官方寄售补贴期：挂牌价高于买家价时返回划线价 */
    resolveListingStrikePrice(row) {
      if (!row) return null;
      const listing = Number(row.consignListingPrice);
      const buyer = Number(row.price);
      if (!Number.isFinite(listing) || !Number.isFinite(buyer) || listing <= buyer) {
        return null;
      }
      return listing;
    },

    resolveInspectionSeq(row) {
      if (!row) return "";
      const seq = String(row.inspectionSeq || "").trim();
      if (seq) return seq;
      const no = String(row.inspectionNo || "").trim();
      if (no) {
        const parts = no.split("-");
        return parts.length >= 3 ? parts.slice(0, 3).join("-") : no;
      }
      const raw = row.attrJson;
      if (!raw) return "";
      try {
        const obj = isJSON(raw) ? JSON.parse(raw) : null;
        const src = obj && (obj.sourceInspectionNo || obj.source_inspection_no);
        return src != null && String(src).trim() ? String(src).trim() : "";
      } catch (e) {
        return "";
      }
    },

    resolveImportCode(row) {
      if (!row) return "";
      const direct = String(row.importCode || "").trim();
      if (direct) return direct;
      const raw = row.attrJson;
      if (!raw) return "";
      try {
        const obj = isJSON(raw) ? JSON.parse(raw) : null;
        const code = obj && (obj.importCode || obj.import_code);
        return code != null && String(code).trim() ? String(code).trim() : "";
      } catch (e) {
        return "";
      }
    },

    /**
     * 解析闲鱼 itemId：优先后端 goofishShopListings（listing_sync 多店权威），再兜底 attr.goofishByAccount / 扁平字段。
     * 拍卖中 Tab：只展示拍卖槽自建 id（B），不回退出站 A。
     * @returns {{ shop: string, shopShort: string, itemId: string }[]}
     */
    resolveXianyuItemEntries(row) {
      if (!row) return [];
      const auctionOnly = this.isAuctionTab
        || Number(row.status) === 8
        || row.consignStage === "IN_AUCTION";
      const seen = new Set();
      const entries = [];
      const push = (shop, itemId) => {
        const id = itemId != null ? String(itemId).trim() : "";
        if (!id || seen.has(id)) return;
        seen.add(id);
        const shopFull = shop != null ? String(shop).trim() : "";
        entries.push({
          shop: shopFull,
          shopShort: shopFull
            ? shopFull.length > 10
              ? `${shopFull.slice(0, 4)}…${shopFull.slice(-4)}`
              : shopFull
            : "",
          itemId: id,
        });
      };
      const pickListingId = (l) => {
        if (!l) return "";
        const auctionId = l.auctionXianyuItemId
          || l.auction_xianyu_item_id
          || (l.auctionGoofishProductId != null ? String(l.auctionGoofishProductId) : "")
          || (l.auction_goofish_product_id != null ? String(l.auction_goofish_product_id) : "");
        if (auctionOnly) {
          return String(auctionId || "").trim();
        }
        const outboundId = l.xianyuItemId
          || l.xianyu_item_id
          || (l.goofishProductId != null ? String(l.goofishProductId) : "");
        return String(outboundId || "").trim();
      };
      const pickAttrShopId = (shop) => {
        if (!shop || typeof shop !== "object") return "";
        const auctionNative = shop.auctionNative || shop.auction_native;
        const auctionId = auctionNative && typeof auctionNative === "object"
          ? (auctionNative.xianyuItemId || auctionNative.xianyu_item_id
            || auctionNative.goofishProductId || auctionNative.goofish_product_id || "")
          : "";
        const rootSrc = String(shop.linkSource || shop.link_source || "").trim().toLowerCase();
        const outboundId = shop.xianyuItemId || shop.xianyu_item_id || shop.goofishProductId || "";
        if (auctionOnly) {
          if (auctionId) return String(auctionId).trim();
          // 旧版把 B 写在根上并打 native
          if (rootSrc === "native" && outboundId) return String(outboundId).trim();
          return "";
        }
        if (rootSrc === "native") return "";
        return String(outboundId || "").trim();
      };

      const listings = row.goofishShopListings;
      if (Array.isArray(listings) && listings.length) {
        listings.forEach((l) => {
          if (!l) return;
          const shopLabel = l.accountName
            ? `${l.accountName}${l.userName ? "·" + l.userName : ""}`
            : l.userName || "";
          push(shopLabel, pickListingId(l));
        });
        if (entries.length) return entries;
      }

      let attr = null;
      if (row.attrJson) {
        try {
          attr = isJSON(row.attrJson) ? JSON.parse(row.attrJson) : null;
        } catch (e) {
          attr = null;
        }
      }

      const byAccount = attr && (attr.goofishByAccount || attr.goofish_by_account);
      if (byAccount && typeof byAccount === "object") {
        Object.keys(byAccount).forEach((key) => {
          const shop = byAccount[key];
          const shopLabel = /^\d+$/.test(String(key)) ? "" : String(key);
          push(shopLabel, pickAttrShopId(shop));
        });
      }

      if (!auctionOnly) {
        const flat =
          (row.xianyuItemId && String(row.xianyuItemId).trim()) ||
          (attr && (attr.xianyuItemId || attr.xianyu_item_id));
        if (flat) push("", flat);
      }

      return entries;
    },

    resolveXianyuItemId(row) {
      const entries = this.resolveXianyuItemEntries(row);
      if (!entries.length) return "";
      return entries.map((e) => (e.shop ? `${e.shop}:${e.itemId}` : e.itemId)).join(" / ");
    },

    /** 闲鱼历史导入（attr.importSource=xianyu）；出站同步写入的 xianyuItemId 不算导入 */
    isImportedFromXianyu(row) {
      if (!row) return false;
      const raw = row.attrJson;
      if (!raw) return false;
      try {
        const obj = isJSON(raw) ? JSON.parse(raw) : null;
        const src = obj && (obj.importSource || obj.import_source);
        return String(src || "").trim().toLowerCase() === "xianyu";
      } catch (e) {
        return false;
      }
    },

    formatPercent(v) {
      if (v == null || v === "") return "-";
      const n = Number(v);
      if (Number.isNaN(n)) return String(v);
      return `${(n * 100).toFixed(0)}%`;
    },

    yesNoLabel(v) {
      if (v === 1 || v === true) return "是";
      if (v === 0 || v === false) return "否";
      return "-";
    },

    detailTooltipContent(val) {
      if (val == null || val === "") return "-";
      return String(val);
    },

    detailTooltipDisabled(val) {
      return val == null || String(val).trim() === "";
    },

    imageList(imagesStr) {
      if (!imagesStr) return [];
      try {
        if (isJSON(imagesStr)) {
          const arr = JSON.parse(imagesStr);
          return Array.isArray(arr) ? arr : [];
        }
      } catch (e) {}
      // 兼容逗号分隔
      return String(imagesStr)
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean);
    },

    /** 解析商品余量图（remainImages 列表或 remainImgs JSON/逗号串） */
    parseRemainImageUrls(product) {
      const info = product || {};
      let raw = info.remainImages;
      if (!raw && info.remainImgs) {
        raw = info.remainImgs;
      }
      if (!raw) return [];
      if (Array.isArray(raw)) {
        return raw.map((v) => String(v || "").trim()).filter(Boolean);
      }
      if (typeof raw === "string") {
        try {
          if (isJSON(raw)) {
            const parsed = JSON.parse(raw);
            if (Array.isArray(parsed)) {
              return parsed.map((v) => String(v || "").trim()).filter(Boolean);
            }
          }
        } catch (e) {
          /* fallthrough */
        }
        return raw
          .split(",")
          .map((s) => s.trim())
          .filter(Boolean);
      }
      return [];
    },

    firstImage(imagesStr) {
      const arr = this.imageList(imagesStr);
      return arr.length ? this.$assetUrl(arr[0]) : "";
    },

    previewFn(url) {
      if (!url) return;
      window.open(url);
    },

    /** 寄售单详情图库下载前缀：品牌-型号-寄售用户-图类型 */
    consignOrderImagesDownloadNameBase(kind) {
      const row = this.consignOrderDetailRow;
      const consignorRaw =
        (row && (row.consignorNickName || row.consignorScentId || row.consignorRealName)) ||
        (row && row.consignorUserId != null ? String(row.consignorUserId) : "") ||
        "未知用户";
      return joinDownloadNameParts(
        this.consignOrderDetailBrandName || "未知品牌",
        this.consignOrderDetailTypeName || "未知型号",
        consignorRaw,
        kind || "图"
      );
    },

    /** 审核弹窗：商品描述展示 */
    auditDescriptionDisplay(row) {
      if (!row || row.description == null) return "-";
      const s = String(row.description).trim();
      return s || "-";
    },

    defaultQuery() {
      return {
        status: null,
        consignStage: null,
        title: "",
        sellerNickName: "",
        linkStatus: 0,
        productNo: "",
        consignOrderNo: "",
        inspectionSeq: "",
        shelfNo: "",
        importCode: "",
        xianyuItemId: "",
        gradeLevel: "",
        brandKeyword: "",
        xianyuOnly: 0,
        autoList: null,
        inspectionTimeRange: null,
      };
    },

    appendOfficialConsignQueryFilters(obj) {
      const q = this.query;
      if (q.linkStatus === 1) obj.filterUnlinkedSourceXwOrder = 1;
      if (q.linkStatus === 2) obj.filterLinkedSourceXwOrder = 1;
      const productNo = String(q.productNo || "").trim();
      if (productNo) obj.filterProductNo = productNo;
      const consignOrderNo = String(q.consignOrderNo || "").trim();
      if (consignOrderNo) obj.filterSourceConsignOrderNo = consignOrderNo;
      const inspectionSeq = String(q.inspectionSeq || "").trim();
      if (inspectionSeq) obj.filterInspectionSeq = inspectionSeq;
      const shelfNo = String(q.shelfNo || "").trim();
      if (shelfNo) obj.filterSourceConsignShelfNo = shelfNo;
      const importCode = String(q.importCode || "").trim();
      if (importCode) obj.filterImportCode = importCode;
      const xianyuItemId = String(q.xianyuItemId || "").trim();
      if (xianyuItemId) obj.filterXianyuItemId = xianyuItemId;
      if (q.gradeLevel) obj.gradeLevel = q.gradeLevel;
      const brandKeyword = String(q.brandKeyword || "").trim();
      if (brandKeyword) obj.filterBrandKeyword = brandKeyword;
      if (q.xianyuOnly === 1) obj.filterXianyuImportOnly = 1;
      if (q.autoList === 0 || q.autoList === 1) obj.filterAutoList = q.autoList;
      if (Array.isArray(q.inspectionTimeRange) && q.inspectionTimeRange.length === 2) {
        const [startDate, endDate] = q.inspectionTimeRange;
        if (startDate) obj.filterInspectionTimeStart = `${startDate} 00:00:00`;
        if (endDate) obj.filterInspectionTimeEnd = `${endDate} 23:59:59`;
      }
    },

    handleMainTabClick() {
      this.currentPage = 1;
      // 切到具体阶段 Tab 时清空筛选框状态，避免残留条件干扰
      if (this.isOfficialConsignList && this.activeMainTab !== "all") {
        this.query.consignStage = null;
      }
      this.fetchList(1);
    },

    isOfficialConsignStageName(name) {
      if (!name || name === "all" || name === "audit") return false;
      return (this.officialConsignMainTabs || []).some((t) => t.name === name);
    },

    resetFn() {
      this.query = this.defaultQuery();
      this.fetchList(1);
      this.currentPage = 1;
    },

    searchFn() {
      this.fetchList(1);
      this.currentPage = 1;
    },

    changePage(p) {
      this.fetchList(p);
    },

    handlePageSizeChange() {
      this.fetchList(this.currentPage);
      this.syncTableMaxHeight();
    },

    fetchList(page) {
      this.loading = true;
      const obj = this.buildOfficialConsignListQuery({
        includePaging: true,
        page: page || 1,
        size: this.pageSize,
      });

      this.$https(this.$api.api.selSecondhandProduct, obj, "POST")
        .then((res) => {
          if (res.data && res.data.code == 200) {
            this.tableData = res.data.data || [];
            this.tableTotal = res.data.size || 0;
          } else {
            this.tableData = [];
            this.tableTotal = 0;
            this.$message.error((res.data && res.data.msg) || "查询失败");
          }
        })
        .finally(() => {
          this.loading = false;
          this.syncTableMaxHeight();
          this.clearBatchPublishSelection();
        });
    },

    /** 表格铺满筛选区与底部分页之间的剩余空间；略留余量避免 fixed 列把滚动条裁掉 */
    syncTableMaxHeight() {
      this.$nextTick(() => {
        const wrap = this.$el && this.$el.querySelector(".secondhand-list-table-wrap");
        if (!wrap) return;
        const h = Math.floor(wrap.getBoundingClientRect().height);
        if (h < 80) return;
        const next = Math.max(420, h - 16);
        if (next === this.tableMaxHeight) return;
        this.tableMaxHeight = next;
        this.$nextTick(() => {
          const table = this.$refs.productTable;
          if (table && typeof table.doLayout === "function") {
            table.doLayout();
          }
        });
      });
    },

    bindTableResizeObserver() {
      if (typeof ResizeObserver === "undefined") return;
      this.$nextTick(() => {
        const wrap = this.$el && this.$el.querySelector(".secondhand-list-table-wrap");
        if (!wrap) return;
        this._tableResizeObserver = new ResizeObserver(() => {
          this.syncTableMaxHeight();
        });
        this._tableResizeObserver.observe(wrap);
      });
    },

    unbindTableResizeObserver() {
      if (this._tableResizeObserver) {
        this._tableResizeObserver.disconnect();
        this._tableResizeObserver = null;
      }
    },

    productExportFn() {
      const obj = this.buildOfficialConsignListQuery();

      this.$https(this.$api.api.exportSecondhandProduct, obj, "FILE").then((res) => {
        if (res.data) {
          const blob = new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          const now = new Date();
          const timeStr = `${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, '0')}${String(now.getDate()).padStart(2, '0')}${String(now.getHours()).padStart(2, '0')}${String(now.getMinutes()).padStart(2, '0')}${String(now.getSeconds()).padStart(2, '0')}`;
          link.download = `平台寄售商品_${timeStr}.xlsx`;
          link.click();
          window.URL.revokeObjectURL(url);
          this.$message.success("导出成功");
        }
      }).catch((err) => {
        this.$message.error("导出失败：" + (err.message || "网络错误"));
      });
    },

    downloadGoofishAuctionTemplateFn() {
      this.$https(this.$api.api.downloadGoofishAuctionImportTemplate, {}, "FILE")
        .then((res) => {
          if (!res.data) {
            this.$message.error("模板下载失败");
            return;
          }
          const blob = new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = "闲鱼拍卖导入模板.xlsx";
          link.click();
          window.URL.revokeObjectURL(url);
          this.$message.success("模板下载成功");
        })
        .catch((err) => {
          this.$message.error("模板下载失败：" + (err.message || "网络错误"));
        });
    },

    handleToolbarImportCommand(command) {
      if (command === "consignLinkImport") {
        this.consignLinkImportVisible = true;
        return;
      }
      if (command === "goofishAuctionImport") {
        this.goofishAuctionImportVisible = true;
        return;
      }
      if (command === "downloadAuctionTemplate") {
        this.downloadGoofishAuctionTemplateFn();
        return;
      }
      if (command === "exportProduct") {
        this.productExportFn();
      }
    },

    handleToolbarBatchCommand(command) {
      if (command === "batchGoofishSync") {
        if (!this.batchGoofishSyncSelectedCount) {
          this.$message.warning("请先勾选要同步的商品");
          return;
        }
        this.openBatchGoofishSyncConfirm();
        return;
      }
      if (command === "syncAllGoofish") {
        this.openSyncAllGoofishConfirm();
        return;
      }
      if (command === "syncAllFreight") {
        this.openSyncAllFreightConfirm();
        return;
      }
      if (command === "cancelSchedule") {
        if (!this.cancelScheduleSelectedCount) {
          this.$message.warning("请先勾选要取消预约的商品");
          return;
        }
        this.openCancelScheduleConfirm();
        return;
      }
      if (command === "syncEs") {
        if (!this.batchSyncEsSelectedCount) {
          this.$message.warning("请先勾选要同步的商品");
          return;
        }
        this.openBatchSyncEsConfirm();
      }
    },

    detailFn(row) {
      if (!row) return;
      if (this.isOfficialConsignList && this.isOfficialConsignOrderRow(row)) {
        this.openConsignOrderDetail(row);
        return;
      }
      if (!row.id) {
        this.$message.warning("暂无详情");
        return;
      }
      this.openProductDetail(row.id, row);
    },

    openProductDetail(id, listRow) {
      this.detailVisible = true;
      this.detail = null;
      this.detailLoading = true;
      this.$https(this.$api.api.getSecondhandProductById, { id }, "GET")
        .then((res) => {
          if (res.data && res.data.code == 200) {
            const data = res.data.data || {};
            if (listRow) {
              if (listRow.consignStage && !data.consignStage) data.consignStage = listRow.consignStage;
              if (listRow.gradeLevel && !data.gradeLevel) data.gradeLevel = listRow.gradeLevel;
            }
            this.detail = data;
          } else {
            this.$message.error((res.data && res.data.msg) || "查询详情失败");
            this.detailVisible = false;
          }
        })
        .finally(() => {
          this.detailLoading = false;
        });
    },

    openConsignOrderDetail(row) {
      const orderId = row && row.sourceXwOrderId;
      if (!orderId) {
        this.$message.warning("缺少寄售子单信息");
        return;
      }
      this.consignOrderDetailVisible = true;
      this.consignOrderDetailLoading = true;
      this.consignOrderDetail = null;
      this.consignOrderDetailRow = { ...row };
      this.$https(this.$api.api.consignmentGradeContext, { orderId }, "GET")
        .then((res) => {
          if (res.data && res.data.code == 200) {
            this.consignOrderDetail = res.data.data || {};
          } else {
            this.$message.error((res.data && res.data.msg) || "加载寄售单详情失败");
            this.consignOrderDetailVisible = false;
          }
        })
        .finally(() => {
          this.consignOrderDetailLoading = false;
        });
    },

    onConsignOrderDetailClosed() {
      this.consignOrderDetail = null;
      this.consignOrderDetailRow = null;
    },

    goConsignGradeFromOrderDetail() {
      if (!this.consignOrderDetailRow) return;
      this.consignOrderDetailVisible = false;
      this.goConsignGrade(this.consignOrderDetailRow);
    },

    openAutoListPriceFromOrderDetail() {
      if (!this.consignOrderDetailRow) return;
      const row = this.consignOrderDetailRow;
      this.consignOrderDetailVisible = false;
      this.openAutoListPriceDialog(row);
    },

    openConsignPublishFromOrderDetail() {
      if (!this.consignOrderDetailRow) return;
      const row = this.consignOrderDetailRow;
      this.consignOrderDetailVisible = false;
      this.openConsignPublishDialog(row);
    },

    /** 已生成闲置商品的行可手动同步 ES（寄售子单 ORDER 行无商品则不可） */
    canSyncEsEntry(row) {
      if (!row || !row.id) return false;
      if (this.isOfficialConsignOrderRow(row)) return false;
      return true;
    },

    /** 官方寄售在售商品可手动同步闲鱼（含闲鱼导入、已上架，便于刷新闲鱼链接） */
    canShowGoofishSyncEntry(row) {
      if (!this.isOfficialConsignList || !row || !row.id) return false;
      if (this.isOfficialConsignOrderRow(row)) return false;
      if (row.status !== 1) return false;
      return true;
    },

    getBatchGoofishProductIds() {
      return (this.batchPublishSelection || [])
        .filter((r) => this.canShowGoofishSyncEntry(r))
        .map((r) => r.id)
        .filter(Boolean);
    },

    openBatchGoofishSyncConfirm() {
      const ids = this.getBatchGoofishProductIds();
      if (!ids.length) {
        this.$message.warning("请勾选在售官方寄售商品行");
        return;
      }
      this.ensureGoofishAccounts().then(() => {
        this.goofishSyncMode = "schedule";
        this.batchGoofishSyncVisible = true;
      });
    },

    submitBatchGoofishSync() {
      const ids = this.getBatchGoofishProductIds();
      if (!ids.length) {
        this.$message.warning("请勾选在售官方寄售商品行");
        return;
      }
      if (!this.goofishSyncAccountIds || !this.goofishSyncAccountIds.length) {
        this.$message.warning("请选择至少一个闲鱼店铺");
        return;
      }
      this.batchGoofishSyncSubmitting = true;
      this.$https(
        this.$api.api.goofishSyncBatch,
        {
          productIds: ids,
          accountIds: this.goofishSyncAccountIds,
          mode: this.goofishSyncMode || "schedule",
        },
        "POST"
      )
        .then((res) => {
          if (res.data && res.data.code == 200) {
            const data = res.data.data || {};
            const success = Number(data.successCount) || 0;
            const skip = Number(data.skipCount) || 0;
            const fail = Number(data.failCount) || 0;
            this.batchGoofishSyncVisible = false;
            if (fail > 0 || skip > 0) {
              this.$message.warning(
                (res.data.msg || "批量同步完成") +
                  (data.messages && data.messages.length
                    ? "：" + data.messages.slice(0, 3).join("；")
                    : "")
              );
            } else {
              this.$message.success(res.data.msg || `已成功提交 ${success} 个`);
            }
            this.clearBatchPublishSelection();
          } else {
            this.$message.error((res.data && res.data.msg) || "批量同步失败");
          }
        })
        .finally(() => {
          this.batchGoofishSyncSubmitting = false;
        });
    },

    openSyncAllGoofishConfirm() {
      this.ensureGoofishAccounts().then(() => {
        this.goofishSyncMode = "schedule";
        if (!this.syncAllGoofishLimit) this.syncAllGoofishLimit = 2000;
        this.syncAllGoofishVisible = true;
      });
    },

    openSyncAllFreightConfirm() {
      this.ensureGoofishAccounts().then(() => {
        if (!this.syncAllFreightLimit) this.syncAllFreightLimit = 2000;
        this.syncAllFreightVisible = true;
      });
    },

    submitSyncAllFreight() {
      if (!this.goofishSyncAccountIds || !this.goofishSyncAccountIds.length) {
        this.$message.warning("请选择至少一个闲鱼店铺");
        return;
      }
      const limit = Math.min(Math.max(Number(this.syncAllFreightLimit) || 2000, 1), 5000);
      this.syncAllFreightSubmitting = true;
      this.$https(
        this.$api.api.goofishSyncAllFreight,
        { limit, accountIds: this.goofishSyncAccountIds },
        "POST"
      )
        .then((res) => {
          if (res.data && res.data.code == 200) {
            const data = res.data.data || {};
            this.syncAllFreightVisible = false;
            if (data.asyncAccepted) {
              this.$message.success(
                res.data.msg ||
                  `已提交后台运费修复，共扫描 ${Number(data.total) || 0} 条，请稍后在闲鱼同步列表查看`
              );
              return;
            }
            const success = Number(data.successCount) || 0;
            const skip = Number(data.skipCount) || 0;
            const fail = Number(data.failCount) || 0;
            const tip = res.data.msg || `扫描完成：成功 ${success}，跳过 ${skip}，失败 ${fail}`;
            if (fail > 0) {
              this.$message.warning(
                tip +
                  (data.messages && data.messages.length
                    ? "：" + data.messages.slice(0, 3).join("；")
                    : "")
              );
            } else {
              this.$message.success(tip);
            }
          } else {
            this.$message.error((res.data && res.data.msg) || "运费修复失败");
          }
        })
        .finally(() => {
          this.syncAllFreightSubmitting = false;
        });
    },

    submitSyncAllGoofish() {
      if (!this.goofishSyncAccountIds || !this.goofishSyncAccountIds.length) {
        this.$message.warning("请选择至少一个闲鱼店铺");
        return;
      }
      const mode = this.goofishSyncMode || "schedule";
      const limit = Math.min(Math.max(Number(this.syncAllGoofishLimit) || 2000, 1), 5000);
      this.syncAllGoofishSubmitting = true;
      this.$https(
        this.$api.api.goofishSyncAllOnSale,
        { mode, limit, accountIds: this.goofishSyncAccountIds },
        "POST"
      )
        .then((res) => {
          if (res.data && res.data.code == 200) {
            const data = res.data.data || {};
            this.syncAllGoofishVisible = false;
            if (data.asyncAccepted) {
              this.$message.success(
                res.data.msg ||
                  `已提交后台同步，共 ${Number(data.total) || 0} 条，请稍后在闲鱼同步列表查看`
              );
              return;
            }
            const success = Number(data.successCount) || 0;
            const skip = Number(data.skipCount) || 0;
            const fail = Number(data.failCount) || 0;
            const tip = res.data.msg || `扫描完成：成功 ${success}，跳过 ${skip}，失败 ${fail}`;
            if (fail > 0) {
              this.$message.warning(
                tip +
                  (data.messages && data.messages.length
                    ? "：" + data.messages.slice(0, 3).join("；")
                    : "")
              );
            } else {
              this.$message.success(tip);
            }
          } else {
            this.$message.error((res.data && res.data.msg) || "全量同步失败");
          }
        })
        .finally(() => {
          this.syncAllGoofishSubmitting = false;
        });
    },

    ensureGoofishAccounts() {
      return this.$https(this.$api.api.goofishAccountListEnabled, {}, "GET").then((res) => {
        if (res.data && res.data.code == 200) {
          this.goofishAccountOptions = res.data.data || [];
          // 默认勾选全部启用店铺（与自动同步一致，可再取消）
          if (!this.goofishSyncAccountIds || !this.goofishSyncAccountIds.length) {
            this.goofishSyncAccountIds = this.goofishAccountOptions.map((a) => a.id).filter(Boolean);
          }
          if (!this.goofishAccountOptions.length) {
            this.$message.warning("请先在「闲鱼店铺账号」中配置启用中的店铺");
          }
        } else {
          this.goofishAccountOptions = [];
          this.$message.error((res.data && res.data.msg) || "加载闲鱼店铺失败");
        }
      });
    },

    openGoofishSyncDialog(row) {
      if (!this.canShowGoofishSyncEntry(row)) return;
      this.ensureGoofishAccounts().then(() => {
        this.goofishSyncRow = row;
        this.goofishSyncMode = "schedule";
        this.goofishSyncVisible = true;
      });
    },

    submitGoofishSync() {
      if (!this.goofishSyncRow || !this.goofishSyncRow.id) return;
      if (!this.goofishSyncAccountIds || !this.goofishSyncAccountIds.length) {
        this.$message.warning("请选择至少一个闲鱼店铺");
        return;
      }
      const productId = this.goofishSyncRow.id;
      const api =
        this.goofishSyncMode === "now"
          ? this.$api.api.goofishSyncPublishNow
          : this.$api.api.goofishSyncSchedulePublish;
      this.goofishSyncLoading = true;
      this.$https(api, { productId, accountIds: this.goofishSyncAccountIds }, "POST")
        .then((res) => {
          if (res.data && res.data.code == 200) {
            this.$message.success((res.data && res.data.msg) || "操作成功");
            this.goofishSyncVisible = false;
          } else {
            this.$message.error((res.data && res.data.msg) || "操作失败");
          }
        })
        .finally(() => {
          this.goofishSyncLoading = false;
        });
    },

    offlineProductFn(row) {
      if (!row || !row.id) return;
      this.$confirm("确定下架该商品吗？下架后前台将不再展示。", "提示", { type: "warning" })
        .then(() => {
          this.shelfActionId = row.id;
          return this.$https(this.$api.api.offlineSecondhandProduct, { id: row.id }, "GET");
        })
        .then((res) => {
          if (res.data && res.data.code == 200) {
            this.$message.success("下架成功");
            this.fetchList(this.currentPage);
          } else {
            this.$message.error((res.data && res.data.msg) || "下架失败");
          }
        })
        .catch(() => {})
        .finally(() => {
          this.shelfActionId = null;
        });
    },

    startAuctionFn(row) {
      if (!row || !row.id) return;
      this.$confirm("确定将该商品设为拍卖中吗？小程序将不可购买，用户端显示「拍卖中」。", "提示", { type: "warning" })
        .then(() => {
          this.shelfActionId = row.id;
          return this.$https(this.$api.api.startSecondhandAuction, { id: row.id }, "GET");
        })
        .then((res) => {
          if (res.data && res.data.code == 200) {
            this.$message.success((res.data && res.data.msg) || "已设为拍卖中");
            this.fetchList(this.currentPage);
          } else {
            this.$message.error((res.data && res.data.msg) || "操作失败");
          }
        })
        .catch(() => {})
        .finally(() => {
          this.shelfActionId = null;
        });
    },

    endAuctionFn(row) {
      if (!row || !row.id) return;
      this.$confirm("确定结束拍卖并恢复上架吗？恢复后小程序可正常购买。", "提示", { type: "warning" })
        .then(() => {
          this.shelfActionId = row.id;
          return this.$https(this.$api.api.endSecondhandAuction, { id: row.id }, "GET");
        })
        .then((res) => {
          if (res.data && res.data.code == 200) {
            this.$message.success((res.data && res.data.msg) || "已恢复上架");
            this.fetchList(this.currentPage);
          } else {
            this.$message.error((res.data && res.data.msg) || "操作失败");
          }
        })
        .catch(() => {})
        .finally(() => {
          this.shelfActionId = null;
        });
    },

    deleteProductFn(row) {
      if (!row || !row.id) return;
      if (!this.canShowConsignDeleteEntry(row)) {
        this.$message.warning("该商品已删除");
        return;
      }
      const st = Number(row.status);
      let confirmMsg = "确定删除该商品吗？删除后列表将不再展示，且不可恢复。";
      if (st === 1) {
        confirmMsg =
          "该商品当前在售，确定强制删除吗？将取消未支付订单，删除后列表不再展示且不可恢复。";
      } else if (st === 8) {
        confirmMsg =
          "该商品当前拍卖中，确定强制删除吗？将退出拍卖并从列表/搜索中移除，且不可恢复。";
      }
      this.$confirm(confirmMsg, "提示", { type: "warning" })
        .then(() => {
          this.deleteActionId = row.id;
          return this.$https(this.$api.api.deleteSecondhandProduct, { id: row.id }, "GET");
        })
        .then((res) => {
          if (res.data && res.data.code == 200) {
            this.$message.success("删除成功");
            this.fetchList(this.currentPage);
          } else {
            this.$message.error((res.data && res.data.msg) || "删除失败");
          }
        })
        .catch(() => {})
        .finally(() => {
          this.deleteActionId = null;
        });
    },

    onlineProductFn(row) {
      if (!row || !row.id) return;
      this.$confirm("确定上架该商品吗？上架后将在前台展示。", "提示", { type: "warning" })
        .then(() => {
          this.shelfActionId = row.id;
          return this.$https(this.$api.api.getSecondhandProductById, { id: row.id }, "GET");
        })
        .then((res) => {
          if (!res.data || res.data.code != 200 || !res.data.data) {
            this.$message.error((res.data && res.data.msg) || "加载商品失败");
            return null;
          }
          const full = res.data.data;
          full.status = 1;
          return this.$https(this.$api.api.updateSecondhandProduct, full, "POST");
        })
        .then((res) => {
          if (!res) return;
          if (res.data && res.data.code == 200) {
            this.$message.success((res.data && res.data.msg) || "上架成功");
            this.fetchList(this.currentPage);
          } else {
            this.$message.error((res.data && res.data.msg) || "上架失败");
          }
        })
        .catch(() => {})
        .finally(() => {
          this.shelfActionId = null;
        });
    },

    openAuditDialog(row) {
      if (!row || !row.id) return;
      this.auditRow = row;
      this.auditRejectRemark = "";
      this.auditDialogVisible = true;
    },

    onAuditDialogClosed() {
      this.auditRow = null;
      this.auditRejectRemark = "";
      this.auditSubmitLoading = false;
    },

    submitAuditApprove() {
      if (!this.auditRow || !this.auditRow.id) return;
      const auditBy = this.getAuditBy();
      this.auditSubmitLoading = true;
      this.$https(
        this.$api.api.auditSecondhandApprove,
        { id: this.auditRow.id, auditBy: auditBy, auditRemark: "" },
        "POST"
      )
        .then((res) => {
          if (res.data && res.data.code == 200) {
            this.$message.success("审核通过");
            this.auditDialogVisible = false;
            this.fetchList(this.currentPage);
          } else {
            this.$message.error((res.data && res.data.msg) || "操作失败");
          }
        })
        .finally(() => {
          this.auditSubmitLoading = false;
        });
    },

    submitAuditReject() {
      const remark = String(this.auditRejectRemark || "").trim();
      if (!remark) {
        this.$message.error("请输入驳回原因");
        return;
      }
      if (!this.auditRow || !this.auditRow.id) return;
      const auditBy = this.getAuditBy();
      this.auditSubmitLoading = true;
      this.$https(
        this.$api.api.auditSecondhandReject,
        { id: this.auditRow.id, auditBy: auditBy, auditRemark: remark },
        "POST"
      )
        .then((res) => {
          if (res.data && res.data.code == 200) {
            this.$message.success("已驳回");
            this.auditDialogVisible = false;
            this.fetchList(this.currentPage);
          } else {
            this.$message.error((res.data && res.data.msg) || "操作失败");
          }
        })
        .finally(() => {
          this.auditSubmitLoading = false;
        });
    },

    getAuditBy() {
      // 你项目里通常把登录信息存 sessionStorage
      try {
        const u = sessionStorage.getItem("USER");
        if (u) {
          const obj = JSON.parse(u);
          return obj.nickName || obj.username || obj.account || "admin";
        }
      } catch (e) {}
      return "admin";
    },

    normalizeUploadedImageUrl(path) {
      if (!path || typeof path !== "string") return "";
      const p = path.trim();
      if (/^https?:\/\//i.test(p)) return p;
      const base = "https://hzshixiang.site";
      return p.startsWith("/") ? base + p : `${base}/${p}`;
    },

    async uploadEditImageRequest(option) {
      if (this.editImageUrls.length >= 9) {
        this.$message.warning("最多 9 张图片");
        return;
      }
      const no = `${Date.now()}_${Math.round(Math.random() * 1000)}`;
      this.editImageUploading = true;
      try {
        const result = await uploadImageWithCompressFallback(this.$https, option.file, {
          api: this.$api.api,
          no,
        });
        if (result.ok && result.path) {
          const url = this.normalizeUploadedImageUrl(String(result.path).trim());
          if (url) {
            this.editImageUrls.push(url);
            if (typeof option.onSuccess === "function") {
              option.onSuccess(result.body || { code: 0, data: result.data }, option.file);
            }
          } else {
            this.$message.error("未返回图片地址");
            if (typeof option.onError === "function") option.onError(new Error("empty url"));
          }
        } else {
          this.$message.error((result && result.msg) || "上传失败");
          if (typeof option.onError === "function") option.onError(new Error("fail"));
        }
      } catch (e) {
        this.$message.error("上传失败");
        if (typeof option.onError === "function") option.onError(new Error("network"));
      } finally {
        this.editImageUploading = false;
      }
    },

    removeEditImage(index) {
      if (index < 0 || index >= this.editImageUrls.length) return;
      this.editImageUrls.splice(index, 1);
    },

    editFn(row) {
      if (!row || !row.id) return;
      if (this.isOfficialConsignList && this.isOfficialConsignOrderRow(row)) return;
      this.editVisible = true;
      this.editLoading = true;
      this.editRaw = null;
      this.editForm = null;
      this.editImageUrls = [];
      this.$https(this.$api.api.getSecondhandProductById, { id: row.id }, "GET")
        .then((res) => {
          if (res.data && res.data.code == 200) {
            this.editRaw = res.data.data;
            this.initEditFormFromRaw();
          } else {
            this.$message.error((res.data && res.data.msg) || "加载失败");
            this.editVisible = false;
          }
        })
        .finally(() => {
          this.editLoading = false;
        });
    },

    initEditFormFromRaw() {
      const r = this.editRaw;
      if (!r) return;
      let statusVal = r.status != null ? Number(r.status) : 1;
      if (statusVal === 2) {
        statusVal = null;
        this.$message.info("当前为已售出，编辑不包含该状态，请重新选择商品状态后再保存");
      }
      // status=8 拍卖中：保留回显，状态下拉禁用，结束拍卖请用列表按钮
      let extra = {};
      try {
        if (r.attrJson && isJSON(r.attrJson)) {
          const parsed = JSON.parse(r.attrJson);
          if (parsed && parsed.attrExtra && typeof parsed.attrExtra === "object") {
            extra = parsed.attrExtra;
          }
        }
      } catch (e) {}
      let deliveryType = r.deliveryType != null ? Number(r.deliveryType) : 1;
      if (deliveryType === 3) {
        deliveryType = 1;
        this.$message.warning("同城配送已停用，已改为「快递」，请确认运费与地区");
      }
      const freightNum = r.freight != null ? Number(r.freight) : 0;
      let expressFreightMode = "free";
      if (deliveryType === 1) {
        expressFreightMode = freightNum > 0 ? "custom" : "free";
      }

      this.editForm = {
        title: r.title || "",
        description: r.description || "",
        status: statusVal,
        recallExpressNo: r.recallExpressNo != null ? String(r.recallExpressNo) : "",
        price: r.price != null ? Number(r.price) : null,
        originalPrice: r.originalPrice != null ? Number(r.originalPrice) : null,
        quantity: r.quantity != null ? Number(r.quantity) : 1,
        conditionLevel: r.conditionLevel,
        purchaseChannel: extra.purchaseChannel != null && extra.purchaseChannel !== "" ? extra.purchaseChannel : null,
        shelfLife: extra.shelfLife != null && extra.shelfLife !== "" ? extra.shelfLife : null,
        specType: extra.specType != null && extra.specType !== "" ? extra.specType : null,
        capacityMl: extra.capacityMl != null && extra.capacityMl !== "" ? String(extra.capacityMl).trim() : "",
        gender: extra.gender != null && extra.gender !== "" ? extra.gender : null,
        deliveryType,
        expressFreightMode,
        freight:
          deliveryType === 1 && expressFreightMode === "custom"
            ? freightNum > 0
              ? freightNum
              : 0.01
            : deliveryType === 1
              ? 0
              : 0,
        regionCodes: [],
        location: r.location || "",
        allowBargain: r.allowBargain === 1 || r.allowBargain === true ? 1 : 0,
        minBargainPrice: r.minBargainPrice != null ? Number(r.minBargainPrice) : null,
        depositRate: r.depositRate != null ? Number(r.depositRate) : 0.05,
        depositAmount: r.depositAmount != null ? Number(r.depositAmount) : null,
        allowInspection: r.allowInspection === 1 || r.allowInspection === true ? 1 : 0,
        inspectionFee: r.inspectionFee != null ? Number(r.inspectionFee) : null,
        importCode: this.resolveImportCode(r),
        xianyuItemId: this.resolveXianyuItemId(r),
        listingPrice: (() => {
          const cur = resolveConsignorDisplayPrice(r);
          if (cur != null && cur !== "") return Number(cur);
          return r.price != null ? Number(r.price) : null;
        })(),
        brandName: r.brandName || "",
        typeName: r.typeName || "",
      };
      this.editImageUrls = [...this.imageList(r.images)];
    },

    /** 保存时把成色 + attrExtra 写回 attrJson，并保留原 JSON 其它字段 */
    buildAttrJsonForSave(editForm, raw) {
      let base = {};
      try {
        if (raw.attrJson && isJSON(raw.attrJson)) {
          base = JSON.parse(raw.attrJson);
        }
      } catch (e) {
        base = {};
      }
      if (base == null || typeof base !== "object") base = {};
      if (base.v == null) base.v = 1;
      base.conditionLevel =
        editForm.conditionLevel != null ? editForm.conditionLevel : raw.conditionLevel != null ? raw.conditionLevel : base.conditionLevel;
      base.categoryId = raw.categoryId != null ? raw.categoryId : base.categoryId;
      base.brandId = raw.brandId != null ? raw.brandId : base.brandId;
      base.typeId = raw.typeId != null ? raw.typeId : base.typeId;
      if (raw.brandName != null && raw.brandName !== "") base.brandName = raw.brandName;
      if (raw.typeName != null && raw.typeName !== "") base.typeName = raw.typeName;
      if (editForm.brandName != null && String(editForm.brandName).trim()) {
        base.brandName = String(editForm.brandName).trim();
      }
      if (editForm.typeName != null && String(editForm.typeName).trim()) {
        base.typeName = String(editForm.typeName).trim();
      }
      if (editForm.importCode != null && String(editForm.importCode).trim()) {
        base.importCode = String(editForm.importCode).trim();
      } else if (base.importCode) {
        delete base.importCode;
      }
      if (editForm.xianyuItemId != null && String(editForm.xianyuItemId).trim()) {
        base.xianyuItemId = String(editForm.xianyuItemId).trim();
      } else if (base.xianyuItemId) {
        delete base.xianyuItemId;
      }
      const prevExtra =
        base.attrExtra && typeof base.attrExtra === "object" && !Array.isArray(base.attrExtra) ? { ...base.attrExtra } : {};
      base.attrExtra = {
        ...prevExtra,
        purchaseChannel: editForm.purchaseChannel != null && editForm.purchaseChannel !== "" ? editForm.purchaseChannel : null,
        shelfLife: editForm.shelfLife != null && editForm.shelfLife !== "" ? editForm.shelfLife : null,
        specType: editForm.specType != null && editForm.specType !== "" ? editForm.specType : null,
        capacityMl:
          editForm.capacityMl != null && String(editForm.capacityMl).trim() !== ""
            ? String(editForm.capacityMl).trim().replace(/ml$/i, "")
            : prevExtra.capacityMl != null && prevExtra.capacityMl !== ""
              ? prevExtra.capacityMl
              : null,
        gender: editForm.gender != null && editForm.gender !== "" ? editForm.gender : null,
      };
      if (base.moreExpanded == null) base.moreExpanded = 1;
      if (base.attrCardRevealedOnce == null) base.attrCardRevealedOnce = 1;
      try {
        return JSON.stringify(base);
      } catch (e) {
        return raw.attrJson || "{}";
      }
    },

    onEditAllowBargainChange(val) {
      if (val !== 1) {
        if (this.editForm) this.editForm.minBargainPrice = null;
        this.$nextTick(() => {
          if (this.$refs.editFormRef) this.$refs.editFormRef.clearValidate(["minBargainPrice"]);
        });
      }
    },

    onEditAllowInspectionChange(val) {
      if (val !== 1) {
        if (this.editForm) this.editForm.inspectionFee = null;
        this.$nextTick(() => {
          if (this.$refs.editFormRef) this.$refs.editFormRef.clearValidate(["inspectionFee"]);
        });
      }
    },

    onEditDialogClosed() {
      this.editRaw = null;
      this.editForm = null;
      this.editImageUrls = [];
      this.$nextTick(() => {
        if (this.$refs.editFormRef) {
          this.$refs.editFormRef.clearValidate();
        }
      });
    },

    formatConsignorDisplay(row) {
      if (!row) return "-";
      const parts = [];
      const nick = String(row.consignorNickName || "").trim();
      const scent = String(row.consignorScentId || "").trim();
      const real = String(row.consignorRealName || "").trim();
      const userId = row.consignorUserId;
      if (nick) parts.push(nick);
      if (scent) parts.push(scent);
      if (real) parts.push(real);
      if (userId != null && userId !== "") parts.push(String(userId));
      return parts.length ? parts.join(" - ") : "-";
    },

    /** 在售(1)或已下架(0)时可改价；待评级/待上架走专用入口，不展示改价 */
    canConsignorChangePrice(row) {
      if (!row || row.consignorUserId == null || row.consignorUserId === "") return false;
      if (this.isOfficialConsignList) {
        if (this.isOfficialConsignOrderRow(row)) return false;
        if (row.consignStage === "PENDING_GRADE" || row.consignStage === "GRADED_WAIT_LIST") {
          return false;
        }
      }
      const st = Number(row.status);
      return st === 0 || st === 1;
    },

    /**
     * 自动上架预设价：待评级/待上架且勾选自动上架的寄售子单可代改 js_price
     */
    canEditAutoListPrice(row) {
      if (!this.isOfficialConsignList || !row || !row.sourceXwOrderId) return false;
      if (!this.isAutoListRow(row)) return false;
      return row.consignStage === "PENDING_GRADE" || row.consignStage === "GRADED_WAIT_LIST";
    },

    openAutoListPriceDialog(row) {
      if (!this.canEditAutoListPrice(row)) {
        this.$message.warning("当前状态不可修改预设售价");
        return;
      }
      const cur = this.resolveBatchPublishListingPrice(row);
      this.autoListPriceRow = { ...row };
      this.autoListPriceForm = {
        listingPrice: cur != null ? cur : null,
      };
      this.autoListPriceVisible = true;
    },

    onAutoListPriceDialogClosed() {
      this.autoListPriceRow = null;
      this.autoListPriceForm = { listingPrice: null };
      this.autoListPriceSubmitting = false;
    },

    submitAutoListPriceFn() {
      if (!this.autoListPriceRow || this.autoListPriceSubmitting) return;
      const orderId = this.autoListPriceRow.sourceXwOrderId;
      if (!orderId) {
        this.$message.warning("缺少寄售子单");
        return;
      }
      const price = Number(this.autoListPriceForm && this.autoListPriceForm.listingPrice);
      if (!Number.isFinite(price) || price <= 0) {
        this.$message.warning("请输入有效预设售价");
        return;
      }
      this.autoListPriceSubmitting = true;
      this.$https(
        this.$api.api.consignmentGradeUpdateAutoListPrice,
        { orderId, price },
        "POST"
      )
        .then((res) => {
          if (res.data && res.data.code == 200) {
            this.$message.success((res.data && res.data.msg) || "改价成功");
            this.autoListPriceVisible = false;
            this.fetchList(this.currentPage);
          } else {
            this.$message.error((res.data && res.data.msg) || "改价失败");
          }
        })
        .finally(() => {
          this.autoListPriceSubmitting = false;
        });
    },

    openConsignPriceDialog(row) {
      if (!this.canConsignorChangePrice(row)) {
        this.$message.warning("当前状态不可改价");
        return;
      }
      const cur = resolveConsignorDisplayPrice(row);
      const listing = cur != null && cur !== "" ? Number(cur) : null;
      this.consignPriceRow = { ...row };
      this.consignPriceForm = {
        listingPrice: Number.isFinite(listing) ? listing : null,
      };
      this.consignPriceVisible = true;
    },

    onConsignPriceDialogClosed() {
      this.consignPriceRow = null;
      this.consignPriceForm = { listingPrice: null };
      this.consignPriceSubmitting = false;
    },

    submitConsignPriceFn() {
      if (!this.consignPriceRow || this.consignPriceSubmitting) return;
      const price = Number(this.consignPriceForm && this.consignPriceForm.listingPrice);
      if (!Number.isFinite(price) || price <= 0) {
        this.$message.warning("请输入有效货主售卖价");
        return;
      }
      const row = this.consignPriceRow;
      this.consignPriceSubmitting = true;
      this.$https(
        this.$api.api.updateConsignorSecondhandPrice,
        {
          id: row.id,
          consignorUserId: row.consignorUserId,
          price,
        },
        "POST"
      )
        .then((res) => {
          if (res.data && res.data.code == 200) {
            this.$message.success((res.data && res.data.msg) || "改价成功");
            this.consignPriceVisible = false;
            this.fetchList(this.currentPage);
          } else {
            this.$message.error((res.data && res.data.msg) || "改价失败");
          }
        })
        .finally(() => {
          this.consignPriceSubmitting = false;
        });
    },

    openConsignLinkDialog(row) {
      if (!row || !row.id) return;
      if (!row.consignorUserId) {
        this.$message.warning("该商品未绑定寄售用户，无法关联寄售单");
        return;
      }
      this.consignLinkProduct = { ...row };
      this.consignLinkSearch = {
        orderId: "",
        unlinkedOnly: 1,
      };
      this.consignLinkOrderList = [];
      this.consignLinkOrderPage = 1;
      this.consignLinkOrderTotal = 0;
      this.consignLinkSelectedOrder = null;
      this.consignLinkManualOrderNo = row.sourceConsignOrderNo ? String(row.sourceConsignOrderNo) : "";
      this.consignLinkVisible = true;
      this.$nextTick(() => this.searchConsignOrdersFn());
    },

    onConsignLinkDialogClosed() {
      this.consignLinkProduct = null;
      this.consignLinkOrderList = [];
      this.consignLinkSelectedOrder = null;
      this.consignLinkManualOrderNo = "";
      this.consignLinkSubmitting = false;
    },

    onConsignLinkOrderSelect(row) {
      this.consignLinkSelectedOrder = row || null;
      if (row && row.orderId) {
        this.consignLinkManualOrderNo = String(row.orderId);
      }
    },

    searchConsignOrdersFn(page) {
      if (page) this.consignLinkOrderPage = page;
      const product = this.consignLinkProduct;
      if (!product || !product.consignorUserId) {
        this.consignLinkOrderList = [];
        this.consignLinkOrderTotal = 0;
        return;
      }
      const s = this.consignLinkSearch;
      const body = {
        page: this.consignLinkOrderPage,
        size: this.consignLinkOrderSize,
        unlinkedOnly: s.unlinkedOnly,
        userId: product.consignorUserId,
        productId: product.id,
      };
      const orderId = String(s.orderId || "").trim();
      if (orderId) body.orderId = orderId;

      this.consignLinkOrderLoading = true;
      this.$https(this.$api.api.searchConsignOrdersForLink, body, "POST")
        .then((res) => {
          if (res.data && res.data.code == 200) {
            this.consignLinkOrderList = res.data.data || [];
            this.consignLinkOrderTotal = res.data.size || 0;
          } else {
            this.consignLinkOrderList = [];
            this.consignLinkOrderTotal = 0;
            this.$message.error((res.data && res.data.msg) || "搜索寄售单失败");
          }
        })
        .catch(() => {
          this.consignLinkOrderList = [];
          this.consignLinkOrderTotal = 0;
          this.$message.error("搜索寄售单失败");
        })
        .finally(() => {
          this.consignLinkOrderLoading = false;
        });
    },

    submitConsignLinkFn(force) {
      const product = this.consignLinkProduct;
      if (!product || !product.id) return;
      const body = { productId: product.id };
      if (this.consignLinkSelectedOrder && this.consignLinkSelectedOrder.id) {
        body.xwOrderId = this.consignLinkSelectedOrder.id;
      } else {
        const orderNo = String(this.consignLinkManualOrderNo || "").trim();
        if (!orderNo) {
          this.$message.warning("请从列表选择寄售单，或手动输入寄售订单号");
          return;
        }
        body.orderNo = orderNo;
      }
      if (force === true) body.force = true;
      this.consignLinkSubmitting = true;

      this.$https(this.$api.api.linkConsignOrder, body, "POST")
        .then((res) => {
          if (res.data && res.data.code == 200) {
            this.$message.success((res.data && res.data.msg) || "关联成功");
            this.consignLinkVisible = false;
            this.fetchList(this.currentPage);
          } else {
            const msg = (res.data && res.data.msg) || "关联失败";
            if (!force && this.shouldOfferForceConsignLink(msg)) {
              this.$confirm(msg + "，是否强制覆盖关联？", "确认强制关联", {
                type: "warning",
                confirmButtonText: "强制关联",
                cancelButtonText: "取消",
              })
                .then(() => this.submitConsignLinkFn(true))
                .catch(() => {});
            } else {
              this.$message.error(msg);
            }
          }
        })
        .catch((err) => {
          this.$message.error("关联失败：" + (err.message || "网络错误"));
        })
        .finally(() => {
          this.consignLinkSubmitting = false;
        });
    },

    shouldOfferForceConsignLink(msg) {
      const s = String(msg || "");
      return s.includes("不一致") || s.includes("已关联");
    },

    onConsignLinkImportSuccess() {
      this.fetchList(this.currentPage);
    },

    onGoofishAuctionImportSuccess() {
      this.fetchList(this.currentPage);
    },

    openOfficialPublishDialog() {
      this.officialPublishLoading = true;
      this.$https(this.$api.api.selOfficialUserMgmtList, {}, "GET")
        .then((res) => {
          if (res.data && res.data.code == 200) {
            const list = Array.isArray(res.data.data) ? res.data.data : [];
            this.officialAccountList = list;
            if (!list.length) {
              this.$message.error("未配置官方寄售帐号，请先在「用户管理 → 官方帐号列表」中添加");
              return;
            }
            this.resetOfficialPublishForm();
            this.officialPublishForm.officialSellerUserId = list[0].officialUserId;
            this.officialPublishVisible = true;
          } else {
            this.$message.error((res.data && res.data.msg) || "加载官方帐号失败");
          }
        })
        .catch(() => {
          this.$message.error("加载官方帐号失败");
        })
        .finally(() => {
          this.officialPublishLoading = false;
        });
    },

    displayOfficialAccountNick(acc) {
      if (!acc) return "—";
      const n = acc.nickName != null && String(acc.nickName).trim() !== "" ? String(acc.nickName).trim() : "";
      return n || "（未设置昵称）";
    },

    officialAccountOptionLabel(acc) {
      if (!acc) return "";
      const nick = this.displayOfficialAccountNick(acc);
      const rm =
        acc.remark != null && String(acc.remark).trim() !== "" ? ` · ${String(acc.remark).trim()}` : "";
      return `${nick}（ID ${acc.officialUserId}）${rm}`;
    },

    resetOfficialPublishForm() {
      this.consignorSearchOptions = [];
      this.officialPublishBrandOptions = [];
      this.officialPublishTypeOptions = [];
      this.officialPublishSelectedBrand = null;
      this.officialPublishSelectedType = null;
      this.officialPublishForm = {
        officialSellerUserId: null,
        consignorUserId: null,
        title: "",
        description: "",
        price: null,
        originalPrice: null,
        quantity: 1,
        conditionLevel: null,
        brandId: null,
        typeId: null,
        brandName: "",
        typeName: "",
        regionCodes: [],
        expressFreightMode: "free",
        deliveryType: 1,
        freight: 0,
        purchaseChannel: null,
        shelfLife: null,
        specType: null,
        gender: null,
        allowBargain: 1,
        minBargainPrice: 0,
        depositRate: 0.05,
        depositAmount: null,
        allowInspection: 0,
        inspectionFee: null,
      };
      this.officialPublishImageUrls = [];
    },

    onOfficialPublishAllowBargainChange(val) {
      if (!this.officialPublishForm) return;
      if (val !== 1) {
        this.officialPublishForm.minBargainPrice = null;
      } else if (
        this.officialPublishForm.minBargainPrice == null ||
        this.officialPublishForm.minBargainPrice === ""
      ) {
        this.officialPublishForm.minBargainPrice = 0;
      }
      this.$nextTick(() => {
        if (this.$refs.officialPublishFormRef) {
          this.$refs.officialPublishFormRef.clearValidate(["minBargainPrice"]);
        }
      });
    },

    consignorUserOptionLabel(u) {
      if (!u) return "";
      const nick = u.nickName != null && String(u.nickName).trim() !== "" ? String(u.nickName).trim() : "";
      return nick ? `${nick}（ID ${u.id}）` : `用户 ID ${u.id}`;
    },

    officialPublishBrandOptionLabel(b) {
      if (!b) return "";
      const n = b.name != null ? String(b.name).trim() : "";
      return n || `ID ${b.id}`;
    },

    officialPublishTypeOptionLabel(t) {
      if (!t) return "";
      const n = t.name != null ? String(t.name).trim() : "";
      const en =
        t.englishName != null && String(t.englishName).trim() !== ""
          ? ` / ${String(t.englishName).trim()}`
          : "";
      return (n || `ID ${t.id}`) + en;
    },

    remoteSearchOfficialPublishBrand(query) {
      if (this.officialPublishBrandSearchTimer) {
        clearTimeout(this.officialPublishBrandSearchTimer);
        this.officialPublishBrandSearchTimer = null;
      }
      const q = String(query || "").trim();
      this.officialPublishBrandSearchTimer = setTimeout(() => {
        this.officialPublishBrandSearchLoading = true;
        const payload = { page: 1, size: 30 };
        if (q) payload.name = q;
        this.$https(this.$api.api.selBrand, payload, "POST")
          .then((res) => {
            let arr = [];
            if (res.data && res.data.code == 200) {
              arr = res.data.data || [];
            }
            if (
              this.officialPublishForm &&
              this.officialPublishForm.brandId != null &&
              this.officialPublishSelectedBrand &&
              this.officialPublishSelectedBrand.id === this.officialPublishForm.brandId &&
              !arr.some((x) => x.id === this.officialPublishSelectedBrand.id)
            ) {
              arr = [this.officialPublishSelectedBrand, ...arr];
            }
            this.officialPublishBrandOptions = arr;
          })
          .catch(() => {
            this.officialPublishBrandOptions = [];
          })
          .finally(() => {
            this.officialPublishBrandSearchLoading = false;
          });
      }, 280);
    },

    onOfficialPublishBrandChange(val) {
      if (!this.officialPublishForm) return;
      if (val == null || val === "") {
        this.officialPublishForm.brandName = "";
        this.officialPublishForm.typeId = null;
        this.officialPublishForm.typeName = "";
        this.officialPublishTypeOptions = [];
        this.officialPublishSelectedBrand = null;
        this.officialPublishSelectedType = null;
        return;
      }
      const row = this.officialPublishBrandOptions.find((b) => b.id === val);
      if (row) {
        this.officialPublishSelectedBrand = { ...row };
        this.officialPublishForm.brandName = row.name != null ? String(row.name).trim() : "";
      }
      this.officialPublishForm.typeId = null;
      this.officialPublishForm.typeName = "";
      this.officialPublishTypeOptions = [];
      this.officialPublishSelectedType = null;
    },

    remoteSearchOfficialPublishType(query) {
      const bid = this.officialPublishForm && this.officialPublishForm.brandId;
      if (bid == null || bid === "") {
        this.officialPublishTypeOptions = [];
        return;
      }
      if (this.officialPublishTypeSearchTimer) {
        clearTimeout(this.officialPublishTypeSearchTimer);
        this.officialPublishTypeSearchTimer = null;
      }
      const q = String(query || "").trim();
      this.officialPublishTypeSearchTimer = setTimeout(() => {
        this.officialPublishTypeSearchLoading = true;
        const payload = { brandId: bid, page: 1, size: 50 };
        if (q) payload.name = q;
        this.$https(this.$api.api.selModel, payload, "POST")
          .then((res) => {
            let arr = [];
            if (res.data && res.data.code == 200) {
              arr = res.data.data || [];
            }
            if (
              this.officialPublishForm &&
              this.officialPublishForm.typeId != null &&
              this.officialPublishSelectedType &&
              this.officialPublishSelectedType.id === this.officialPublishForm.typeId &&
              !arr.some((x) => x.id === this.officialPublishSelectedType.id)
            ) {
              arr = [this.officialPublishSelectedType, ...arr];
            }
            this.officialPublishTypeOptions = arr;
          })
          .catch(() => {
            this.officialPublishTypeOptions = [];
          })
          .finally(() => {
            this.officialPublishTypeSearchLoading = false;
          });
      }, 280);
    },

    onOfficialPublishTypeChange(val) {
      if (!this.officialPublishForm) return;
      if (val == null || val === "") {
        this.officialPublishForm.typeName = "";
        this.officialPublishSelectedType = null;
        return;
      }
      const row = this.officialPublishTypeOptions.find((t) => t.id === val);
      if (row) {
        this.officialPublishSelectedType = { ...row };
        this.officialPublishForm.typeName = row.name != null ? String(row.name).trim() : "";
      }
    },

    remoteSearchConsignorUser(query) {
      if (this.consignorSearchTimer) {
        clearTimeout(this.consignorSearchTimer);
        this.consignorSearchTimer = null;
      }
      const q = String(query || "").trim();
      if (!q) {
        this.consignorSearchOptions = [];
        return;
      }
      this.consignorSearchTimer = setTimeout(() => {
        this.consignorSearchLoading = true;
        this.$https(this.$api.api.selUser, { nickName: q, page: 1, size: 30 }, "POST")
          .then((res) => {
            if (res.data && res.data.code == 200) {
              this.consignorSearchOptions = res.data.data || [];
            } else {
              this.consignorSearchOptions = [];
            }
          })
          .catch(() => {
            this.consignorSearchOptions = [];
          })
          .finally(() => {
            this.consignorSearchLoading = false;
          });
      }, 280);
    },

    onOfficialPublishDialogClosed() {
      this.officialPublishForm = null;
      this.officialAccountList = [];
      this.officialPublishImageUrls = [];
      this.consignorSearchOptions = [];
      this.officialPublishBrandOptions = [];
      this.officialPublishTypeOptions = [];
      this.officialPublishSelectedBrand = null;
      this.officialPublishSelectedType = null;
      if (this.consignorSearchTimer) {
        clearTimeout(this.consignorSearchTimer);
        this.consignorSearchTimer = null;
      }
      if (this.officialPublishBrandSearchTimer) {
        clearTimeout(this.officialPublishBrandSearchTimer);
        this.officialPublishBrandSearchTimer = null;
      }
      if (this.officialPublishTypeSearchTimer) {
        clearTimeout(this.officialPublishTypeSearchTimer);
        this.officialPublishTypeSearchTimer = null;
      }
      this.$nextTick(() => {
        if (this.$refs.officialPublishFormRef) {
          this.$refs.officialPublishFormRef.clearValidate();
        }
      });
    },

    parseOptionalPositiveInt(str) {
      if (str == null || String(str).trim() === "") return null;
      const n = parseInt(String(str).trim(), 10);
      return Number.isNaN(n) || n < 1 ? null : n;
    },

    /** 省市区 code 数组 → 连续中文，写入 SecondhandProduct.location */
    formatLocationFromCodes(codes) {
      if (!codes || !codes.length) return "";
      const parts = codes.map((c) => CodeToText[c]).filter(Boolean);
      return parts.join("");
    },

    resolveFreightForPayload(f) {
      const deliveryType = f.deliveryType != null ? Number(f.deliveryType) : 1;
      if (deliveryType === 2) return 0;
      if (deliveryType === 1) {
        if (f.expressFreightMode === "free") return 0;
        let freight = f.freight != null && f.freight !== "" ? Number(f.freight) : 0;
        if (Number.isNaN(freight) || freight < 0) freight = 0;
        return freight;
      }
      const fb = f.freight != null && f.freight !== "" ? Number(f.freight) : 0;
      return Number.isNaN(fb) ? 0 : fb;
    },

    onOfficialPublishDeliveryTypeChange(val) {
      const t = Number(val);
      if (!this.officialPublishForm) return;
      if (t === 2) {
        this.officialPublishForm.freight = 0;
      }
      if (t === 1) {
        this.officialPublishForm.expressFreightMode = "free";
        this.officialPublishForm.freight = 0;
      }
    },

    onOfficialPublishExpressFreightModeChange(val) {
      if (!this.officialPublishForm) return;
      if (val === "free") {
        this.officialPublishForm.freight = 0;
      } else if (val === "custom") {
        const cur = Number(this.officialPublishForm.freight);
        if (this.officialPublishForm.freight == null || this.officialPublishForm.freight === "" || cur <= 0) {
          this.officialPublishForm.freight = 0.01;
        }
      }
    },

    onEditDeliveryTypeChange(val) {
      const t = Number(val);
      if (!this.editForm) return;
      if (t === 2) {
        this.editForm.freight = 0;
      }
      if (t === 1) {
        this.editForm.expressFreightMode = "free";
        this.editForm.freight = 0;
      }
    },

    onEditExpressFreightModeChange(val) {
      if (!this.editForm) return;
      if (val === "free") {
        this.editForm.freight = 0;
      } else if (val === "custom") {
        const cur = Number(this.editForm.freight);
        if (this.editForm.freight == null || this.editForm.freight === "" || cur <= 0) {
          this.editForm.freight = 0.01;
        }
      }
    },

    onEditRegionChange(val) {
      if (!this.editForm) return;
      if (val && val.length) {
        this.editForm.location = this.formatLocationFromCodes(val);
      }
    },

    buildOfficialPublishAttrJson() {
      const f = this.officialPublishForm;
      if (!f) return "{}";
      const brandId = this.parseOptionalPositiveInt(f.brandId != null ? String(f.brandId) : "");
      const typeId = this.parseOptionalPositiveInt(f.typeId != null ? String(f.typeId) : "");
      const base = {
        v: 1,
        conditionLevel: f.conditionLevel != null ? f.conditionLevel : 1,
        categoryId: null,
        brandId,
        typeId,
        moreExpanded: 1,
        attrCardRevealedOnce: 1,
        attrExtra: {
          purchaseChannel: f.purchaseChannel != null && f.purchaseChannel !== "" ? f.purchaseChannel : null,
          shelfLife: f.shelfLife != null && f.shelfLife !== "" ? f.shelfLife : null,
          specType: f.specType != null && f.specType !== "" ? f.specType : null,
          gender: f.gender != null && f.gender !== "" ? f.gender : null,
        },
      };
      const bn = f.brandName != null ? String(f.brandName).trim() : "";
      const tn = f.typeName != null ? String(f.typeName).trim() : "";
      if (bn) base.brandName = bn;
      if (tn) base.typeName = tn;
      try {
        return JSON.stringify(base);
      } catch (e) {
        return "{}";
      }
    },

    buildOfficialPublishPayload() {
      const f = this.officialPublishForm;
      const brandId = this.parseOptionalPositiveInt(f.brandId != null ? String(f.brandId) : "");
      const typeId = this.parseOptionalPositiveInt(f.typeId != null ? String(f.typeId) : "");
      const deliveryType = f.deliveryType != null ? Number(f.deliveryType) : 1;
      const freight = this.resolveFreightForPayload(f);
      const location = this.formatLocationFromCodes(f.regionCodes) || "";
      const qty = f.quantity != null ? Math.max(1, parseInt(String(f.quantity), 10) || 1) : 1;
      const allowBargain = f.allowBargain === 1 ? 1 : 0;
      const allowInspection = 0;
      return {
        sellerUserId: f.officialSellerUserId,
        consignorUserId: f.consignorUserId,
        productType: 1,
        title: f.title,
        description: f.description || "",
        price: f.price,
        consignListingPrice: f.price,
        originalPrice: f.originalPrice != null && f.originalPrice !== "" ? f.originalPrice : null,
        images: JSON.stringify(this.officialPublishImageUrls || []),
        categoryId: null,
        brandId,
        typeId,
        conditionLevel: f.conditionLevel != null ? f.conditionLevel : 1,
        deliveryType,
        freight,
        quantity: qty,
        location,
        allowBargain,
        minBargainPrice: allowBargain === 1 && f.minBargainPrice != null && f.minBargainPrice !== "" ? f.minBargainPrice : null,
        depositRate: allowBargain === 1 ? (f.depositRate != null ? f.depositRate : 0.05) : null,
        depositAmount:
          allowBargain === 1 && f.depositAmount != null && f.depositAmount !== "" ? f.depositAmount : null,
        allowInspection,
        inspectionFee:
          allowInspection === 1 && f.inspectionFee != null && f.inspectionFee !== "" ? f.inspectionFee : null,
        attrJson: this.buildOfficialPublishAttrJson(),
      };
    },

    async uploadOfficialPublishImageRequest(option) {
      if (this.officialPublishImageUrls.length >= 9) {
        this.$message.warning("最多 9 张图片");
        return;
      }
      const no = `${Date.now()}_${Math.round(Math.random() * 1000)}`;
      this.officialPublishImageUploading = true;
      try {
        const result = await uploadImageWithCompressFallback(this.$https, option.file, {
          api: this.$api.api,
          no,
        });
        if (result.ok && result.path) {
          const url = this.normalizeUploadedImageUrl(String(result.path).trim());
          if (url) {
            this.officialPublishImageUrls.push(url);
            if (typeof option.onSuccess === "function") {
              option.onSuccess(result.body || { code: 0, data: result.data }, option.file);
            }
          } else {
            this.$message.error("未返回图片地址");
            if (typeof option.onError === "function") option.onError(new Error("empty url"));
          }
        } else {
          this.$message.error((result && result.msg) || "上传失败");
          if (typeof option.onError === "function") option.onError(new Error("fail"));
        }
      } catch (e) {
        this.$message.error("上传失败");
        if (typeof option.onError === "function") option.onError(new Error("network"));
      } finally {
        this.officialPublishImageUploading = false;
      }
    },

    removeOfficialPublishImage(index) {
      if (index < 0 || index >= this.officialPublishImageUrls.length) return;
      this.officialPublishImageUrls.splice(index, 1);
    },

    submitOfficialPublishFn() {
      if (!this.$refs.officialPublishFormRef || !this.officialPublishForm) return;
      this.$refs.officialPublishFormRef.validate((valid) => {
        if (!valid) return;
        if (!this.officialPublishImageUrls.length) {
          this.$message.warning("请至少上传一张商品图");
          return;
        }
        const f = this.officialPublishForm;
        if (f.allowBargain === 1) {
          const minP =
            f.minBargainPrice == null || f.minBargainPrice === "" ? 0 : Number(f.minBargainPrice);
          if (Number.isNaN(minP) || minP < 0) {
            this.$message.warning("还价最低金额无效");
            return;
          }
          const sale = Number(f.price);
          if (minP > 0 && !Number.isNaN(sale) && minP >= sale) {
            this.$message.warning("还价最低金额须低于售价");
            return;
          }
        }
        if (Number(f.deliveryType) === 1 && f.expressFreightMode === "custom") {
          const fr = Number(f.freight);
          if (f.freight == null || f.freight === "" || Number.isNaN(fr) || fr <= 0) {
            this.$message.warning("选择自定义邮费时请填写大于 0 的邮费");
            return;
          }
        }
        this.officialPublishSubmitting = true;
        const payload = this.buildOfficialPublishPayload();
        this.$https(this.$api.api.addSecondhandProduct, payload, "POST")
          .then((res) => {
            if (!res.data || res.data.code != 200) {
              this.$message.error((res.data && res.data.msg) || "发布失败");
              return;
            }
            const created = res.data.data;
            const id = created && created.id;
            if (!id) {
              this.$message.success("发布成功");
              this.officialPublishVisible = false;
              this.fetchList(1);
              return;
            }
            return this.$https(this.$api.api.getSecondhandProductById, { id }, "GET").then((r2) => {
              if (!r2.data || r2.data.code != 200 || !r2.data.data) {
                this.$message.warning("商品已创建，请在列表中手动上架");
                this.officialPublishVisible = false;
                this.fetchList(1);
                return;
              }
              const full = r2.data.data;
              full.status = 1;
              return this.$https(this.$api.api.updateSecondhandProduct, full, "POST").then((r3) => {
                if (r3.data && r3.data.code == 200) {
                  this.$message.success("发布成功，已上架");
                } else {
                  this.$message.warning((r3.data && r3.data.msg) || "上架失败，请在列表中编辑上架");
                }
                this.officialPublishVisible = false;
                this.fetchList(1);
              });
            });
          })
          .finally(() => {
            this.officialPublishSubmitting = false;
          });
      });
    },

    submitEditFn() {
      if (!this.$refs.editFormRef || !this.editForm || !this.editRaw) return;
      this.$refs.editFormRef.validate((valid) => {
        if (!valid) return;
        this.editSubmitLoading = true;
        const payload = { ...this.editRaw };
        payload.title = this.editForm.title;
        payload.description = this.editForm.description;
        // 拍卖中锁定状态，避免误改；结束拍卖请用列表「上架」
        payload.status = this.isEditStatusLockedByAuction ? 8 : this.editForm.status;
        if (Number(payload.status) === 9) {
          const recallNo =
            this.editForm.recallExpressNo != null ? String(this.editForm.recallExpressNo).trim() : "";
          if (!recallNo) {
            this.$message.warning("召回状态请填写召回单号");
            this.editSubmitLoading = false;
            return;
          }
          payload.recallExpressNo = recallNo;
        } else {
          payload.recallExpressNo = null;
        }
        if (this.isEditingOfficialConsignProduct) {
          const listing = Number(this.editForm.listingPrice);
          if (!Number.isFinite(listing) || listing <= 0) {
            this.$message.warning("请输入有效挂牌价");
            this.editSubmitLoading = false;
            return;
          }
          const rate = resolveConsignPromoDiscountRate(this.editRaw);
          if (shouldApplyConsignPromoOnEdit(this.editRaw)) {
            payload.consignListingPrice = listing;
            payload.price = applyBuyerPriceFromListing(listing, rate);
          } else {
            payload.price = listing;
            payload.consignListingPrice = null;
          }
          payload.importCode =
            this.editForm.importCode != null && String(this.editForm.importCode).trim()
              ? String(this.editForm.importCode).trim()
              : null;
          payload.xianyuItemId =
            this.editForm.xianyuItemId != null && String(this.editForm.xianyuItemId).trim()
              ? String(this.editForm.xianyuItemId).trim()
              : null;
        } else {
          payload.price = this.editForm.price;
        }
        if (!this.isOfficialConsignList) {
          payload.originalPrice = this.editForm.originalPrice;
        }
        payload.quantity = this.editForm.quantity;
        payload.conditionLevel = this.editForm.conditionLevel;
        payload.deliveryType = this.editForm.deliveryType;
        payload.freight = this.resolveFreightForPayload(this.editForm);
        if (Number(this.editForm.deliveryType) === 1 && this.editForm.expressFreightMode === "custom") {
          const fr = Number(this.editForm.freight);
          if (
            this.editForm.freight == null ||
            this.editForm.freight === "" ||
            Number.isNaN(fr) ||
            fr <= 0
          ) {
            this.$message.warning("选择自定义邮费时请填写大于 0 的邮费");
            this.editSubmitLoading = false;
            return;
          }
        }
        const locFromCascader = this.formatLocationFromCodes(this.editForm.regionCodes);
        payload.location =
          (locFromCascader && locFromCascader.trim()) ||
          (this.editForm.location && String(this.editForm.location).trim()) ||
          "";
        payload.allowBargain = this.editForm.allowBargain;
        if (this.editForm.allowBargain === 1) {
          payload.minBargainPrice = this.editForm.minBargainPrice;
        } else {
          payload.minBargainPrice = null;
        }
        payload.depositRate = this.editForm.depositRate;
        payload.depositAmount =
          this.editForm.depositAmount != null && this.editForm.depositAmount !== "" ? this.editForm.depositAmount : null;
        if (!this.isOfficialConsignList) {
          payload.allowInspection = this.editForm.allowInspection;
          if (this.editForm.allowInspection === 1) {
            payload.inspectionFee =
              this.editForm.inspectionFee != null && this.editForm.inspectionFee !== ""
                ? this.editForm.inspectionFee
                : null;
          } else {
            payload.inspectionFee = null;
          }
        }
        payload.images = JSON.stringify(this.editImageUrls || []);
        payload.attrJson = this.buildAttrJsonForSave(this.editForm, this.editRaw);
        this.$https(this.$api.api.updateSecondhandProduct, payload, "POST")
          .then((res) => {
            if (res.data && res.data.code == 200) {
              this.$message.success((res.data && res.data.msg) || "保存成功");
              this.editVisible = false;
              this.fetchList(this.currentPage);
            } else {
              this.$message.error((res.data && res.data.msg) || "保存失败");
            }
          })
          .finally(() => {
            this.editSubmitLoading = false;
          });
      });
    },
  },
};
</script>

<style lang="less" scoped>
#box {
  width: 100%;
  display: flex;
  flex-direction: column;
  /* 仅扣除顶栏；用负 margin 抵消 Home .main_box 底部 padding，让表格吃满剩余视口 */
  height: calc(100vh - 60px);
  max-height: calc(100vh - 60px);
  min-height: 480px;
  margin-bottom: -48px;
  box-sizing: border-box;
  overflow: hidden;

  .secondhand-list-head {
    flex-shrink: 0;
  }

  .secondhand-list-table-wrap {
    flex: 1 1 auto;
    min-height: 0;
    min-width: 0;
    overflow: hidden;
    margin-top: 8px;
  }
  .secondhand-list-table-wrap ::v-deep .el-table__body-wrapper {
    overflow-y: scroll !important;
    scrollbar-width: thin;
    scrollbar-color: #909399 #ebeef5;
  }
  .secondhand-list-table-wrap ::v-deep .el-table__body-wrapper::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 10px;
    height: 10px;
  }
  .secondhand-list-table-wrap ::v-deep .el-table__body-wrapper::-webkit-scrollbar-thumb {
    background-color: #909399;
    border-radius: 8px;
    border: 2px solid #ebeef5;
  }
  .secondhand-list-table-wrap ::v-deep .el-table__body-wrapper::-webkit-scrollbar-track {
    background: #ebeef5;
    border-radius: 8px;
  }
  .secondhand-list-table-wrap--compact ::v-deep .el-table td,
  .secondhand-list-table-wrap--compact ::v-deep .el-table th {
    padding: 6px 0;
  }
  .list-row-thumb {
    width: 60px;
    height: 60px;
    object-fit: cover;
    cursor: pointer;
    display: block;
    margin: 0 auto;
  }
  .list-row-thumb--compact {
    width: 48px;
    height: 48px;
  }

  .official-publish-tip {
    font-size: 13px;
    color: #606266;
    margin: 0 0 12px;
    line-height: 1.5;
  }
  .official-publish-field-hint {
    font-size: 12px;
    color: #909399;
    line-height: 1.4;
    margin-top: 6px;
  }
  .official-publish-consignor-item ::v-deep .el-select,
  .official-publish-official-item ::v-deep .el-select {
    width: 100%;
  }
  .official-publish-wrap {
    margin-top: -4px;
  }
  .official-publish-body {
    max-height: min(520px, calc(90vh - 200px));
    overflow-y: auto;
    padding-right: 4px;
  }
  .official-publish-field-hint.inline-hint {
    display: inline-block;
    margin-top: 0;
    margin-left: 8px;
    vertical-align: middle;
  }
  /* 商品图片：网格缩略图 + 虚线添加格 */
  .sh-img-upload {
    width: 100%;
  }
  .sh-img-upload__grid {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    align-items: flex-start;
  }
  .sh-img-upload__thumb {
    position: relative;
    width: 96px;
    height: 96px;
    border-radius: 8px;
    overflow: hidden;
    flex-shrink: 0;
    background: #f5f7fa;
    border: 1px solid #e4e7ed;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
    transition: box-shadow 0.2s ease, border-color 0.2s ease;
    &:hover {
      border-color: #c0c4cc;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    }
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      cursor: pointer;
      display: block;
    }
  }
  .sh-img-upload__cover {
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    font-size: 11px;
    line-height: 20px;
    text-align: center;
    color: #fff;
    background: linear-gradient(transparent, rgba(0, 0, 0, 0.55));
    letter-spacing: 0.5px;
  }
  .sh-img-upload__remove {
    position: absolute;
    top: 4px;
    right: 4px;
    width: 22px;
    height: 22px;
    line-height: 22px;
    text-align: center;
    background: rgba(0, 0, 0, 0.45);
    color: #fff;
    border-radius: 50%;
    cursor: pointer;
    font-size: 12px;
    transition: background 0.15s ease, transform 0.15s ease;
    &:hover {
      background: rgba(245, 108, 108, 0.95);
      transform: scale(1.05);
    }
  }
  .sh-img-upload__trigger {
    display: block;
    width: 96px;
    height: 96px;
    flex-shrink: 0;
    ::v-deep .el-upload {
      width: 100%;
      height: 100%;
      border: none;
      background: transparent;
      border-radius: 8px;
    }
  }
  .sh-img-upload__add {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
    padding: 8px;
    border: 1px dashed #c0c4cc;
    border-radius: 8px;
    background: #fafafa;
    color: #909399;
    font-size: 12px;
    line-height: 1.3;
    text-align: center;
    cursor: pointer;
    transition: border-color 0.2s ease, background 0.2s ease, color 0.2s ease;
    &:hover:not(.is-loading) {
      border-color: #409eff;
      background: #f0f9ff;
      color: #409eff;
    }
    &.is-loading {
      cursor: wait;
      opacity: 0.85;
    }
  }
  .sh-img-upload__add-icon {
    font-size: 22px;
    line-height: 1;
  }
  .sh-img-upload__add-text {
    max-width: 72px;
  }
  .sh-img-upload__hint {
    margin: 10px 0 0;
    font-size: 12px;
    color: #909399;
    line-height: 1.5;
  }
  .sh-img-upload__hint-em {
    color: #606266;
    font-weight: 500;
  }
  .secondhand-main-tabs {
    margin-top: 8px;
    ::v-deep .el-tabs__content {
      display: none;
    }
    ::v-deep .el-tabs__header {
      margin-bottom: 0;
    }
  }
  .audit-dialog-body {
    font-size: 14px;
    color: #303133;
    line-height: 1.6;
    max-height: min(420px, calc(100vh - 280px));
    overflow-x: hidden;
    overflow-y: auto;
    padding-right: 4px;
  }
  .audit-dialog-line {
    margin: 0 0 8px;
    word-break: break-all;
  }
  .audit-dialog-block {
    margin-top: 12px;
  }
  .audit-dialog-block__label {
    margin-bottom: 6px;
    font-size: 13px;
    font-weight: 600;
    color: #606266;
  }
  .audit-dialog-images {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    img {
      width: 88px;
      height: 88px;
      object-fit: cover;
      border-radius: 4px;
      border: 1px solid #ebeef5;
      cursor: pointer;
      display: block;
    }
  }
  .detail-dialog-images {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    img {
      width: 88px;
      height: 88px;
      object-fit: cover;
      border-radius: 4px;
      border: 1px solid #ebeef5;
      cursor: pointer;
      display: block;
    }
  }
  .detail-dialog-images-empty {
    color: #909399;
    font-size: 13px;
  }
  .audit-dialog-empty {
    color: #909399;
    font-size: 13px;
  }
  .audit-dialog-desc {
    margin: 0;
    padding: 8px 10px;
    background: #f5f7fa;
    border-radius: 4px;
    font-size: 13px;
    color: #303133;
    white-space: pre-wrap;
    word-break: break-word;
    line-height: 1.5;
    max-height: 120px;
    overflow-y: auto;
  }
  .audit-dialog-violation {
    margin: 0;
    padding: 8px 10px;
    background: #fdf6ec;
    border: 1px solid #faecd8;
    border-radius: 4px;
    font-size: 13px;
    color: #606266;
    white-space: pre-wrap;
    word-break: break-word;
    line-height: 1.5;
    max-height: 100px;
    overflow-y: auto;
  }
  .audit-dialog-remark {
    margin-top: 14px;
  }
  .audit-dialog-remark__label {
    margin-bottom: 8px;
    font-size: 13px;
    color: #606266;
  }
  .topBox {
    width: 100%;
    align-items: center;
    justify-content: space-between;
    margin-top: 10px;
  }
  .topLeft {
    align-items: center;
  }
  .search-toolbar {
    margin-top: 6px;
    padding: 8px 12px 8px;
    background: #f5f7fa;
    border-radius: 4px;
    border: 1px solid #ebeef5;
  }
  .search-toolbar__footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 8px 12px;
    margin-top: 2px;
    padding-top: 10px;
    border-top: 1px dashed #e4e7ed;
  }
  .search-toolbar__footer-left,
  .search-toolbar__footer-right {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
  }
  .search-toolbar__footer-right {
    margin-left: auto;
  }
  .search-toolbar__expand-btn {
    padding-left: 4px;
    padding-right: 4px;
  }
  .search-form {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
  }
  .search-form ::v-deep .el-form-item {
    margin-right: 10px;
    margin-bottom: 8px;
  }
  .search-form ::v-deep .el-form-item__label {
    padding-right: 6px;
    color: #606266;
  }
  .search-form__input--xs { width: 100px; }
  .search-form__input--sm { width: 132px; }
  .search-form__input--md { width: 148px; }
  .search-form__input--brand { width: 120px; }
  .search-form__input--grade { width: 88px; }
  .search-form__input--source { width: 108px; }
  .search-form__input--status { width: 118px; }
  .search-form__input--stage { width: 150px; }
  .search-form__input--range { width: 240px; }
  .search-form__range-sep {
    display: inline-block;
    margin: 0 4px;
    color: #909399;
  }
  .table-action-wrap {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    justify-content: center;
    padding: 2px 0;
  }
  .table-action-wrap ::v-deep .el-button {
    margin: 0 !important;
    padding: 5px 7px;
    font-size: 12px;
  }
  ::v-deep .table-action-col .cell {
    padding-left: 4px !important;
    padding-right: 4px !important;
    overflow: visible;
    white-space: normal;
  }
  .batch-publish-dialog {
    .batch-publish-tip {
      margin-bottom: 14px;
      color: #606266;
      line-height: 1.5;
    }
  }
  .consign-price-dialog {
    .consign-price-product {
      font-weight: 600;
      color: #303133;
      margin-bottom: 6px;
      line-height: 1.4;
    }
    .consign-price-meta {
      font-size: 12px;
      color: #909399;
      margin-bottom: 16px;
    }
    .consign-price-hint {
      margin-top: 6px;
      font-size: 12px;
      color: #909399;
      line-height: 1.5;
    }
  }
  .page_box {
    flex-shrink: 0;
    position: relative;
    z-index: 20;
    margin-top: 0;
    padding: 6px 0 8px;
    border-top: 1px solid #ebeef5;
    background: #fff;
    display: flex;
    justify-content: flex-end;
  }
  .detail-dialog-body {
    max-height: min(560px, calc(100vh - 200px));
    overflow-x: hidden;
    overflow-y: auto;
    padding-right: 4px;
    margin-right: -4px;
  }
  .detail-section {
    margin-bottom: 20px;
    &--last {
      margin-bottom: 0;
    }
  }
  .detail-section__head {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
    margin-bottom: 10px;
    .detail-section__title {
      margin-bottom: 0;
    }
  }
  .detail-section__title {
    margin: 0 0 10px;
    padding: 0 0 0 10px;
    font-size: 14px;
    font-weight: 600;
    color: #303133;
    line-height: 1.4;
    border-left: 3px solid #409eff;
  }
  .detail-field-box {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 1px;
    width: 100%;
    /* 仅网格间隙用灰线；空列无格子时透出白底，避免出现大块灰块 */
    background: #ebeef5;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    overflow: hidden;
    box-sizing: border-box;
    &--cols2 {
      grid-template-columns: repeat(2, 1fr);
    }
  }
  .detail-field-cell {
    display: flex;
    flex-direction: column;
    min-width: 0;
    background: #fff;
    &--full {
      grid-column: 1 / -1;
      width: 100%;
    }
    &--span2 {
      grid-column: span 2;
    }
  }
  .detail-field-label {
    flex-shrink: 0;
    padding: 8px 10px;
    background: #f5f7fa;
    color: #606266;
    font-size: 12px;
    line-height: 1.4;
    text-align: left;
    border-bottom: 1px solid #ebeef5;
    box-sizing: border-box;
  }
  .detail-field-value {
    flex: 1;
    min-width: 0;
    width: 100%;
    min-height: 36px;
    padding: 8px 10px;
    font-size: 13px;
    color: #303133;
    line-height: 1.5;
    word-break: break-all;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    &--multiline {
      display: block;
      align-items: stretch;
      white-space: pre-wrap;
      max-height: 160px;
      overflow-y: auto;
    }
    &--tooltip {
      display: block;
      min-width: 0;
      width: 100%;
      ::v-deep .el-tooltip {
        display: block;
        width: 100%;
      }
    }
  }
  .detail-field-ellipsis {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
    line-height: 1.5;
    cursor: default;
  }
  .consign-listing-strike {
    margin-left: 6px;
    color: #909399;
    text-decoration: line-through;
  }
  .detail-seller-row {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
  }
  .detail-seller-avatar {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    object-fit: cover;
    cursor: pointer;
    border: 1px solid #ebeef5;
    flex-shrink: 0;
  }
  .detail-seller-uid {
    color: #909399;
    font-size: 12px;
  }
  .desc-cell-ellipsis {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
    cursor: default;
  }
  .edit-status-row {
    width: 100%;
  }
  .edit-status-hint {
    margin-top: 6px;
    font-size: 12px;
    color: #909399;
    line-height: 1.4;
  }
  .edit-bargain-hint {
    margin-top: 6px;
    font-size: 12px;
    color: #909399;
    line-height: 1.4;
  }
}
</style>

<style lang="less">
/* tooltip 挂载在 body，需非 scoped */
.secondhand-desc-tooltip {
  max-width: 480px;
  word-break: break-word;
  line-height: 1.5;
}

.secondhand-detail-dialog .el-dialog__body {
  padding: 12px 20px 10px;
}
.secondhand-detail-dialog .el-dialog__footer {
  border-top: 1px solid #ebeef5;
  padding-top: 12px;
}

/* 编辑商品：固定宽度 + 主体区域固定高度内滚动 */
.secondhand-edit-dialog.el-dialog {
  width: 640px !important;
  max-height: 90vh;
  margin-top: 5vh !important;
  display: flex;
  flex-direction: column;
}
.secondhand-edit-dialog .el-dialog__header {
  flex-shrink: 0;
  padding-bottom: 12px;
}
.secondhand-edit-dialog .el-dialog__body {
  flex: 1 1 auto;
  min-height: 0;
  max-height: min(560px, calc(90vh - 168px));
  overflow-y: auto;
  overflow-x: hidden;
  box-sizing: border-box;
  padding: 8px 20px 4px;
}
.secondhand-edit-dialog .el-dialog__footer {
  flex-shrink: 0;
  border-top: 1px solid #ebeef5;
  padding-top: 12px;
}

.secondhand-audit-dialog .el-dialog__body {
  padding: 8px 20px 4px;
}
.secondhand-audit-dialog .el-dialog__footer {
  border-top: 1px solid #ebeef5;
  padding-top: 12px;
}

.secondhand-official-publish-dialog.el-dialog {
  width: 820px !important;
  max-height: 92vh;
  margin-top: 5vh !important;
  display: flex;
  flex-direction: column;
}
.secondhand-official-publish-dialog .el-dialog__header {
  flex-shrink: 0;
  padding-bottom: 8px;
}
.secondhand-official-publish-dialog .el-dialog__body {
  flex: 1 1 auto;
  min-height: 0;
  padding: 8px 20px 4px;
  overflow: hidden;
}
.secondhand-official-publish-dialog .el-dialog__footer {
  flex-shrink: 0;
  border-top: 1px solid #ebeef5;
  padding-top: 12px;
}

/* 发闲置：官方帐号下拉（挂载在 body） */
.official-publish-official-dropdown.el-select-dropdown {
  min-width: 380px !important;
}
.official-account-opt {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 2px 0;
  line-height: 1.35;
}
.official-account-opt__avatar-wrap {
  flex-shrink: 0;
}
.official-account-opt__avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
  display: block;
  border: 1px solid #ebeef5;
}
.official-account-opt__avatar--ph {
  background: #f5f7fa;
  color: #c0c4cc;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
}
.official-account-opt__meta {
  min-width: 0;
  flex: 1;
}
.official-account-opt__nick {
  font-size: 13px;
  color: #303133;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.official-account-opt__sub {
  font-size: 12px;
  color: #909399;
  margin-top: 2px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.consign-link-product-tip {
  padding: 10px 12px;
  background: #f4f4f5;
  border-radius: 4px;
  font-size: 13px;
  color: #606266;
  line-height: 1.5;
}
.consign-link-filter-tip {
  margin-top: 6px;
  font-size: 12px;
  color: #909399;
}

/* 同步至闲鱼弹窗 */
.goofish-sync-dialog .el-dialog__body {
  padding: 8px 20px 4px;
}
.goofish-sync-dialog .el-dialog__footer {
  border-top: 1px solid #ebeef5;
  padding-top: 12px;
}
.goofish-sync-dialog__body {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.goofish-sync-dialog__meta {
  padding: 12px 14px;
  background: #f7f8fa;
  border-radius: 6px;
  font-size: 13px;
  color: #606266;
  line-height: 1.55;
}
.goofish-sync-dialog__meta-title {
  font-size: 14px;
  font-weight: 500;
  color: #303133;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.goofish-sync-dialog__meta-sub {
  margin-top: 6px;
  font-size: 12px;
  color: #909399;
}
.goofish-sync-dialog__form .el-form-item {
  margin-bottom: 18px;
}
.goofish-sync-dialog__form .el-form-item:last-child {
  margin-bottom: 4px;
}
.goofish-sync-dialog__form .el-form-item__label {
  padding: 0 0 6px;
  line-height: 1.3;
  color: #606266;
}
.goofish-sync-dialog__modes {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
}
.goofish-sync-dialog__modes .el-radio {
  margin-right: 0;
  line-height: 1.4;
  white-space: normal;
}
.goofish-sync-dialog__shops {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 8px;
  width: 100%;
}
.goofish-sync-dialog__shop {
  display: flex !important;
  align-items: flex-start;
  margin-right: 0 !important;
  padding: 10px 12px;
  border: 1px solid #ebeef5;
  border-radius: 6px;
  line-height: 1.4;
  white-space: normal;
  height: auto !important;
}
.goofish-sync-dialog__shop.is-checked {
  border-color: #c6e2ff;
  background: #f5faff;
}
.goofish-sync-dialog__shop .el-checkbox__input {
  margin-top: 2px;
}
.goofish-sync-dialog__shop .el-checkbox__label {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  white-space: normal;
  line-height: 1.4;
  padding-left: 8px;
}
.goofish-sync-dialog__shop-name {
  font-size: 13px;
  color: #303133;
  font-weight: 500;
  word-break: break-all;
}
.goofish-sync-dialog__shop-user {
  font-size: 12px;
  color: #909399;
  word-break: break-all;
}
.goofish-sync-dialog__empty {
  font-size: 12px;
  color: #909399;
}

/* 官方寄售列表：多店闲鱼 id */
.xianyu-id-cell {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  line-height: 1.35;
}
.xianyu-id-row {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 4px;
  max-width: 100%;
}
.xianyu-id-shop {
  flex-shrink: 0;
  font-size: 11px;
  color: #909399;
  background: #f4f4f5;
  border-radius: 3px;
  padding: 0 4px;
  max-width: 88px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.xianyu-id-value {
  font-size: 12px;
  color: #303133;
  word-break: break-all;
}
</style>



// WEBPACK FOOTER //
// src/pages/secondhandProduct/index.vue